//@ts-nocheck
import React, { useEffect, useRef, useState } from "react";
import {
  Input,
  Button,
  DatePicker,
  Select,
  Table,
  ConfigProvider,
  Tag,
  Tabs,
  Space,
  message,
  Popconfirm,
  Dropdown,
  Modal,
  // Tooltip,
} from "antd";
import {
  DeleteOutlined,
  FilterOutlined,
  SettingOutlined,
  MailOutlined,
  GoogleOutlined,
  RightOutlined,
  QuestionOutlined,
  SearchOutlined,
  EditOutlined,
  UserOutlined,
  DownOutlined,
} from "@ant-design/icons";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { RiDeleteBinLine } from "react-icons/ri";
import { FaUser } from "react-icons/fa";
import dayjs from "dayjs";
import {
  createQuote,
  createQuoteWtb,
  createQuoteSequence,
  deleteQuoteSequence,
  getNextQuoteId,
  getQuoteNavigatorData,
  getQuoteByQuoteId,
  getQuoteWtb,
  getQuoteSequencesByQuoteId,
  getQuotes,
  getQuotesByModel,
  getQuotesResponses,
  getSources,
  getStatuses,
  createStatus,
  updateStatus,
  deleteStatus,
  createOutlookDraftFromTemplate,
  softDeleteQuote,
  updateQuote,
  updateQuoteSequence,
  updateQuotesResponse,
  updateQuoteWtb,
  getManufacturers,
  createManufacturer,
  updateManufacturer,
  deleteManufacturer,
  createOrderTracking,
  getVendors,
  getOtcReps,
  getOtcPmts,
  createOtcPmt,
  updateOtcPmt,
  deleteOtcPmt,
  getRepresentatives,
  bulkImportQuotes,
  bulkImportQuoteSeq,
  getInventories,
  getPendingExternalQuotes,
  approveExternalQuote,
  rejectExternalQuote,
  searchEbayItems,
  EbayItem,
} from "../../utils/API";
import { openOutlookDraft } from "../../utils/outlook";
import PageLogoutButton from "../../Components/PageLogoutButton";
import CommonHeader from "../../Components/commonHeader";
import { normalizeSortRules, sortRulesToQuery, type SortRule } from "../../utils/sortRules";
import {
  buildOrderTrackingCreatePayload,
  createBlankOpenOrderRecord,
  type OpenOrderData,
} from "../../utils/orderTrackingMapping";
import { DEALER_EMAIL_MODELS_STORAGE_KEY } from "../../utils/emailLinkAPI";
import { canSeeEmailLinkTabs } from "../../Components/NavigationDropDown";
import EmailThreadPanel from "../../Components/email-link/EmailThreadPanel";
// Sales View response tabs that are hidden for now so they stop taking up space.
// The tab definitions and everything backing them (wtbResponseColumns,
// quotesWtbData, the WTB fetch) are deliberately left in place — clear this set
// to bring a tab back. "4" = Dealer WTB, "5" = USEDLINE.
const HIDDEN_RESPONSE_TAB_KEYS = new Set(["4", "5"]);

// Sales View tabs that show linked mail for the quote on screen: "6" = Cust
// Email (everything sent about this quote, from anyone), "7" = Dealer Emails
// (everything about the models on it). Same allow-list as the header's
// Customer/Dealer Email buttons.
const EMAIL_RESPONSE_TAB_KEYS = new Set(["6", "7"]);

// quotes_fm (quote header) fields
const QUOTE_HEADER_EXPORT_COLUMNS = [
  { label: "Quote ID", key: "quoteId" },
  { label: "Created Date", key: "createdDate" },
  { label: "Company", key: "companyName" },
  { label: "Contact Name", key: "contactName" },
  { label: "Contact Email", key: "contactEmail" },
  { label: "Phone 1", key: "phone1" },
  { label: "Phone 2", key: "phone2" },
  { label: "Mobile", key: "mobile" },
  { label: "Quote Status", key: "quoteStatus" },
  { label: "Sub Status", key: "subStatus" },
  { label: "Quote Source", key: "quoteSource" },
  { label: "Assigned Email", key: "assignedEmail" },
  { label: "Quote Sent", key: "quoteSent" },
  { label: "Quote Sent Date", key: "quoteSentDate" },
  { label: "First Follow Up Date", key: "firstFollowUpDate" },
  { label: "Second Follow Up Date", key: "secondFollowUpDate" },
  { label: "Final Follow Up Date", key: "finalFollowUpDate" },
  { label: "Dollars", key: "dollars" },
  { label: "Country", key: "country" },
  { label: "Customer Comments", key: "customerComments" },
  { label: "Notes", key: "notes" },
  { label: "Sales Info", key: "salesInfo" },
  { label: "Options Requested", key: "optionsRequested" },
  { label: "Win", key: "win" },
  { label: "In Conversation", key: "inConversation" },
];

// quoteseq_fm (line items) fields
const LINE_ITEMS_EXPORT_COLUMNS = [
  { label: "Quote ID", key: "quoteId" },
  { label: "Manufacturer", key: "manufacturer" },
  { label: "Model", key: "model" },
  { label: "Options", key: "options" },
  { label: "QTY", key: "qty" },
  { label: "Price", key: "price" },
  { label: "Price String", key: "priceString" },
  { label: "Std Cal", key: "stdCal" },
  { label: "Status", key: "status" },
  { label: "Description", key: "description" },
  { label: "WTB Sent", key: "wtbSentCalculated" },
  { label: "Created Date", key: "createdDate" },
];

// Combined: both tables visible — deduplicate by key
const QUOTE_SORT_KEYS = QUOTE_HEADER_EXPORT_COLUMNS.map((column) => column.key);
const _headerKeys = new Set(QUOTE_HEADER_EXPORT_COLUMNS.map((c) => c.key));
const QUOTES_ADD_EXPORT_COLUMNS = [
  ...QUOTE_HEADER_EXPORT_COLUMNS,
  ...LINE_ITEMS_EXPORT_COLUMNS.filter((c) => !_headerKeys.has(c.key)),
];

// --- Types ---
interface LineItem {
  key: string;
  seqId?: number;
  manufacturer: string;
  model: string;
  options: string;
  qty: number;
  price: string;
  stdCal: string;
  status: string;
  description: string;
}

interface Manufacturer {
  id: number;
  name: string;
  createdAt: string;
  updatedAt: string;
}

interface GeneralTabProps {
  setIsInConversation: (v: boolean) => void;
  isInConversation: boolean;
  settingPlus: string;
  onAddRow: () => void;
  onSendFQ: () => void;
  onFirstFollowUp: () => void;
  onSecondFollowUp: () => void;
  onFinalFollowUp: () => void;
  onLooking: () => void;
  onOutOfStock: () => void;
  statusOptions: StatusOption[];
  sourceOptions: Array<{ value: string; label: string }>;
  setIsStatusModalOpen: (v: boolean) => void;
  quoteForm: any;
  onQuoteFormChange: (field: string, value: any) => void;
  isFindMode: boolean;
  isFindResultsActive: boolean;
  findCriteria: Record<string, string>;
  appliedFindCriteria: Record<string, string>;
  setFindCriteria: React.Dispatch<React.SetStateAction<Record<string, string>>>;
}

interface RepresentativeMasterItem {
  id: number;
  name: string;
  email: string;
}

type StatusOption = {
  id: number;
  value: string;
  label: string;
  type: string;
};

// eBay "Ship to" options — value is the ISO 3166 alpha-2 code sent to the backend.
const EBAY_SHIP_COUNTRIES = [
  { value: "", label: "Any location" },
  { value: "US", label: "United States" },
  { value: "IN", label: "India" },
  { value: "CA", label: "Canada" },
  { value: "MX", label: "Mexico" },
  { value: "GB", label: "United Kingdom" },
  { value: "DE", label: "Germany" },
  { value: "FR", label: "France" },
  { value: "IT", label: "Italy" },
  { value: "ES", label: "Spain" },
  { value: "NL", label: "Netherlands" },
  { value: "AU", label: "Australia" },
  { value: "JP", label: "Japan" },
  { value: "CN", label: "China" },
  { value: "SG", label: "Singapore" },
  { value: "AE", label: "United Arab Emirates" },
];

const STATUS_TYPE_QUOTE = "quote";
const DATE_TIME_FORMAT = "MM/DD/YYYY hh:mm:ss A";
const getNowDateTime = () => dayjs().format(DATE_TIME_FORMAT);

const parseUsDateTime = (value: string) => {
  const raw = String(value || "").trim();
  const match = raw.match(
    /^(\d{1,2})\/(\d{1,2})\/(\d{4})(?:\s+(\d{1,2}):(\d{2})(?::(\d{2}))?\s*(AM|PM))?$/i,
  );
  if (!match) return null;

  const [, monthText, dayText, yearText, hourText, minuteText, secondText, meridiem] = match;
  let hour = Number(hourText || 0);
  if (meridiem) {
    const upper = meridiem.toUpperCase();
    if (upper === "PM" && hour < 12) hour += 12;
    if (upper === "AM" && hour === 12) hour = 0;
  }

  const parsed = new Date(
    Number(yearText),
    Number(monthText) - 1,
    Number(dayText),
    hour,
    Number(minuteText || 0),
    Number(secondText || 0),
  );
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const parseDateTimeValue = (value: any) => {
  if (!value) return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (typeof value === "string") {
    const usParsed = parseUsDateTime(value);
    if (usParsed) return usParsed;

    // Strip UTC timezone suffix so the stored UTC time is displayed as-is
    // without local timezone conversion (e.g. "03:00Z" shows as "03:00", not "08:30" on UTC+5:30)
    const noTz = value.replace(/Z$/, "").replace(/[+-]\d{2}:?\d{2}$/, "");
    const parsedNoTz = new Date(noTz);
    if (!Number.isNaN(parsedNoTz.getTime())) return parsedNoTz;
  }

  const nativeParsed = new Date(value);
  return Number.isNaN(nativeParsed.getTime()) ? null : nativeParsed;
};

const formatDateTimeValue = (value: any, fallback = "") => {
  const parsed = parseDateTimeValue(value);
  return parsed ? dayjs(parsed).format(DATE_TIME_FORMAT) : fallback;
};

const toDayjsValue = (value: any) => {
  const parsed = parseDateTimeValue(value);
  return parsed ? dayjs(parsed) : null;
};

// Default Sub Status / Rep stamped on a brand-new quote record (via New
// Record, or a pending quote entering the review form) when nothing was set.
const DEFAULT_QUOTE_SUB_STATUS = "Active";
const DEFAULT_QUOTE_REP_NAME = "Sean Anderson";
const DEFAULT_QUOTE_REP_EMAIL = "sanderson@alliancetesteq.com";

// The Quotes page's rep name (e.g. "Sean Anderson") and Order Tracking's OTC
// Rep list (e.g. "Sean") often don't match exactly, since OTC Reps are
// frequently just a first name. Try an exact match first, then fall back to
// a substring/prefix match in either direction, then a first-name match.
const findMatchingOtcRep = <T extends { name: string }>(
  quoteRepName: string,
  otcReps: T[],
): T | undefined => {
  const query = quoteRepName.trim().toLowerCase();
  if (!query || otcReps.length === 0) return undefined;

  const exact = otcReps.find((rep) => rep.name.trim().toLowerCase() === query);
  if (exact) return exact;

  const partial = otcReps.find((rep) => {
    const repName = rep.name.trim().toLowerCase();
    return repName && (query.includes(repName) || repName.includes(query));
  });
  if (partial) return partial;

  const firstName = query.split(/\s+/)[0];
  const byFirstName = otcReps.find(
    (rep) => rep.name.trim().toLowerCase().split(/\s+/)[0] === firstName,
  );
  return byFirstName;
};

const mergeDateWithExistingTime = (dateOnlyValue: string, existingDateTime: any) => {
  const nextDate = parseDateTimeValue(dateOnlyValue);
  if (!nextDate) return "";

  const existing = parseDateTimeValue(existingDateTime);
  if (existing) {
    nextDate.setHours(
      existing.getHours(),
      existing.getMinutes(),
      existing.getSeconds(),
      existing.getMilliseconds(),
    );
  }

  return dayjs(nextDate).format(DATE_TIME_FORMAT);
};

const SIMPLE_STATUS_OPTIONS = [
  "SOLD !",
  "Want Target",
  "$$ Change",
  "Offer",
  "No Interest",
  "Make Bid",
  "Offer Made",
  "Call",
  "Working W/Seller",
  "Bid Submitted",
  "Rental Only",
  "Cole Comments",
  "Closed",
  "Sellers Price",
].map((value) => ({ value, label: value }));

/** Options cell — single line by default, click to expand and overlap rows below */
const OptionsCellInput: React.FC<{
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  className?: string;
  readOnly?: boolean;
}> = ({ value, onChange, className, readOnly = false }) => {
  const [focused, setFocused] = useState(false);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const taRef = useRef<HTMLTextAreaElement | null>(null);

  // Close on outside click
  useEffect(() => {
    if (!focused) return;
    const handler = (e: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(e.target as Node)) {
        setFocused(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [focused]);

  // DO NOT put height in the React style prop — React would reset it to "auto"
  // on every re-render, fighting our JS. We set el.style.height directly only.
  const autoResize = (el: HTMLTextAreaElement) => {
    el.style.height = "0px";           // force browser to recalc scrollHeight
    el.style.height = `${el.scrollHeight}px`;
  };

  // Callback ref — keep latest element and size it. This runs on every render,
  // so it must NOT move the caret (doing so on each keystroke forces the cursor
  // to the end). Caret placement happens once on focus, in the effect below.
  const setTaRef = (el: HTMLTextAreaElement | null) => {
    taRef.current = el;
    if (el) autoResize(el);
  };

  // Focus the textarea and place the caret at the end only when it first opens.
  useEffect(() => {
    if (!focused) return;
    const el = taRef.current;
    if (!el) return;
    el.focus(); // focus so onBlur fires correctly
    if (!readOnly) {
      el.setSelectionRange(el.value.length, el.value.length);
    }
  }, [focused, readOnly]);

  return (
    <div ref={containerRef} style={{ position: "relative", height: 24 }}>
      {/* Collapsed: single-line read display */}
      {!focused && (
        <div
          onClick={() => setFocused(true)}
          title={value || undefined}
          style={{
            height: 24,
            lineHeight: "22px",
            fontSize: 12,
            padding: "0 4px",
            border: "1px solid #d9d9d9",
            borderRadius: 4,
            backgroundColor: "#fff",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            cursor: "text",
            color: value ? "#000" : "#bbb",
          }}
        >
          {value || ""}
        </div>
      )}
      {/* Expanded: absolutely positioned, grows to show every line, no scroll */}
      {focused && (
        <textarea
          ref={setTaRef}
          value={value}
          rows={1}
          readOnly={readOnly}
          onChange={(e) => {
            if (readOnly) return;
            onChange(e);
            autoResize(e.target);
          }}
          onBlur={() => setFocused(false)}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            /* height intentionally omitted — managed via el.style.height by autoResize */
            overflow: "hidden",
            fontSize: 12,
            lineHeight: "1.5",
            padding: "3px 6px",
            border: `1px solid ${readOnly ? "#d9d9d9" : "#4096ff"}`,
            borderRadius: 4,
            backgroundColor: readOnly ? "#f5f5f5" : "#fff",
            zIndex: 300,
            boxShadow: "0 6px 16px rgba(0,0,0,0.18)",
            resize: "none",
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            outline: "none",
            boxSizing: "border-box",
            cursor: readOnly ? "default" : "text",
          }}
          /* className intentionally not applied — CSS rules on options-cell-input
             would fight the JS-managed height with !important overrides */
        />
      )}
    </div>
  );
};

const CreateQuote: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  // Filters snapshot passed back from quoteForm after Send FQ
  const _rf = (location.state as any)?.restoredFilters ?? {};
  const QUOTE_ADD_FILTER_KEY = "quoteAddFilterState";
  const _savedFilters = (() => { try { return JSON.parse(localStorage.getItem(QUOTE_ADD_FILTER_KEY) || "null") || {}; } catch { return {}; } })();
  const [sortRules, setSortRules] = useState<SortRule[]>(() => normalizeSortRules(_savedFilters.sortRules, QUOTE_SORT_KEYS));
  // Default to first row so right side is not empty on load
  const [openRow, setOpenRow] = useState<string | null>(null);
  const [isInConversation, setIsInConversation] = useState(false);
  const [activeTopTab, setActiveTopTab] = useState("General");
  const [country, setCountry] = useState();
  const [isAutoSaving, setIsAutoSaving] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const [isHydratingQuote, setIsHydratingQuote] = useState(false);
  const [isLoadingQuoteById, setIsLoadingQuoteById] = useState(false);
  // Tags each loadQuoteByQuoteId call so a stale response (e.g. from rapid
  // prev/next clicks) can't overwrite the table with an out-of-date quote.
  const loadQuoteRequestIdRef = useRef(0);
  const canSendToOrderTracking = (() => {
    try {
      const email = (JSON.parse(localStorage.getItem("user") || "{}")?.email || "").trim().toLowerCase();
      const allowedEmails = (process.env.REACT_APP_ORDER_TRACKING_EMAILS || "")
        .split(",")
        .map((e) => e.trim().toLowerCase())
        .filter(Boolean);
      return allowedEmails.includes(email);
    } catch {
      return false;
    }
  })();
  const buildQuoteSortParams = (rules = sortRules) => {
    const sort = sortRulesToQuery(rules, QUOTE_SORT_KEYS);
    return sort ? { sort } : {};
  };
  const [responsesLoading, setResponsesLoading] = useState(false);
  const [responsesLoadingMore, setResponsesLoadingMore] = useState(false);
  const [responsesTabKey, setResponsesTabKey] = useState("1");
  const [responsesRefreshKey, setResponsesRefreshKey] = useState(0);
  const [custEmailSearch, setCustEmailSearch] = useState("");
  const [dealerEmailSearch, setDealerEmailSearch] = useState("");
  const [dealerEmailDateRange, setDealerEmailDateRange] = useState<
    [dayjs.Dayjs | null, dayjs.Dayjs | null] | null
  >(null);
  const [recordInputValue, setRecordInputValue] = useState<string>("");
  const [quotesResponsesData, setQuotesResponsesData] = useState<any[]>([]);
  const [selectedResponseInfo, setSelectedResponseInfo] = useState<{
    key: string; sendMail: string; dealerSelling: string; tel: string; altTel: string;
  }>({ key: "", sendMail: "", dealerSelling: "", tel: "", altTel: "" });
  const [responsesPagination, setResponsesPagination] = useState({
    page: 1,
    limit: 20,
    total: 0,
    totalPages: 1,
    hasNext: false,
    hasPrev: false,
  });
  const [quotesWtbData, setQuotesWtbData] = useState<any[]>([]);
  const [wtbLoading, setWtbLoading] = useState(false);
  const [euQuotesData, setEuQuotesData] = useState<any[]>([]);
  const [euQuotesLoading, setEuQuotesLoading] = useState(false);
  const [euQuotesFindModel, setEuQuotesFindModel] = useState("");
  const [ebayItems, setEbayItems] = useState<EbayItem[]>([]);
  const [ebayLoading, setEbayLoading] = useState(false);
  const [ebayError, setEbayError] = useState("");
  const [ebayMatchedQuery, setEbayMatchedQuery] = useState("");
  const [ebayExactMatch, setEbayExactMatch] = useState(true);
  // Ship-to country for eBay search (persisted per browser). Empty = no location filter.
  const [ebayCountry, setEbayCountry] = useState<string>(() => {
    try { return localStorage.getItem("ebayShipCountry") || ""; } catch { return ""; }
  });
  const [inventoryByRow, setInventoryByRow] = useState<Record<string, any[]>>({});
  const [euEditingCell, setEuEditingCell] = useState<{ key: string; field: string } | null>(null);
  const [euEditingValue, setEuEditingValue] = useState("");
  const [loadedQuoteId, setLoadedQuoteId] = useState("");
  const [quoteDbId, setQuoteDbId] = useState<number | null>(null);
  const [quoteSeqIdsByRow, setQuoteSeqIdsByRow] = useState<
    Record<string, number>
  >({});

  // --- Pending external quotes (created via the form-token API) ---
  // Pending quotes are shown in the normal quote layout. When viewing one, the
  // header exposes Approve / Reject. pendingViewIndex === null means not in
  // pending-review mode.
  const [pendingQuotes, setPendingQuotes] = useState<any[]>([]);
  const [pendingViewIndex, setPendingViewIndex] = useState<number | null>(null);
  const [pendingActionLoading, setPendingActionLoading] = useState(false);
  const isViewingPending = pendingViewIndex !== null;
  const currentPendingQuote =
    pendingViewIndex !== null ? pendingQuotes[pendingViewIndex] : null;

  // Populate the existing quote form + line-item table directly from a pending
  // quote object (bypasses sanitizeQuoteId, which rejects non-numeric ids).
  const loadPendingIntoForm = (pq: any) => {
    if (!pq) return;
    const fmtUSD = (v: any) => {
      const n = Number(String(v ?? "").replace(/[^0-9.-]/g, ""));
      return Number.isFinite(n)
        ? n.toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2, maximumFractionDigits: 2 })
        : "$0.00";
    };

    const items = Array.isArray(pq.items) ? pq.items : [];
    const mappedRows: LineItem[] = items.map((row: any, index: number) => ({
      // Key a saved row by its real DB id ("seq-<id>") so its identity survives
      // reload. A positional key ("1","2"...) gets reassigned on every load, so
      // if the create's id write-back was lost before a reload the row looked
      // "new" and got created again. A stable seq-<id> key always maps back to
      // the row's seqId, so the save path recognizes it and UPDATES. New rows
      // (handleAddRow) use numeric keys, which never collide with "seq-".
      key: row.id != null ? `seq-${row.id}` : String(index + 1),
      seqId: row.id,
      manufacturer: row.eqBrand || "",
      model: row.eqModel || "",
      options: row.options || "",
      qty: Number(row.quantity) || 0,
      price: fmtUSD(row.priceString || row.price),
      stdCal: row.priceAutomatic != null ? fmtUSD(row.priceAutomatic) : "$0.00",
      status: row.wtbSentCalculated || "",
      description: row.eqDescription || "",
    }));

    const seqIdMap = mappedRows.reduce<Record<string, number>>((acc, row) => {
      if (row.seqId != null) acc[row.key] = row.seqId;
      return acc;
    }, {});

    // A pending quote has no stored quoteId — the header shows the number it
    // WOULD get on approval, which is display-only and never written back.
    const displayQuoteId = pq.previewQuoteId || pq.quoteId || "";
    setQuoteDbId(pq.id);
    setLoadedQuoteId(pq.quoteId || "");
    setRecordInputValue(pq.quoteId || "");
    quoteDbIdRef.current = pq.id;
    quoteSeqIdsByRowRef.current = seqIdMap;
    setQuoteSeqIdsByRow(seqIdMap);
    setTableData(mappedRows);
    setOpenRow(mappedRows.length > 0 ? mappedRows[0].key : null);
    setInventoryByRow({});
    mappedRows.forEach((row) => {
      if (row.model) fetchInventoryForRow(row.key, row.model);
    });
    setIsInConversation(Boolean(pq.inConversation));
    setCountry(String(pq.country || ""));
    setQuoteForm((prev) => ({
      ...prev,
      quoteId: displayQuoteId,
      ip: pq.ip || "",
      quoteSource: pq.quoteSource || "",
      quoteStatus: pq.quoteStatus || "",
      quoteSent: "",
      quoteSentDate: "",
      assignedEmail: pq.assignedEmail || DEFAULT_QUOTE_REP_EMAIL,
      representativeName: (() => {
        const email = pq.assignedEmail || DEFAULT_QUOTE_REP_EMAIL;
        const matched = representativeOptionsRef.current.find(
          (r) => r.email.toLowerCase() === email.toLowerCase(),
        );
        return matched?.name || (pq.assignedEmail ? "" : DEFAULT_QUOTE_REP_NAME);
      })(),
      createdDate: formatDateTimeValue(pq.createdDate, getNowDateTime()),
      contactName: pq.contactName || "",
      contactEmail: pq.contactEmail || "",
      phone1: pq.phone1 || "",
      phone2: pq.phone2 || "",
      mobile: pq.mobile || "",
      companyName: pq.companyName || "",
      customerComments: pq.customerComments || "",
      notes: pq.salesInfo || pq.notes || "",
      optionsRequested: pq.optionsRequested || "",
      subStatus: pq.subStatus || DEFAULT_QUOTE_SUB_STATUS,
    }));
    setIsDirty(false);
  };

  // Entered from the Pending Quotes button in the header: pulls the external
  // (form-token) quotes awaiting review and shows the first one in the form.
  const enterPendingMode = async () => {
    setPendingActionLoading(true);
    try {
      const data = await getPendingExternalQuotes();
      const list = Array.isArray(data) ? data : [];
      if (!list.length) {
        message.info("No pending quotes to review.");
        setPendingQuotes([]);
        setPendingViewIndex(null);
        return;
      }
      setPendingQuotes(list);
      setPendingViewIndex(0);
      loadPendingIntoForm(list[0]);
    } catch {
      message.error("Failed to load pending quotes.");
    } finally {
      setPendingActionLoading(false);
    }
  };

  // Navigate within the pending list (used by the header prev/next + slider
  // while in pending-review mode).
  const goToPending = (index: number) => {
    if (!pendingQuotes.length) return;
    const clamped = Math.max(0, Math.min(index, pendingQuotes.length - 1));
    setPendingViewIndex(clamped);
    loadPendingIntoForm(pendingQuotes[clamped]);
  };

  const exitPendingMode = async () => {
    setPendingViewIndex(null);
    setPendingQuotes([]);
    // Refresh the navigator/stats so any just-approved quotes appear in the
    // records list and counts, then reopen the last opened (real) quote.
    await loadQuoteNavigatorAndStats();
    const lastOpenedQuoteId = sanitizeQuoteId(
      typeof window !== "undefined"
        ? localStorage.getItem("lastOpenedQuoteId")
        : "",
    );
    if (lastOpenedQuoteId) {
      setQuoteForm((prev) => ({ ...prev, quoteId: lastOpenedQuoteId }));
      loadQuoteByQuoteId(lastOpenedQuoteId);
    }
  };

  // Remove the current pending quote from the list and move to the next one,
  // or leave pending-review mode if none remain.
  const advanceAfterAction = () => {
    setPendingQuotes((prev) => {
      const idx = pendingViewIndex ?? 0;
      const next = prev.filter((_, i) => i !== idx);
      if (!next.length) {
        message.success("All pending quotes reviewed.");
        setPendingViewIndex(null);
      } else {
        const nextIdx = Math.min(idx, next.length - 1);
        setPendingViewIndex(nextIdx);
        loadPendingIntoForm(next[nextIdx]);
      }
      return next;
    });
  };

  // Approve the pending quote and stamp it with the status picked in the
  // header dropdown (currently only "Open/WTB").
  const handleApproveCurrentPending = async (status = "Open/WTB") => {
    if (!currentPendingQuote) return;
    setPendingActionLoading(true);
    try {
      // The approve endpoint assigns the real quoteId and stamps the chosen
      // status in the same transaction, so the two can't drift apart.
      const res = await approveExternalQuote(currentPendingQuote.id, status);
      // Keep the open form in sync in case the user is still looking at it.
      setQuoteForm((prev) => ({
        ...prev,
        quoteId: res.quoteId,
        quoteStatus: res.quoteStatus || status,
      }));
      message.success(`Approved as ${status} — assigned Quote ID ${res.quoteId}`);
      // Remember the newly approved (real) quote so Exit opens it and the
      // refreshed records reflect it.
      if (res?.quoteId && typeof window !== "undefined") {
        localStorage.setItem("lastOpenedQuoteId", String(res.quoteId));
      }
      advanceAfterAction();
    } catch {
      message.error("Failed to approve quote.");
    } finally {
      setPendingActionLoading(false);
    }
  };

  // Hard delete: removes the pending quote and its line items permanently.
  const handleDeleteCurrentPending = async () => {
    if (!currentPendingQuote) return;
    setPendingActionLoading(true);
    try {
      await rejectExternalQuote(currentPendingQuote.id);
      message.success("Quote deleted.");
      advanceAfterAction();
    } catch {
      message.error("Failed to delete quote.");
    } finally {
      setPendingActionLoading(false);
    }
  };

  const confirmDeleteCurrentPending = () => {
    if (!currentPendingQuote) return;
    Modal.confirm({
      title: "Delete this quote?",
      content:
        "This permanently deletes the quote and all of its line items. This cannot be undone.",
      okText: "Yes",
      okButtonProps: { danger: true },
      cancelText: "No",
      onOk: handleDeleteCurrentPending,
    });
  };

  // --- Auto-save concurrency guards (Part 1 + Part 2) ---
  // isSavingRef: single-flight lock so only one persistQuote runs at a time.
  // pendingSaveRef: marks that changes arrived during a save → run exactly one more.
  // quoteDbIdRef / quoteSeqIdsByRowRef: instant (synchronous) memory of the saved
  //   quote id and per-row sequence ids, so the next save recognizes an already-saved
  //   row/quote immediately and UPDATES it instead of CREATING a duplicate.
  const isSavingRef = useRef(false);
  const pendingSaveRef = useRef(false);
  // Tracks the currently in-flight persistQuote() call so other code (e.g.
  // record navigation) can await its actual completion instead of racing
  // past it — see the flush in loadQuoteByQuoteId for why that matters.
  const savingPromiseRef = useRef<Promise<void> | null>(null);
  const quoteDbIdRef = useRef<number | null>(null);
  const lastSavedSubStatusRef = useRef<string | null>(null);
  const lastSavedQuoteSentRef = useRef<string | null>(null);
  const quoteSeqIdsByRowRef = useRef<Record<string, number>>({});
  // Rows whose createQuoteSequence POST is currently in flight. A concurrent
  // save (the debounced re-run after pendingSaveRef) must NOT create the same
  // row again while its first create hasn't returned an id yet — that overlap
  // is what produced duplicate line items. Locked by row key for the duration
  // of the POST, then released once the id is recorded.
  const creatingRowsRef = useRef<Set<string>>(new Set());
  useEffect(() => {
    quoteDbIdRef.current = quoteDbId;
  }, [quoteDbId]);
  useEffect(() => {
    quoteSeqIdsByRowRef.current = quoteSeqIdsByRow;
  }, [quoteSeqIdsByRow]);
  const [quoteForm, setQuoteForm] = useState(() => {
    const urlQid = String(new URLSearchParams(window.location.search).get("quoteId") || "").trim();
    const storageQid = String(localStorage.getItem("lastOpenedQuoteId") || "").trim();
    return {
    quoteId: urlQid || storageQid || "",
    createdDate: getNowDateTime(),
    ip: "",
    quoteSource: "",
    quoteStatus: "",
    quoteSent: "",
    quoteSentDate: "",
    representativeName: "",
    assignedEmail: "",
    contactName: "",
    contactEmail: "",
    phone1: "",
    phone2: "",
    mobile: "",
    fax: "",
    companyName: "",
    customerComments: "",
    notes: "",
    optionsRequested: "",
    emailOutOfStock: "",
    firstFollowUpDate: "",
    secondFollowUpDate: "",
    finalFollowUpDate: "",
    subStatus: "",
    grossMargin: "",
  };
  });

  const [tableData, setTableData] = useState<LineItem[]>([]);

  // The Dealer Email tab has no quote to key off of when you jump there from
  // the nav menu, so it reads the models for the quote you were last looking
  // at here from localStorage. Kept up to date on every line-item change so
  // it always reflects what's on screen, not a stale snapshot.
  useEffect(() => {
    try {
      const models = Array.from(
        new Set(
          tableData
            .map((item) => (item.model || "").trim())
            .filter(Boolean),
        ),
      );
      localStorage.setItem(
        DEALER_EMAIL_MODELS_STORAGE_KEY,
        JSON.stringify(models),
      );
    } catch {
      // Blocked/full localStorage — the Dealer Email tab just won't pre-fill.
    }
  }, [tableData]);

  const [manufacturerOptions, setManufacturerOptions] = useState<
    Array<{ value: string; label: string }>
  >([]);
  const [isManufacturerModalOpen, setIsManufacturerModalOpen] = useState(false);
  const [showFQResendConfirm, setShowFQResendConfirm] = useState(false);
  const [isGrossMarginFocused, setIsGrossMarginFocused] = useState(false);
  const [isOrderTrackingModalOpen, setIsOrderTrackingModalOpen] = useState(false);
  const [otDraft, setOtDraft] = useState<OpenOrderData | null>(null);
  const [otVendorOptions, setOtVendorOptions] = useState<
    Array<{ value: string; label: string }>
  >([]);
  const [otStatusOptions, setOtStatusOptions] = useState<
    Array<{ value: string; label: string }>
  >([]);
  const [otcReps, setOtcReps] = useState<{ id: number; name: string }[]>([]);
  const [otcPmts, setOtcPmts] = useState<{ id: number; name: string }[]>([]);
  const [isPmtModalOpen, setIsPmtModalOpen] = useState(false);
  const [editingPmt, setEditingPmt] = useState<{ id: number; name: string } | null>(null);
  const [newPmtName, setNewPmtName] = useState("");
  const [isSubmittingOrderTracking, setIsSubmittingOrderTracking] = useState(false);
  const [manufacturers, setManufacturers] = useState<Manufacturer[]>([]);
  const [editingManufacturer, setEditingManufacturer] = useState<{
    id: number;
    name: string;
  } | null>(null);
  const [newManufacturerName, setNewManufacturerName] = useState("");

  // Add this state near your other useState declarations
  const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);

  const quoteFormRef = useRef<any>(quoteForm);
  quoteFormRef.current = quoteForm;
  const [statusOptions, setStatusOptions] = useState<StatusOption[]>([]);
  const [representativeOptions, setRepresentativeOptions] = useState<
    RepresentativeMasterItem[]
  >([]);
  const representativeOptionsRef = useRef<RepresentativeMasterItem[]>([]);
  const [sourceOptions, setSourceOptions] = useState([
    { value: "Website", label: "Website" },
  ]);
  const [editingStatus, setEditingStatus] = useState({ index: -1, value: "" });
  const [newStatus, setNewStatus] = useState("");
  const [quoteIdList, setQuoteIdList] = useState<string[]>([]);
  const [allQuoteIdList, setAllQuoteIdList] = useState<string[]>([]);
  const [notQuotedQuoteIdList, setNotQuotedQuoteIdList] = useState<string[]>(
    [],
  );
  const [expectingPoQuoteIdList, setExpectingPoQuoteIdList] = useState<
    string[]
  >([]);
  const [inConversationQuoteIdList, setInConversationQuoteIdList] = useState<
    string[]
  >([]);
  const [isNotQuotedFilterActive, setIsNotQuotedFilterActive] = useState<boolean>(_rf.isNotQuotedFilterActive ?? _savedFilters.isNotQuotedFilterActive ?? false);
  const [isExpectingPoFilterActive, setIsExpectingPoFilterActive] = useState<boolean>(_rf.isExpectingPoFilterActive ?? _savedFilters.isExpectingPoFilterActive ?? false);
  const [isInConversationFilterActive, setIsInConversationFilterActive] = useState<boolean>(_rf.isInConversationFilterActive ?? _savedFilters.isInConversationFilterActive ?? false);
  const [isFindResultsActive, setIsFindResultsActive] = useState<boolean>(_rf.isFindResultsActive ?? _savedFilters.isFindResultsActive ?? false);
  const [isFindMode, setIsFindMode] = useState(false);
  const [findCriteria, setFindCriteria] = useState<Record<string, string>>(_rf.appliedFindCriteria ?? {});
  const [appliedFindCriteria, setAppliedFindCriteria] = useState<Record<string, string>>(_rf.appliedFindCriteria ?? {});
  const [savedFormBeforeFind, setSavedFormBeforeFind] = useState<any>(null);
  const [savedTableDataBeforeFind, setSavedTableDataBeforeFind] = useState<LineItem[]>([]);
  const [editingResponsesTable, setEditingResponsesTable] = useState<{
    focusKey: string;
    focusField: string;
    valuesByKey: Record<string, Record<string, any>>;
  } | null>(null);

  const [editingWtbResponseTable, setEditingWtbResponseTable] = useState<{
    focusKey: string;
    focusField: string;
    valuesByKey: Record<string, Record<string, any>>;
  } | null>(null);

  const normalizeResponseEditValue = (value: any) =>
    value === "-" || value == null ? "" : value;

  const renderResponseDisplayValue = (value: any) => {
    const normalized = normalizeResponseEditValue(value);
    return normalized === "" ? "\u00A0" : normalized;
  };

  const buildResponseDraftValues = (record: any) => ({
    date: normalizeResponseEditValue(record.date),
    price: normalizeResponseEditValue(record.price),
    qty: normalizeResponseEditValue(record.qty),
    options: normalizeResponseEditValue(record.options),
    status: normalizeResponseEditValue(record.status),
    comments: normalizeResponseEditValue(record.comments),
    company: normalizeResponseEditValue(record.company),
    subStatus: normalizeResponseEditValue(record.subStatus),
    listType: normalizeResponseEditValue(record.listType),
    qrId: normalizeResponseEditValue(record.qrId),
  });

  // Called from every onFocus inside dealerSalesColumns — saves the OLD focused cell
  // before switching focus so the value is never lost when the textarea unmounts.
  const switchResponseEditFocus = (newKey: string, newField: string) => {
    if (!editingResponsesTable) return;
    const { focusKey: oldKey, focusField: oldField, valuesByKey } = editingResponsesTable;
    if (oldKey && oldField && (oldKey !== newKey || oldField !== newField)) {
      handleSaveCell(oldKey, oldField, valuesByKey[oldKey]?.[oldField] ?? "", null);
    }
    setEditingResponsesTable((prev) => prev ? { ...prev, focusKey: newKey, focusField: newField } : prev);
  };

  const openResponsesTableEdit = (focusKey: string, focusField: string) => {
    // If already editing, save the currently focused cell first then just update focus —
    // don't rebuild valuesByKey or user's in-progress edits on other rows will be lost.
    if (editingResponsesTable) {
      const { focusKey: oldKey, focusField: oldField, valuesByKey } = editingResponsesTable;
      if (oldKey && oldField) {
        handleSaveCell(oldKey, oldField, valuesByKey[oldKey]?.[oldField] ?? "", null);
      }
      setEditingResponsesTable((prev) => prev ? { ...prev, focusKey, focusField } : prev);
      return;
    }
    setEditingResponsesTable({
      focusKey,
      focusField,
      isWtb: false,
      valuesByKey: quotesResponsesData.reduce(
        (acc, row) => {
          acc[row.key] = buildResponseDraftValues(row);
          return acc;
        },
        {} as Record<string, Record<string, any>>,
      ),
    });
  };

  const openWtbResponseEdit = (focusKey: string, focusField: string) => {
    setEditingWtbResponseTable({
      focusKey,
      focusField,
      valuesByKey: quotesWtbData.reduce(
        (acc, row) => {
          acc[row.key] = {
            date: row.date ?? "",
            model: row.model ?? "",
            manu: row.manu ?? "",
            price: row.price ?? "",
            company: row.company ?? "",
            listType: row.listType ?? "",
          };
          return acc;
        },
        {} as Record<string, Record<string, any>>,
      ),
    });
  };

  const updateWtbResponseDraft = (key: string, field: string, value: any) => {
    setEditingWtbResponseTable((prev) =>
      prev
        ? {
            ...prev,
            valuesByKey: {
              ...prev.valuesByKey,
              [key]: { ...prev.valuesByKey[key], [field]: value },
            },
          }
        : prev,
    );
  };

  const handleSaveWtbResponseCell = async (key: string, field: string, value: any) => {
    const previousWtb = quotesWtbData;
    setQuotesWtbData((prev) =>
      prev.map((item) => item.key === key ? { ...item, [field]: value } : item),
    );
    try {
      const updateData: any = {};
      switch (field) {
        case "date":     updateData.createdDate = value; break;
        case "model":    updateData.eqModel = value; break;
        case "manu":     updateData.eqBrand = value; break;
        case "price":    updateData.priceString = value; break;
        case "company":  updateData.companyName = value; break;
        case "listType": updateData.listType = value; updateData.sellerType = value; break;
      }
      if (Object.keys(updateData).length > 0) {
        await updateQuotesResponse(key, updateData);
      }
    } catch (error: any) {
      setQuotesWtbData(previousWtb);
      message.error(error?.response?.data?.message || "Failed to update");
    }
  };

  const updateResponseDraftValue = (key: string, field: string, value: any) => {
    setEditingResponsesTable((prev) =>
      prev
        ? {
            ...prev,
            valuesByKey: {
              ...prev.valuesByKey,
              [key]: {
                ...prev.valuesByKey[key],
                [field]: value,
              },
            },
          }
        : prev,
    );
  };

  useEffect(() => {
    if (!editingResponsesTable) return;

    const handlePointerDown = (event: MouseEvent) => {
      const { isWtb, focusKey, focusField, valuesByKey } = editingResponsesTable;
      const tableWrapper = isWtb
        ? wtbTableWrapperRef.current
        : dealerSalesTableWrapperRef.current;
      if (!tableWrapper) return;

      if (!tableWrapper.contains(event.target as Node)) {
        // Save the focused cell before the textarea unmounts (blur won't fire on unmount)
        if (focusKey && focusField) {
          const value = valuesByKey[focusKey]?.[focusField] ?? "";
          handleSaveCell(focusKey, focusField, value, null, !!isWtb);
        }
        setEditingResponsesTable(null);
      }
    };

    document.addEventListener("mousedown", handlePointerDown);
    return () => document.removeEventListener("mousedown", handlePointerDown);
  }, [editingResponsesTable]);

  useEffect(() => {
    if (!editingWtbResponseTable) return;
    const handleDown = (event: MouseEvent) => {
      const wrapper = wtbTableWrapperRef.current;
      if (!wrapper) return;
      if (!wrapper.contains(event.target as Node)) {
        const { focusKey, focusField, valuesByKey } = editingWtbResponseTable;
        if (focusKey && focusField) {
          handleSaveWtbResponseCell(focusKey, focusField, valuesByKey[focusKey]?.[focusField] ?? "");
        }
        setEditingWtbResponseTable(null);
      }
    };
    document.addEventListener("mousedown", handleDown);
    return () => document.removeEventListener("mousedown", handleDown);
  }, [editingWtbResponseTable]);

  const handleSaveCell = async (
    key: string,
    field: string,
    value: any,
    record: any,
    isWtbOverride?: boolean,
  ) => {
    const isWtb = isWtbOverride !== undefined ? isWtbOverride : !!editingResponsesTable?.isWtb;

    // Optimistic update — show change immediately before API responds
    if (isWtb) {
      const previousWtb = quotesWtbData;
      setQuotesWtbData((prev) =>
        prev.map((item) => item.key === key ? { ...item, [field]: value } : item),
      );
      try {
        const updateData: any = {};
        switch (field) {
          case "options":   updateData.eqOptions = value; updateData.options = value; break;
          case "status":    updateData.status = value; break;
          case "company":   updateData.source = value; break;
          case "subStatus": updateData.status = value; break;
          case "listType":  updateData.type = value; updateData.listType = value; break;
          case "qrId":      updateData.recordId = value; break;
          case "date":      updateData.created = value; updateData.createdDate = value; break;
        }
        if (Object.keys(updateData).length > 0) {
          await updateQuoteWtb(key, updateData);
        }
      } catch (error: any) {
        setQuotesWtbData(previousWtb);
        message.error(error?.response?.data?.message || "Failed to update");
      }
      return;
    }

    const previousData = quotesResponsesData;
    setQuotesResponsesData((prev) =>
      prev.map((item) => item.key === key ? { ...item, [field]: value } : item),
    );
    try {
      const updateData: any = {};
      switch (field) {
        case "company":   updateData.companyName = value; break;
        case "date":      updateData.createdDate = value; break;
        case "price":     updateData.priceString = value; break;
        case "qty":       updateData.qty = value; break;
        case "options":   updateData.options = value; break;
        case "status":    updateData.dStatus = value; break;
        case "comments":  updateData.salesComments = value; break;
        case "subStatus": updateData.dealerQuoted = value; break;
        case "listType":  updateData.sellerType = value; break;
        case "qrId":      updateData.recordId = value; break;
      }
      await updateQuotesResponse(key, updateData);
    } catch (error: any) {
      setQuotesResponsesData(previousData);
      message.error(error?.response?.data?.message || "Failed to update");
    }
  };

  const refreshQuoteStatuses = async () => {
    try {
      const statusResponse = await getStatuses();
      if (Array.isArray(statusResponse) && statusResponse.length > 0) {
        const mappedStatuses = statusResponse
          .filter((item) => item.type === STATUS_TYPE_QUOTE)
          .map((item) => ({
            id: item.id,
            value: item.statusName,
            label: item.statusName,
            type: item.type,
          }));
        setStatusOptions(mappedStatuses);
      } else {
        setStatusOptions([]);
      }
    } catch (error: any) {
      message.error(
        error?.response?.data?.message || "Failed to load statuses",
      );
    }
  };
  const [recordStats, setRecordStats] = useState({
    total: 0,
    open: 0,
    notQuoted: 0,
    expectingPo: 0,
  });
  const [deletedQuoteIds, setDeletedQuoteIds] = useState<Set<string>>(
    new Set(),
  );
  const dealerSalesTableWrapperRef = useRef<HTMLDivElement | null>(null);
  const wtbTableWrapperRef = useRef<HTMLDivElement | null>(null);
  const euQuotesTableWrapperRef = useRef<HTMLDivElement | null>(null);
  // Always holds the latest loadMoreQuoteResponses — prevents stale closure in scroll listeners
  const loadMoreQuoteResponsesRef = useRef<(() => void) | null>(null);
  // Ref-based gates so the scroll handler always sees the current value
  // without waiting for React to re-render (avoids stale-closure race condition)
  const hasNextRef = useRef(false);
  const isLoadingMoreRef = useRef(false);

  const normalizeQuoteId = (value: any) => String(value || "").trim();
  const sanitizeQuoteId = (value: any) => {
    const id = normalizeQuoteId(value);
    return /^\d+$/.test(id) ? id : "";
  };
  const FIND_STATE_STORAGE_KEY = "quoteAddFindState";

  const clearPersistedFindState = () => {
    if (typeof window === "undefined") return;
    localStorage.removeItem(FIND_STATE_STORAGE_KEY);
  };

  const getFindDisplayValue = (field: string) =>
    findCriteria[field] !== undefined
      ? String(findCriteria[field] || "")
      : String(appliedFindCriteria[field] || "");
  const isFindEntryMode = isFindMode && !isFindResultsActive;

  const withQuoteId = (path: string, quoteIdValue?: string) => {
    const quoteId = sanitizeQuoteId(
      quoteIdValue || loadedQuoteId || quoteForm.quoteId,
    );
    if (!quoteId) return path;
    return `${path}?quoteId=${encodeURIComponent(quoteId)}`;
  };

  const syncQuoteIdToUrl = (quoteIdValue?: string, replace = true) => {
    const quoteId = sanitizeQuoteId(quoteIdValue);
    const nextParams = new URLSearchParams(searchParams);
    nextParams.delete("mode");
    if (quoteId) {
      nextParams.set("quoteId", quoteId);
    } else {
      nextParams.delete("quoteId");
    }
    setSearchParams(nextParams, { replace });
  };

  const sortQuoteIds = (ids: string[]) =>
    [...ids].sort((a, b) => {
      const aNum = Number(a);
      const bNum = Number(b);
      if (Number.isFinite(aNum) && Number.isFinite(bNum)) return aNum - bNum;
      return a.localeCompare(b);
    });

  const fetchAllRepresentatives = async () => {
    const response = await getRepresentatives();
    const rows = Array.isArray(response?.data) ? response.data : Array.isArray(response) ? response : [];

    const seen = new Set<string>();
    return rows
      .map((item: any) => ({
        id: Number(item?.id || 0),
        name: String(item?.name || "").trim(),
        email: String(item?.email || "").trim(),
      }))
      .filter((item: RepresentativeMasterItem) => {
        const key = item.name.toLowerCase();
        if (!key || seen.has(key)) return false;
        seen.add(key);
        return true;
      });
  };

  const loadQuoteNavigatorAndStats = async (rulesOverride = sortRules) => {
    try {
      const sortParams = buildQuoteSortParams(rulesOverride);
      const shouldUseBackendOrder = Boolean(sortParams.sort);
      const response = await getQuoteNavigatorData(sortParams);
      const orderQuoteIds = (ids: any[]) => {
        const list = Array.isArray(ids) ? ids : [];
        if (!shouldUseBackendOrder) return sortQuoteIds(list);
        return Array.from(new Set(list.map((id) => String(id || "").trim()).filter(Boolean)));
      };
      const uniqueSortedIds = orderQuoteIds(response?.quoteIds);
      const uniqueNotQuotedIds = orderQuoteIds(response?.notQuotedQuoteIds);
      const uniqueExpectingPoIds = orderQuoteIds(response?.expectingPoQuoteIds);
      const uniqueInConversationIds = orderQuoteIds(
        Array.isArray(response?.inConversationQuoteIds)
          ? response.inConversationQuoteIds
          : Array.isArray(response?.inConversationIds)
            ? response.inConversationIds
            : [],
      );
      setAllQuoteIdList(uniqueSortedIds);
      setNotQuotedQuoteIdList(uniqueNotQuotedIds);
      setExpectingPoQuoteIdList(uniqueExpectingPoIds);
      setInConversationQuoteIdList(uniqueInConversationIds);
      setRecordStats({
        total: Number(response?.counts?.total || uniqueSortedIds.length),
        open: uniqueSortedIds.length,
        notQuoted: Number(
          response?.counts?.notQuoted || uniqueNotQuotedIds.length,
        ),
        expectingPo: Number(
          response?.counts?.expectingPo || uniqueExpectingPoIds.length,
        ),
      });
      return {
        quoteIds: uniqueSortedIds,
        notQuotedQuoteIds: uniqueNotQuotedIds,
        expectingPoQuoteIds: uniqueExpectingPoIds,
        inConversationQuoteIds: uniqueInConversationIds,
      };
    } catch (error: any) {
      message.error(
        error?.response?.data?.message || "Failed to load record stats",
      );
      return null;
    }
  };

  useEffect(() => {
    if (isFindResultsActive) {
      setQuoteIdList(allQuoteIdList);
      return;
    }
    if (isNotQuotedFilterActive) {
      setQuoteIdList(notQuotedQuoteIdList);
      return;
    }
    if (isExpectingPoFilterActive) {
      setQuoteIdList(expectingPoQuoteIdList);
      return;
    }
    if (isInConversationFilterActive) {
      setQuoteIdList(inConversationQuoteIdList);
      return;
    }
    setQuoteIdList(allQuoteIdList);
  }, [
    isFindResultsActive,
    isNotQuotedFilterActive,
    isExpectingPoFilterActive,
    isInConversationFilterActive,
    allQuoteIdList,
    notQuotedQuoteIdList,
    expectingPoQuoteIdList,
    inConversationQuoteIdList,
  ]);

  useEffect(() => {
    localStorage.setItem(QUOTE_ADD_FILTER_KEY, JSON.stringify({
      isNotQuotedFilterActive,
      isExpectingPoFilterActive,
      isInConversationFilterActive,
      isFindResultsActive,
      sortRules,
    }));
  }, [isNotQuotedFilterActive, isExpectingPoFilterActive, isInConversationFilterActive, isFindResultsActive, sortRules]);

  useEffect(() => {
    const loadMasters = async () => {
      try {
        const [
          sourcesResponse,
          statusResponse,
          nextQuoteResponse,
          representativesResponse,
        ] = await Promise.all([
          getSources(),
          getStatuses(),
          getNextQuoteId(),
          fetchAllRepresentatives(),
        ]);

        if (Array.isArray(sourcesResponse) && sourcesResponse.length > 0) {
          const mappedSources = sourcesResponse.map((item) => ({
            value: item.sourceName,
            label: item.sourceName,
          }));
          setSourceOptions(mappedSources);
        }

        if (Array.isArray(statusResponse) && statusResponse.length > 0) {
          const mappedStatuses = statusResponse
            .filter((item) => item.type === STATUS_TYPE_QUOTE)
            .map((item) => ({
              id: item.id,
              value: item.statusName,
              label: item.statusName,
              type: item.type,
            }));
          setStatusOptions(mappedStatuses);
        } else {
          setStatusOptions([]);
        }

        setRepresentativeOptions(representativesResponse);
        if (representativesResponse.length > 0) {
          setQuoteForm((prev) => {
            const currentName = String(prev.representativeName || "").trim();
            const currentEmail = String(prev.assignedEmail || "").trim();

            const matchByName = representativesResponse.find(
              (rep) =>
                rep.name.toLowerCase() === currentName.toLowerCase() &&
                currentName,
            );
            const matchByEmail = representativesResponse.find(
              (rep) =>
                rep.email.toLowerCase() === currentEmail.toLowerCase() &&
                currentEmail,
            );
            const matchByLegacyName = representativesResponse.find(
              (rep) =>
                rep.name.toLowerCase() === currentEmail.toLowerCase() &&
                currentEmail,
            );

            const selected = matchByName || matchByEmail || matchByLegacyName;

            return {
              ...prev,
              representativeName: selected ? selected.name : prev.representativeName || "",
              assignedEmail: selected ? selected.email : prev.assignedEmail || "",
            };
          });
        }

        const quoteIdFromUrl = sanitizeQuoteId(searchParams.get("quoteId"));
        const lastOpenedQuoteId = sanitizeQuoteId(
          typeof window !== "undefined"
            ? localStorage.getItem("lastOpenedQuoteId")
            : "",
        );
        const isNewMode = searchParams.get("mode") === "new";

        setQuoteForm((prev) => ({
          ...prev,
          quoteId:
            prev.quoteId ||
            (isNewMode || (!quoteIdFromUrl && !lastOpenedQuoteId)
              ? String(nextQuoteResponse?.quoteId || "")
              : ""),
        }));
      } catch (error: any) {
        message.error(
          error?.response?.data?.message || "Failed to load source/status data",
        );
      }
    };

    loadMasters();
    (async () => {
      await loadQuoteNavigatorAndStats();
      if (typeof window === "undefined") return;
      const raw = localStorage.getItem(FIND_STATE_STORAGE_KEY);
      if (!raw) return;
      try {
        const parsed = JSON.parse(raw) as {
          ids?: string[];
          criteria?: Record<string, string>;
          row?: Partial<LineItem>;
        };
        const restoredIds = Array.isArray(parsed?.ids)
          ? parsed.ids.filter((id): id is string => Boolean(id && String(id).trim()))
          : [];
        if (!restoredIds.length) {
          clearPersistedFindState();
          return;
        }

        setIsFindResultsActive(true);
        setIsFindMode(true);
        setIsNotQuotedFilterActive(false);
        setIsExpectingPoFilterActive(false);
        setIsInConversationFilterActive(false);
        setFindCriteria(parsed?.criteria || {});
        setAppliedFindCriteria(parsed?.criteria || {});
        setAllQuoteIdList(restoredIds);
        setTableData([
          {
            key: "find-1",
            manufacturer: String(parsed?.row?.manufacturer || ""),
            model: String(parsed?.row?.model || ""),
            options: String(parsed?.row?.options || ""),
            qty: 1,
            price: "",
            stdCal: "",
            status: "",
            description: String(parsed?.row?.description || ""),
          },
        ]);
        setOpenRow("find-1");
        loadQuoteByQuoteId(restoredIds[0]);
      } catch {
        clearPersistedFindState();
      }
    })();
  }, []);

  useEffect(() => {
    if (!representativeOptions.length) return;

    setQuoteForm((prev) => {
      const currentName = String(prev.representativeName || "").trim();
      const currentEmail = String(prev.assignedEmail || "").trim();

      const repByName = representativeOptions.find(
        (rep) => rep.name.toLowerCase() === currentName.toLowerCase(),
      );
      if (repByName) {
        if (repByName.email === currentEmail) return prev;
        // Don't auto-fill email if the user explicitly cleared it
        if (!currentEmail) return prev;
        return {
          ...prev,
          assignedEmail: repByName.email,
        };
      }

      const repByEmail = representativeOptions.find(
        (rep) => rep.email.toLowerCase() === currentEmail.toLowerCase(),
      );
      if (repByEmail) {
        return {
          ...prev,
          representativeName: repByEmail.name,
          assignedEmail: repByEmail.email,
        };
      }

      const repByLegacyName = representativeOptions.find(
        (rep) => rep.name.toLowerCase() === currentEmail.toLowerCase(),
      );
      if (repByLegacyName) {
        return {
          ...prev,
          representativeName: repByLegacyName.name,
          assignedEmail: repByLegacyName.email,
        };
      }

      return prev;
    });
  }, [representativeOptions, quoteForm.assignedEmail]);

  // Keep ref in sync so loadQuoteByQuoteId always sees the latest options
  // regardless of when it was captured in the closure.
  useEffect(() => {
    representativeOptionsRef.current = representativeOptions;
  }, [representativeOptions]);

  const selectedModelForResponses =
    tableData.find((i) => i.key === openRow)?.model?.trim() || "";

  const mapQuoteResponseRows = (rows: any[]) =>
    [...rows]
    .sort((a, b) => {
      const dateA = a.createdDate ? new Date(a.createdDate).getTime() : 0;
      const dateB = b.createdDate ? new Date(b.createdDate).getTime() : 0;
      return dateB - dateA; // newest first, oldest last
    })
    .map((row) => {
      const createdDate = row.createdDate ? new Date(row.createdDate) : null;
      const dateLabel =
        createdDate && !Number.isNaN(createdDate.getTime())
          ? createdDate.toLocaleDateString("en-US", {
              month: "2-digit",
              day: "2-digit",
              year: "numeric",
            })
          : "";

      const toCurrency = (value: any) => {
        if (value == null || value === "") return null;
        const parsed = Number(
          String(value)
            .replace(/,/g, "")
            .replace(/[^0-9.-]/g, ""),
        );
        if (!Number.isFinite(parsed)) return null;
        return parsed.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
      };

      const priceDisplay =
        toCurrency(row.priceString) ||
        toCurrency(row.price) ||
        toCurrency(row.priceRange) ||
        "";

      return {
        key: String(row.qid),
        date: dateLabel,
        price: priceDisplay,
        qty: Number(row.qty) || 1,
        options: row.options || "",
        status: row.dStatus || "",
        comments: row.salesComments || "",
        company: row.companyName || "",
        subStatus: row.dealerQuoted || "Active",
        listType: row.listType || row.sellerType || "",
        qrId: row.recordId || "",
        model: row.eqModel || "",
        manu: row.eqBrandConsolidated || row.eqBrand || "",
        sendMail: row.email || row.contactEmail || row.wtbReplyEmail || row.wtbdReplyEmail || row.offices?.[0]?.email || "",
        dealerSelling: row.companyName || "",
        tel: row.offices?.[0]?.phone1 || row.responseContacts?.[0]?.phone1 || "",
        altTel: row.offices?.[0]?.phone2 || row.responseContacts?.[0]?.phone2 || "",
      };
    });

  const loadMoreQuoteResponses = async () => {
    // Use refs for the guards — they are updated synchronously on every render
    // and also mutated directly below, so they're never stale.
    if (
      responsesTabKey === "4" ||
      !selectedModelForResponses ||
      responsesLoading ||
      isLoadingMoreRef.current ||
      !hasNextRef.current
    ) {
      return;
    }

    // ── Lock immediately (synchronously, before any await) ──────────────────
    // This blocks any concurrent scroll events that fire before React re-renders
    // with the new responsesLoadingMore = true state.
    isLoadingMoreRef.current = true;

    try {
      setResponsesLoadingMore(true);
      const nextPage = Number(responsesPagination.page || 1) + 1;
      const responseRowsResponse = await getQuotesResponses({
        model: selectedModelForResponses,
        modelMatch: "exact",
        page: nextPage,
        limit: responsesPagination.limit || 20,
        sort: "desc",
      });
      const responseRows = Array.isArray(responseRowsResponse?.data)
        ? responseRowsResponse.data
        : [];

      // No rows returned — we've reached the end, stop all future loads.
      if (responseRows.length === 0) {
        hasNextRef.current = false; // block immediately, before next re-render
        setResponsesPagination((prev) => ({ ...prev, hasNext: false }));
        return;
      }

      const mappedRows = mapQuoteResponseRows(responseRows);

      // ── Save scroll position before the DOM update ───────────────────────
      // Without this, adding rows causes the Ant Design table to reflow and
      // the browser resets scrollTop to 0 (the "scroll jumps to top" bug).
      const activeWrapper =
        responsesTabKey === "1"
          ? dealerSalesTableWrapperRef.current
          : euQuotesTableWrapperRef.current;
      const scrollEl = activeWrapper
        ? ((activeWrapper.querySelector(".ant-table-body") as HTMLElement) || activeWrapper)
        : null;
      const savedScrollTop = scrollEl ? scrollEl.scrollTop : 0;

      // ── Append only — no re-sort ─────────────────────────────────────────
      // Sorting the full array on every append forces React to re-reconcile
      // all existing rows, which causes the scroll container to reset.
      // Pages from the API are already ordered; just append.
      setQuotesResponsesData((prev) => {
        const existingKeys = new Set(prev.map((item) => item.key));
        const nextRows = mappedRows.filter((item) => !existingKeys.has(item.key));
        return [...prev, ...nextRows];
      });

      // ── Restore scroll position after React paints ───────────────────────
      if (scrollEl) {
        requestAnimationFrame(() => {
          scrollEl.scrollTop = savedScrollTop;
        });
      }

      const pagination = responseRowsResponse?.pagination;
      const newHasNext = pagination
        ? pagination.hasNext && responseRows.length >= (pagination.limit || 20)
        : false;

      // Update ref immediately so the next scroll event sees the correct value
      // before React has had a chance to re-render.
      hasNextRef.current = newHasNext;

      setResponsesPagination(
        pagination
          ? { ...pagination, hasNext: newHasNext }
          : {
              page: nextPage,
              limit: responsesPagination.limit || 20,
              total: quotesResponsesData.length + mappedRows.length,
              totalPages: nextPage,
              hasNext: false,
              hasPrev: nextPage > 1,
            },
      );
    } catch (error: any) {
      message.error(
        error?.response?.data?.message || "Failed to load more quote responses",
      );
    } finally {
      // Always unlock — even if an error occurred
      isLoadingMoreRef.current = false;
      setResponsesLoadingMore(false);
    }
  };

  const scrollDebounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  // Sync all three refs on every render so the scroll handler always sees
  // fresh values without waiting for a React re-render cycle.
  loadMoreQuoteResponsesRef.current = loadMoreQuoteResponses;
  hasNextRef.current = responsesPagination.hasNext;
  isLoadingMoreRef.current = responsesLoadingMore;

  useEffect(() => {
    if (responsesTabKey !== "1" && responsesTabKey !== "3") return;

    const wrapper =
      responsesTabKey === "1"
        ? dealerSalesTableWrapperRef.current
        : euQuotesTableWrapperRef.current;
    if (!wrapper) return;

    // When scroll={{ y }} is set Ant Design creates .ant-table-body.
    // Without it the wrapper div itself is the scroll container.
    const scrollTarget = (wrapper.querySelector(".ant-table-body") as HTMLElement) || wrapper;

    const onScroll = () => {
      // Fast gate using refs — avoids stale-closure race condition.
      // If all data is loaded (hasNext = false) or a load is already in
      // progress, stop immediately without even checking scroll position.
      if (!hasNextRef.current || isLoadingMoreRef.current) return;

      // Use Math.ceil to handle subpixel rounding at non-100% browser zoom levels
      const threshold = 100;
      const reachedBottom =
        Math.ceil(scrollTarget.scrollTop) + scrollTarget.clientHeight >=
        scrollTarget.scrollHeight - threshold;
      if (!reachedBottom) return;

      if (scrollDebounceRef.current) clearTimeout(scrollDebounceRef.current);
      scrollDebounceRef.current = setTimeout(() => {
        // Double-check via refs inside the timeout — state may have changed
        // during the debounce window.
        if (!hasNextRef.current || isLoadingMoreRef.current) return;
        loadMoreQuoteResponsesRef.current?.();
      }, 200);
    };

    // passive: true lets the browser scroll immediately without waiting for JS
    scrollTarget.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      scrollTarget.removeEventListener("scroll", onScroll);
    };
    // Only re-attach when the tab or selected model changes — all other state
    // guards are handled via refs above, not deps.
  }, [responsesTabKey, selectedModelForResponses]);

  useEffect(() => {
    const loadResponses = async () => {
      if (!selectedModelForResponses && responsesTabKey !== "4") {
        setQuotesResponsesData([]);
        setQuotesWtbData([]);
        setResponsesLoading(false);
        setResponsesLoadingMore(false);
        setWtbLoading(false);
        setResponsesPagination({
          page: 1,
          limit: 20,
          total: 0,
          totalPages: 1,
          hasNext: false,
          hasPrev: false,
        });
        return;
      }

      try {
        if (responsesTabKey === "4") {
          setWtbLoading(true);
          const res = await getQuotesResponses({
            model: selectedModelForResponses || undefined,
            modelMatch: selectedModelForResponses ? "exact" : undefined,
            page: 1,
            limit: 500,
            sort: "desc",
          });
          const allRows = Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : [];
          const wtbdRows = allRows.filter((row: any) => {
            const lt = String(row.listType || row.sellerType || "").toUpperCase();
            const st = String(row.dStatus || "").toUpperCase();
            return lt === "WTBD" || st === "WTBD";
          });
          const toCurrency = (v: any) => {
            if (v == null || v === "") return "";
            const n = Number(String(v).replace(/,/g, "").replace(/[^0-9.-]/g, ""));
            if (!Number.isFinite(n)) return "";
            return n.toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0 });
          };
          const mappedWtbRows = wtbdRows.map((row: any, index: number) => {
            const createdDate = row.createdDate ? new Date(row.createdDate) : null;
            const dateLabel = createdDate && !Number.isNaN(createdDate.getTime())
              ? createdDate.toLocaleDateString("en-US", { month: "numeric", day: "numeric", year: "numeric" })
              : "-";
            return {
              key: String(row.qid ?? index),
              date: dateLabel,
              model: row.eqModel || "-",
              manu: row.eqBrandConsolidated || row.eqBrand || "-",
              price: toCurrency(row.priceString) || toCurrency(row.price) || "",
              company: row.companyName || "-",
              listType: row.listType || row.sellerType || "WTBD",
              options: row.options || "",
            };
          });
          setQuotesWtbData(mappedWtbRows);
          return;
        }

        setResponsesLoading(true);
        const responseRowsResponse = await getQuotesResponses({
          model: selectedModelForResponses,
          modelMatch: "exact",
          page: 1,
          limit: 20,
          sort: "desc",
        });
        const responseRows = Array.isArray(responseRowsResponse)
          ? responseRowsResponse
          : Array.isArray(responseRowsResponse?.data)
            ? responseRowsResponse.data
            : [];
        const mappedInitial = mapQuoteResponseRows(responseRows);
        setQuotesResponsesData(mappedInitial);
        setResponsesPagination(
          responseRowsResponse?.pagination || {
            page: 1,
            limit: 20,
            total: responseRows.length,
            totalPages: 1,
            hasNext: false,
            hasPrev: false,
          },
        );
      } catch (error: any) {
        message.error(
          error?.response?.data?.message ||
            (responsesTabKey === "4"
              ? "Failed to load dealer WTB records"
              : "Failed to load quote responses"),
        );
      } finally {
        setResponsesLoading(false);
        setWtbLoading(false);
      }
    };

    loadResponses();
  }, [selectedModelForResponses, responsesTabKey, responsesRefreshKey]);

  // Auto-fill: after every data update, if the visible area still has empty
  // space below the last row (nothing to scroll) AND there is a next page,
  // keep loading more pages until the container becomes scrollable or data runs out.
  useEffect(() => {
    if (responsesLoading || responsesLoadingMore) return;
    if (!hasNextRef.current) return;
    if (responsesTabKey !== "1" && responsesTabKey !== "3") return;

    const wrapper =
      responsesTabKey === "1"
        ? dealerSalesTableWrapperRef.current
        : euQuotesTableWrapperRef.current;
    if (!wrapper) return;

    const scrollEl =
      (wrapper.querySelector(".ant-table-body") as HTMLElement) || wrapper;

    // Container is not yet scrollable — rows don't fill the visible height
    if (scrollEl.scrollHeight <= scrollEl.clientHeight) {
      loadMoreQuoteResponsesRef.current?.();
    }
  }, [quotesResponsesData, responsesLoading, responsesLoadingMore, responsesTabKey]);

  const loadEuQuotes = async (modelOverride?: string) => {
    const model = modelOverride !== undefined ? modelOverride : selectedModelForResponses;
    if (!model) {
      setEuQuotesData([]);
      return;
    }
    setEuQuotesLoading(true);
    try {
      const res = await getQuotesByModel(model);
      const rows = Array.isArray(res?.data) ? res.data : [];
      const mapped = [...rows]
        .sort((a, b) => {
          const dateA = a.createdDate ? new Date(a.createdDate).getTime() : 0;
          const dateB = b.createdDate ? new Date(b.createdDate).getTime() : 0;
          return dateB - dateA;
        })
        .map((row, idx) => {
          const createdDate = row.createdDate ? new Date(row.createdDate) : null;
          const dateLabel =
            createdDate && !Number.isNaN(createdDate.getTime())
              ? createdDate.toLocaleDateString("en-US", {
                  month: "2-digit",
                  day: "2-digit",
                  year: "numeric",
                })
              : "-";
          const toCurrency = (v: any) => {
            if (v == null || v === "") return null;
            const n = Number(String(v).replace(/,/g, "").replace(/[^0-9.-]/g, ""));
            if (!Number.isFinite(n)) return null;
            return n.toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2, maximumFractionDigits: 2 });
          };
          return {
            key: String(row.id ?? row.recordId ?? idx),
            quoteDbId: row.id ?? null,
            seqId: row.seqId ?? null,
            date: dateLabel,
            price: toCurrency(row.seqPriceString) || toCurrency(row.seqPrice) || toCurrency(row.dollars) || "$0.00",
            cal: toCurrency(row.cal) || "$0",
            options: row.options || "-",
            description: row.eqDescription || "-",
            company: row.companyName || "-",
            subStatus: row.quoteStatus || row.subStatus || "Open/WTB",
            model: row.eqModel || model,
            manu: row.eqBrand || "-",
            quoteSent: row.quoteSent || "",
          };
        });
      setEuQuotesData(mapped);
    } catch {
      message.error("Failed to load EU quotes");
    } finally {
      setEuQuotesLoading(false);
    }
  };

  useEffect(() => {
    if (responsesTabKey === "3") {
      setEuQuotesFindModel(selectedModelForResponses);
      loadEuQuotes(selectedModelForResponses);
    }
  }, [selectedModelForResponses, responsesTabKey, responsesRefreshKey]);

  const loadEbayItems = async (query: string, model?: string, manufacturer?: string) => {
    if (!query) {
      setEbayItems([]);
      setEbayError("");
      setEbayMatchedQuery("");
      setEbayExactMatch(true);
      return;
    }
    setEbayLoading(true);
    setEbayError("");
    try {
      const res = await searchEbayItems(query, model, manufacturer, {
        country: ebayCountry,
      });
      setEbayItems(Array.isArray(res?.items) ? res.items : []);
      setEbayMatchedQuery(res?.matchedQuery || query);
      setEbayExactMatch(res?.exactMatch !== false);
    } catch (error: any) {
      setEbayItems([]);
      setEbayMatchedQuery("");
      setEbayExactMatch(true);
      setEbayError(
        error?.response?.data?.message || "Failed to load eBay results",
      );
    } finally {
      setEbayLoading(false);
    }
  };

  useEffect(() => {
    if (responsesTabKey === "2") {
      const activeRow = tableData.find((i) => i.key === openRow);
      const query = activeRow
        ? buildEquipmentSearchQuery(activeRow)
        : selectedModelForResponses;
      const model = activeRow?.model?.trim() || selectedModelForResponses;
      const manufacturer = activeRow?.manufacturer?.trim() || "";
      loadEbayItems(query, model, manufacturer);
    }
  }, [selectedModelForResponses, responsesTabKey, responsesRefreshKey, ebayCountry]);

  useEffect(() => {
    try {
      localStorage.setItem("ebayShipCountry", ebayCountry);
    } catch {}
  }, [ebayCountry]);

  // Field → which table + payload key
  const euFieldMeta: Record<string, { table: "quote" | "seq"; payloadKey: string }> = {
    subStatus:   { table: "quote", payloadKey: "quoteStatus" },
    company:     { table: "quote", payloadKey: "companyName" },
    date:        { table: "quote", payloadKey: "createdDate" },
    model:       { table: "seq",   payloadKey: "eqModel" },
    manu:        { table: "seq",   payloadKey: "eqBrand" },
    options:     { table: "seq",   payloadKey: "options" },
    description: { table: "seq",   payloadKey: "eqDescription" },
    cal:         { table: "seq",   payloadKey: "priceAutomatic" },
  };

  const saveEuCell = async (rowKey: string, field: string, value: string) => {
    setEuEditingCell(null);
    const meta = euFieldMeta[field];
    if (!meta) return;
    const row = euQuotesData.find((r) => r.key === rowKey);
    if (!row) return;
    // optimistic update
    setEuQuotesData((prev) =>
      prev.map((r) => (r.key === rowKey ? { ...r, [field]: value } : r)),
    );
    try {
      if (meta.table === "quote" && row.quoteDbId) {
        await updateQuote(row.quoteDbId, { [meta.payloadKey]: value } as any);
      } else if (meta.table === "seq" && row.seqId) {
        await updateQuoteSequence(row.seqId, { [meta.payloadKey]: value } as any);
      }
    } catch {
      // silent — revert optimistic update on failure
      setEuQuotesData((prev) =>
        prev.map((r) => (r.key === rowKey ? { ...r, [field]: row[field] } : r)),
      );
    }
  };

  const onQuoteFormChange = (field: string, value: any) => {
    if (field === "representativeName") {
      const selectedRep = representativeOptions.find((rep) => rep.name === value);
      setQuoteForm((prev) => ({
        ...prev,
        representativeName: value,
        assignedEmail: selectedRep?.email || "",
      }));
      setIsDirty(true);
      return;
    }
    if (field === "assignedEmail") {
      const selectedRep = representativeOptions.find((rep) => rep.email === value);
      setQuoteForm((prev) => ({
        ...prev,
        assignedEmail: value,
        representativeName: selectedRep?.name || prev.representativeName || "",
      }));
      setIsDirty(true);
      return;
    }

    setQuoteForm((prev) => ({
      ...prev,
      [field]: value,
    }));
    setIsDirty(true);
  };

  const resetQuoteForNewId = () => {
    quoteDbIdRef.current = null;
    lastSavedSubStatusRef.current = null;
    lastSavedQuoteSentRef.current = null;
    quoteSeqIdsByRowRef.current = {};
    setQuoteDbId(null);
    setLoadedQuoteId("");
    setQuoteSeqIdsByRow({});
    setTableData([]);
    setOpenRow(null);
    setIsInConversation(false);
    setQuoteForm((prev) => ({
      ...prev,
      createdDate: getNowDateTime(),
      ip: "",
      quoteSource: "",
      quoteStatus: "",
      quoteSent: "",
      quoteSentDate: "",
      representativeName: DEFAULT_QUOTE_REP_NAME,
      assignedEmail: DEFAULT_QUOTE_REP_EMAIL,
      contactName: "",
      contactEmail: "",
      phone1: "",
      phone2: "",
      mobile: "",
      fax: "",
      companyName: "",
      customerComments: "",
      notes: "",
      optionsRequested: "",
      emailOutOfStock: "",
      firstFollowUpDate: "",
      secondFollowUpDate: "",
      finalFollowUpDate: "",
      subStatus: DEFAULT_QUOTE_SUB_STATUS,
    }));
    setCountry("");
  };

  const loadQuoteByQuoteId = async (quoteIdValue: string) => {
    const quoteId = sanitizeQuoteId(quoteIdValue);
    if (!quoteId) return;

    // Flush any unsaved edits on the record we're navigating AWAY from before
    // swapping state to the new record. Without this, the 800ms autosave
    // debounce (below) can still be pending when prev/next is clicked; it then
    // fires AFTER this function has already replaced tableData/quoteForm/refs
    // with the new record's data, so persistQuote() runs against a mix of the
    // new record's ids and stale closures — corrupting/duplicating line items
    // on the record you just navigated to. This only shows up mid-session
    // (rapid navigation right after an edit); a hard refresh has no pending
    // timer, which is why it always "looks fixed" after reload.
    if (isDirty) {
      await persistQuote();
    }
    // Also wait out a save that was already in flight (started by the
    // debounce timer just before this navigation) — persistQuote() above
    // only handles the case where nothing had started yet.
    await waitForPendingSave();

    // Claim this request. If a newer call starts before this one's network
    // requests resolve, requestId will no longer match by the time we get
    // back, and we skip applying results — otherwise a stale response
    // (e.g. from rapid prev/next clicks) could land last and overwrite the
    // table with an out-of-date quote's data.
    const requestId = ++loadQuoteRequestIdRef.current;

    try {
      setIsLoadingQuoteById(true);
      setIsHydratingQuote(true);

      const [quote, quoteSeqRows] = await Promise.all([
        getQuoteByQuoteId(quoteId),
        getQuoteSequencesByQuoteId(quoteId),
      ]);

      if (requestId !== loadQuoteRequestIdRef.current) return;

      if (quote?.isDeleted) {
        message.warning(`Quote ID ${quoteId} is deleted.`);
        return;
      }

      const fmtUSD = (v: any) => {
        const n = Number(String(v || "").replace(/[^0-9.-]/g, ""));
        return Number.isFinite(n)
          ? n.toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2, maximumFractionDigits: 2 })
          : "$0.00";
      };

      const mappedRows: LineItem[] = quoteSeqRows.map((row, index) => ({
        // Stable id-based key so a saved row keeps its identity across reload
        // and is always recognized as already-saved (UPDATE, never a 2nd
        // create). See the matching comment in the localStorage-restore path.
        key: row.id != null ? `seq-${row.id}` : String(index + 1),
        seqId: row.id,
        manufacturer: row.eqBrand || "",
        model: row.eqModel || "",
        options: row.options || "",
        qty: Number(row.quantity) || 0,
        price: fmtUSD(row.priceString || row.price),
        stdCal: row.priceAutomatic != null ? fmtUSD(row.priceAutomatic) : "$0.00",
        status: row.wtbSentCalculated || "",
        description: row.eqDescription || "",
      }));

      const seqIdMap = mappedRows.reduce<Record<string, number>>((acc, row) => {
        if (row.seqId != null) {
          acc[row.key] = row.seqId;
        }
        return acc;
      }, {});

      const resolvedQuoteId = sanitizeQuoteId(quote.quoteId || quoteId);
      setQuoteDbId(quote.id);
      setLoadedQuoteId(resolvedQuoteId);
      if (resolvedQuoteId && typeof window !== "undefined") {
        localStorage.setItem("lastOpenedQuoteId", resolvedQuoteId);
      }
      setQuoteIdList((prev) => {
        const resolvedId = sanitizeQuoteId(quote.quoteId || quoteId);
        if (!resolvedId || prev.includes(resolvedId)) return prev;
        return sortQuoteIds([...prev, resolvedId]);
      });
      // Sync refs synchronously so an immediate edit after load saves against
      // the correct quote/sequence ids (the sync effects only run next render).
      quoteDbIdRef.current = quote.id;
      quoteSeqIdsByRowRef.current = seqIdMap;
      setQuoteSeqIdsByRow(seqIdMap);
      setTableData(mappedRows);
      setOpenRow(mappedRows.length > 0 ? mappedRows[0].key : null);
      setInventoryByRow({});
      mappedRows.forEach((row) => {
        if (row.model) fetchInventoryForRow(row.key, row.model);
      });
      setIsInConversation(Boolean(quote.inConversation));
      setCountry(String(quote.country || ""));
      setQuoteForm((prev) => ({
        ...prev,
        quoteId: resolvedQuoteId,
        ip: quote.ip || quote.ipAddress || quote.ip_address || "",
        quoteSource: quote.quoteSource || prev.quoteSource,
        quoteStatus: quote.quoteStatus || prev.quoteStatus,
        quoteSent: quote.quoteSent || "",
        quoteSentDate: quote.quoteSentDate || "",
        assignedEmail: quote.assignedEmail || "",
        representativeName: (() => {
          const email = quote.assignedEmail || "";
          if (!email) return "";
          const matched = representativeOptionsRef.current.find(
            (r) => r.email.toLowerCase() === email.toLowerCase()
          );
          return matched?.name || "";
        })(),
        createdDate: formatDateTimeValue(
          quote.createdDate || quote.createdAt || quote.created_at,
          getNowDateTime(),
        ),
        contactName: quote.contactName || "",
        contactEmail: quote.contactEmail || "",
        phone1: quote.phone1 || "",
        phone2: quote.phone2 || "",
        mobile: quote.mobile || "",
        fax: quote.fax || "",
        companyName: quote.companyName || "",
        customerComments: quote.customerComments || "",
        notes: quote.salesInfo || quote.notes || "",
        optionsRequested: quote.optionsRequested || "",
        emailOutOfStock: quote.emailOutOfStock || "",
        firstFollowUpDate: quote.firstFollowUpDate || "",
        secondFollowUpDate: quote.secondFollowUpDate || "",
        finalFollowUpDate: quote.finalFollowUpDate || "",
        subStatus: quote.subStatus || "",
        grossMargin: quote.grossMargin != null ? String(quote.grossMargin) : "",
      }));
      lastSavedSubStatusRef.current = quote.subStatus || "";
      lastSavedQuoteSentRef.current = quote.quoteSent || "";
      setIsDirty(false);
    } catch (error: any) {
      if (requestId !== loadQuoteRequestIdRef.current) return;

      const errorMessage = String(
        error?.response?.data?.message || "",
      ).toLowerCase();
      const isDeletedLookup =
        deletedQuoteIds.has(quoteId) ||
        error?.response?.status === 410 ||
        errorMessage.includes("deleted");
      if (isDeletedLookup) {
        message.warning(`Quote ID ${quoteId} is deleted.`);
      } else if (error?.response?.status === 404) {
        resetQuoteForNewId();
        message.warning(`Quote ID ${quoteId} not found.`);
      } else {
        message.error(error?.response?.data?.message || "Failed to load quote");
      }
    } finally {
      if (requestId === loadQuoteRequestIdRef.current) {
        setIsHydratingQuote(false);
        setIsLoadingQuoteById(false);
      }
    }
  };

  const handleQuoteIdChange = (value: string) => {
    setQuoteForm((prev) => ({
      ...prev,
      quoteId: value,
    }));
    setIsDirty(false);
  };

  const maybeLoadQuoteById = () => {
    const currentQuoteId = sanitizeQuoteId(quoteForm.quoteId);
    if (!currentQuoteId) return;
    if (currentQuoteId === loadedQuoteId) return;
    loadQuoteByQuoteId(currentQuoteId);
  };

  const emptyFindRow: LineItem = { key: "find-1", manufacturer: "", model: "", options: "", qty: 1, price: "", stdCal: "", status: "", description: "" };

  const enterFindMode = () => {
    setSavedFormBeforeFind({ ...quoteForm });
    setSavedTableDataBeforeFind([...tableData]);
    setIsFindResultsActive(false);
    clearPersistedFindState();
    setFindCriteria({});
    setAppliedFindCriteria({});
    setQuoteForm((prev) => Object.fromEntries(Object.keys(prev).map((k) => [k, ""])) as any);
    setTableData([emptyFindRow]);
    setOpenRow("find-1");
    setIsFindMode(true);
  };

  const cancelFind = () => {
    // If a record is currently open from the find results, keep it open instead
    // of reverting to the record that was open before Find started. Only restore
    // the pre-find record when cancelling from the find-entry (criteria) screen.
    const findResultQuoteId = sanitizeQuoteId(loadedQuoteId || quoteForm.quoteId);
    if (isFindResultsActive && findResultQuoteId) {
      loadQuoteByQuoteId(findResultQuoteId);
    } else if (savedFormBeforeFind) {
      setQuoteForm(savedFormBeforeFind);
      if (savedTableDataBeforeFind.length > 0) {
        setTableData(savedTableDataBeforeFind);
        setOpenRow(savedTableDataBeforeFind[0]?.key ?? null);
      } else if (findResultQuoteId) {
        loadQuoteByQuoteId(findResultQuoteId);
      }
    }
    setFindCriteria({});
    setAppliedFindCriteria({});
    setIsFindResultsActive(false);
    clearPersistedFindState();
    setIsFindMode(false);
    loadQuoteNavigatorAndStats([]);
  };

  const performFind = async () => {
    const normalizeFindValue = (value: any) => String(value || "").trim();
    const normalizeComparableText = (value: any) =>
      normalizeFindValue(value).toLowerCase();
    const normalizeStatusValue = (value: any) =>
      normalizeFindValue(value)
        .toLowerCase()
        .replace(/[\s_-]+/g, "");
    const normalizeDateValue = (value: any) => {
      const raw = normalizeFindValue(value);
      if (!raw) return "";
      const parsed = dayjs(raw);
      return parsed.isValid() ? parsed.format("MM/DD/YYYY") : raw;
    };

    const hasAnyCriteria = Object.values(findCriteria).some((value) =>
      Boolean(normalizeFindValue(value)),
    );
    if (!hasAnyCriteria) { cancelFind(); return; }
    try {
      const quotesById = new Map<string, any>();
      const requestCriteria = Object.fromEntries(
        Object.entries(findCriteria).filter(([, value]) =>
          Boolean(normalizeFindValue(value)),
        ),
      );
      const result = await getQuotes(requestCriteria as any);

      (result.data || []).forEach((q: any) => {
        const id = q.quoteId || q.id;
        if (!id) return;
        quotesById.set(String(id), q);
      });

      let allIds = Array.from(quotesById.keys());

      const matchesExactFindCriteria = (quote: any) => {
        const quoteDate = normalizeDateValue(quote?.createdDate || quote?.createdAt || quote?.created_at);
        const criteriaDate = normalizeDateValue(findCriteria.createdDate);
        if (criteriaDate && quoteDate !== criteriaDate) return false;

        const criteriaSource = normalizeComparableText(findCriteria.quoteSource);
        const quoteSource = normalizeComparableText(quote?.quoteSource);
        if (criteriaSource && quoteSource !== criteriaSource) return false;

        const criteriaStatus = normalizeComparableText(findCriteria.quoteStatus);
        const quoteStatus = normalizeComparableText(quote?.quoteStatus);
        if (criteriaStatus && quoteStatus !== criteriaStatus) return false;

        const criteriaSubStatus = normalizeStatusValue(findCriteria.subStatus);
        const quoteSubStatus = normalizeStatusValue(
          quote?.subStatus || quote?.dealerQuoted,
        );
        if (criteriaSubStatus && quoteSubStatus !== criteriaSubStatus) return false;

        return true;
      };

      allIds = sortQuoteIds(allIds.filter((id) => matchesExactFindCriteria(quotesById.get(id))));

      if (allIds.length === 0) { message.info("No records found"); return; }
      if (typeof window !== "undefined") {
        localStorage.setItem(
          FIND_STATE_STORAGE_KEY,
          JSON.stringify({
            ids: allIds,
            criteria: findCriteria,
            row: {
              manufacturer: findCriteria.manufacturer || "",
              model: findCriteria.model || "",
              options: findCriteria.options || "",
              description: findCriteria.description || "",
            },
          }),
        );
      }
      setAppliedFindCriteria({ ...findCriteria });
      setIsFindResultsActive(true);
      setIsNotQuotedFilterActive(false);
      setIsExpectingPoFilterActive(false);
      setIsInConversationFilterActive(false);
      setAllQuoteIdList(allIds);
      loadQuoteByQuoteId(allIds[0]);
    } catch {
      message.error("Find failed");
    }
  };

  useEffect(() => {
    const modelFromUrl = searchParams.get("model");
    if (modelFromUrl) {
      const criteria = { model: modelFromUrl };
      setFindCriteria(criteria);
      setAppliedFindCriteria(criteria);
      setIsFindMode(false);
      setIsFindResultsActive(false);

      getQuotes(criteria as any)
        .then((result) => {
          const quotesById = new Map<string, any>();
          (result.data || []).forEach((q: any) => {
            const id = q.quoteId || q.id;
            if (id) quotesById.set(String(id), q);
          });
          const allIds = sortQuoteIds(Array.from(quotesById.keys()));
          if (allIds.length === 0) {
            message.info("No records found for model: " + modelFromUrl);
            return;
          }
          if (typeof window !== "undefined") {
            localStorage.setItem(
              FIND_STATE_STORAGE_KEY,
              JSON.stringify({
                ids: allIds,
                criteria,
                row: { manufacturer: "", model: modelFromUrl, options: "", description: "" },
              }),
            );
          }
          setAppliedFindCriteria(criteria);
          setIsFindResultsActive(true);
          setIsNotQuotedFilterActive(false);
          setIsExpectingPoFilterActive(false);
          setIsInConversationFilterActive(false);
          setAllQuoteIdList(allIds);
          loadQuoteByQuoteId(allIds[0]);
        })
        .catch(() => message.error("Failed to filter by model"));
      return;
    }

    const quoteIdFromUrl = sanitizeQuoteId(searchParams.get("quoteId"));
    const isNewMode = searchParams.get("mode") === "new";
    const lastOpenedQuoteId = sanitizeQuoteId(
      typeof window !== "undefined"
        ? localStorage.getItem("lastOpenedQuoteId")
        : "",
    );

    if (quoteIdFromUrl) {
      setQuoteForm((prev) =>
        prev.quoteId === quoteIdFromUrl
          ? prev
          : { ...prev, quoteId: quoteIdFromUrl },
      );
      if (quoteIdFromUrl !== loadedQuoteId) {
        loadQuoteByQuoteId(quoteIdFromUrl);
      }
      return;
    }

    if (isNewMode) {
      handleNewQuoteRecord();
      return;
    }

    if (lastOpenedQuoteId && lastOpenedQuoteId !== loadedQuoteId) {
      setQuoteForm((prev) => ({ ...prev, quoteId: lastOpenedQuoteId }));
      loadQuoteByQuoteId(lastOpenedQuoteId);
    }
  }, []);

  useEffect(() => {
    const activeQuoteId = sanitizeQuoteId(loadedQuoteId || quoteForm.quoteId);
    const urlQuoteId = sanitizeQuoteId(searchParams.get("quoteId"));
    if (activeQuoteId !== urlQuoteId) {
      syncQuoteIdToUrl(activeQuoteId);
    }
  }, [loadedQuoteId, quoteForm.quoteId, searchParams]);

  const findClosestQuoteIndex = (quoteId: string) => {
    if (!quoteIdList.length) return -1;
    const exactIndex = quoteIdList.indexOf(quoteId);
    if (exactIndex >= 0) return exactIndex;

    const currentNum = Number(quoteId);
    if (!Number.isFinite(currentNum)) return 0;

    let closest = 0;
    let minDiff = Number.POSITIVE_INFINITY;
    quoteIdList.forEach((id, idx) => {
      const n = Number(id);
      if (!Number.isFinite(n)) return;
      const diff = Math.abs(n - currentNum);
      if (diff < minDiff) {
        minDiff = diff;
        closest = idx;
      }
    });
    return closest;
  };

  const currentNavIdx = findClosestQuoteIndex(
    normalizeQuoteId(loadedQuoteId || quoteForm.quoteId)
  );
  const isFirstRecord = quoteIdList.length === 0 || currentNavIdx <= 0;
  const isLastRecord =
    quoteIdList.length === 0 || currentNavIdx >= quoteIdList.length - 1;

  const handleQuoteArrowNavigation = async (direction: "prev" | "next") => {
    const currentId = normalizeQuoteId(loadedQuoteId || quoteForm.quoteId);
    if (!quoteIdList.length) {
      await loadQuoteNavigatorAndStats();
      return;
    }

    const currentIdx = findClosestQuoteIndex(currentId);
    if (currentIdx < 0) return;

    const targetIdx = direction === "next" ? currentIdx + 1 : currentIdx - 1;
    if (targetIdx < 0 || targetIdx >= quoteIdList.length) return;

    const targetId = quoteIdList[targetIdx];
    if (!targetId) return;
    await loadQuoteByQuoteId(targetId);
  };

  const handleToggleNotQuotedFilter = async () => {
    const nextActive = !isNotQuotedFilterActive;
    setIsNotQuotedFilterActive(nextActive);
    setIsFindResultsActive(false);
    setIsFindMode(false);
    clearPersistedFindState();
    if (nextActive) {
      setIsExpectingPoFilterActive(false);
      setIsInConversationFilterActive(false);
    }
    const nextList = nextActive ? notQuotedQuoteIdList : allQuoteIdList;

    if (!nextActive) {
      return;
    }

    if (!nextList.length) {
      message.warning("No quotes found with FQ status not yet.");
      return;
    }

    const activeQuoteId = sanitizeQuoteId(loadedQuoteId || quoteForm.quoteId);
    if (activeQuoteId && nextList.includes(activeQuoteId)) {
      return;
    }

    await loadQuoteByQuoteId(nextList[0]);
  };

  const handleToggleExpectingPoFilter = async () => {
    const nextActive = !isExpectingPoFilterActive;
    setIsExpectingPoFilterActive(nextActive);
    setIsFindResultsActive(false);
    setIsFindMode(false);
    clearPersistedFindState();
    if (nextActive) {
      setIsNotQuotedFilterActive(false);
      setIsInConversationFilterActive(false);
    }
    const nextList = nextActive ? expectingPoQuoteIdList : allQuoteIdList;

    if (!nextActive) {
      return;
    }

    if (!nextList.length) {
      message.warning("No quotes found with Expecting PO status.");
      return;
    }

    const activeQuoteId = sanitizeQuoteId(loadedQuoteId || quoteForm.quoteId);
    if (activeQuoteId && nextList.includes(activeQuoteId)) {
      return;
    }

    await loadQuoteByQuoteId(nextList[0]);
  };

  const CONV_ASSIGNED_EMAIL = "sanderson@alliancetesteq.com";

  const handleToggleInConversationFilter = async () => {
    const nextActive = !isInConversationFilterActive;
    setIsFindResultsActive(false);
    setIsFindMode(false);
    clearPersistedFindState();
    if (nextActive) {
      setIsNotQuotedFilterActive(false);
      setIsExpectingPoFilterActive(false);
      // Clear stale navigator list immediately so the count shows 0 while loading,
      // not the old unfiltered inConversation count.
      setInConversationQuoteIdList([]);
    }
    setIsInConversationFilterActive(nextActive);

    if (!nextActive) {
      return;
    }

    try {
      const result = await getQuotes({
        inConversation: true,
        assignedEmail: CONV_ASSIGNED_EMAIL,
        limit: 5000,
      });
      const ids = sortQuoteIds(
        (result.data || [])
          .map((q: any) => sanitizeQuoteId(q.quoteId || q.id))
          .filter(Boolean),
      );

      if (!ids.length) {
        setIsInConversationFilterActive(false);
        message.warning("No quotes found with In Conversation = Yes and assigned to Sanderson.");
        return;
      }

      setInConversationQuoteIdList(ids);

      const activeQuoteId = sanitizeQuoteId(loadedQuoteId || quoteForm.quoteId);
      if (activeQuoteId && ids.includes(activeQuoteId)) {
        return;
      }

      await loadQuoteByQuoteId(ids[0]);
    } catch {
      setIsInConversationFilterActive(false);
      message.error("Failed to load In Conversation filter.");
    }
  };

  const handleApplySortRules = async (rules: SortRule[]) => {
    const normalized = normalizeSortRules(rules, QUOTE_SORT_KEYS);
    setSortRules(normalized);
    const nav = await loadQuoteNavigatorAndStats(normalized);
    const activeList = isNotQuotedFilterActive
      ? nav?.notQuotedQuoteIds
      : isExpectingPoFilterActive
        ? nav?.expectingPoQuoteIds
        : isInConversationFilterActive
          ? nav?.inConversationQuoteIds
          : nav?.quoteIds;
    const targetId = activeList?.[0];
    if (targetId) loadQuoteByQuoteId(targetId);
  };

  const handleShowAll = () => {
    const hasActiveFilter =
      isFindResultsActive ||
      isNotQuotedFilterActive ||
      isExpectingPoFilterActive ||
      isInConversationFilterActive ||
      isFindMode ||
      sortRules.length > 0;

    if (!hasActiveFilter) {
      return;
    }

    // Capture whether a record is currently open from find results before we
    // clear the flag, so we can keep that record open instead of reverting to
    // the record that was open before Find started.
    const wasViewingFindResult = isFindResultsActive;
    const findResultQuoteId = sanitizeQuoteId(loadedQuoteId || quoteForm.quoteId);

    setIsFindResultsActive(false);
    setIsNotQuotedFilterActive(false);
    setIsExpectingPoFilterActive(false);
    setIsInConversationFilterActive(false);
    setIsFindMode(false);
    setSortRules([]);
    setFindCriteria({});
    setAppliedFindCriteria({});
    clearPersistedFindState();

    if (wasViewingFindResult && findResultQuoteId) {
      loadQuoteByQuoteId(findResultQuoteId);
      setSavedFormBeforeFind(null);
      setSavedTableDataBeforeFind([]);
    } else if (savedFormBeforeFind) {
      setQuoteForm(savedFormBeforeFind);
      setSavedFormBeforeFind(null);
      if (savedTableDataBeforeFind.length > 0) {
        setTableData(savedTableDataBeforeFind);
        setOpenRow(savedTableDataBeforeFind[0]?.key ?? null);
        setSavedTableDataBeforeFind([]);
      } else if (findResultQuoteId) {
        loadQuoteByQuoteId(findResultQuoteId);
      }
    }

    loadQuoteNavigatorAndStats([]);
  };

  const handleNewQuoteRecord = async () => {
    resetQuoteForNewId();
    try {
      const nextQuoteResponse = await getNextQuoteId();
      const nextId = normalizeQuoteId(nextQuoteResponse?.quoteId);
      setQuoteForm((prev) => ({
        ...prev,
        quoteId: nextId,
      }));
      syncQuoteIdToUrl(nextId, false);
    } catch (error: any) {
      message.error(
        error?.response?.data?.message || "Failed to prepare new record",
      );
    }
  };

  const handleSoftDeleteCurrentQuote = async () => {
    const currentQuoteId = normalizeQuoteId(loadedQuoteId || quoteForm.quoteId);
    if (!quoteDbId || !currentQuoteId) {
      message.warning("Load and save a record before deleting.");
      return;
    }

    try {
      await softDeleteQuote(quoteDbId);
      setDeletedQuoteIds((prev) => {
        const next = new Set(prev);
        next.add(currentQuoteId);
        return next;
      });
      // message.success(`Quote ID ${currentQuoteId} deleted.`);

      const filteredIds = quoteIdList.filter((id) => id !== currentQuoteId);
      const filteredAllIds = allQuoteIdList.filter(
        (id) => id !== currentQuoteId,
      );
      const filteredNotQuotedIds = notQuotedQuoteIdList.filter(
        (id) => id !== currentQuoteId,
      );
      const filteredExpectingPoIds = expectingPoQuoteIdList.filter(
        (id) => id !== currentQuoteId,
      );
      setQuoteIdList(filteredIds);
      setAllQuoteIdList(filteredAllIds);
      setNotQuotedQuoteIdList(filteredNotQuotedIds);
      setExpectingPoQuoteIdList(filteredExpectingPoIds);
      setRecordStats((prev) => ({
        open: filteredAllIds.length,
        total: Math.max(0, prev.total - 1),
        notQuoted:
          String(quoteForm.quoteSent || "")
            .trim()
            .toLowerCase() === "not yet"
            ? Math.max(0, prev.notQuoted - 1)
            : prev.notQuoted,
      }));

      if (filteredIds.length > 0) {
        const oldIdx = findClosestQuoteIndex(currentQuoteId);
        const fallbackIdx = Math.min(oldIdx, filteredIds.length - 1);
        const nextId = filteredIds[Math.max(0, fallbackIdx)];
        await loadQuoteByQuoteId(nextId);
      } else {
        await handleNewQuoteRecord();
      }
    } catch (error: any) {
      message.error(
        error?.response?.data?.message || "Failed to delete record",
      );
    }
  };

  const handleOpenEmailScreen = async () => {
    const activeQuoteId = sanitizeQuoteId(loadedQuoteId || quoteForm.quoteId);
    if (!activeQuoteId) {
      message.warning("Save or load a quote before opening email.");
      return;
    }

    try {
      const rawEmail = String(quoteForm.contactEmail || "").trim();
      const angleMatch = rawEmail.match(/<([^>]+)>/);
      const toEmail = angleMatch?.[1]?.trim() || rawEmail;

      const draftResponse = await createOutlookDraftFromTemplate({
        templateSlug: "quote-send-customer",
        quoteId: activeQuoteId,
        to: toEmail || undefined,
        launchMode: "desktop",
      });
      await openOutlookDraft(draftResponse);
    } catch (error: any) {
      message.error(
        error?.response?.data?.message ||
          "Outlook draft could not be prepared. Check the Outlook desktop setup.",
      );
    }
  };

  const executeSendFQ = async () => {
    const activeQuoteId = sanitizeQuoteId(loadedQuoteId || quoteForm.quoteId);
    if (!activeQuoteId) return;

    try {
      const rawEmail = String(quoteForm.contactEmail || "").trim();
      const angleMatch = rawEmail.match(/<([^>]+)>/);
      const toEmail = angleMatch?.[1]?.trim() || rawEmail;

      const now = new Date();
      const formattedDate = now.toLocaleDateString("en-US");
      const formattedTime = now
        .toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", second: "2-digit", hour12: true })
        .replace(" ", "");
      const fqStatusText = `Yes, at ${formattedDate} ${formattedTime}`;
      const fqSentDate = now.toISOString();

      setQuoteForm((prev) => ({
        ...prev,
        quoteSent: fqStatusText,
        quoteSentDate: fqSentDate,
      }));

      if (quoteDbId) {
        await updateQuote(quoteDbId, { quoteSent: fqStatusText, quoteSentDate: fqSentDate });
        lastSavedQuoteSentRef.current = fqStatusText;
        // quoteSent flips from "Not Yet"/blank to sent — drop this quote out of
        // the Not Quoted navigator list immediately instead of leaving it stale.
        await loadQuoteNavigatorAndStats();
      }

      navigate(
        `/quotations/quoteForm?mode=send-fq&quoteId=${encodeURIComponent(activeQuoteId)}`,
        {
          state: {
            autoSendFQ: true,
            templateSlug: "quote-send-customer",
            launchMode: "desktop",
            delayMs: 1500,
            toEmail: toEmail || undefined,
            quoteFormSnapshot: { ...quoteForm, quoteId: activeQuoteId, quoteSent: fqStatusText, quoteSentDate: fqSentDate },
            tableDataSnapshot: tableData.map((row) => ({ ...row })),
            restoredFilters: {
              isNotQuotedFilterActive,
              isExpectingPoFilterActive,
              isInConversationFilterActive,
              isFindResultsActive,
              appliedFindCriteria,
            },
          },
        },
      );
    } catch (error: any) {
      message.error(
        error?.response?.data?.message ||
          "Could not prepare FQ. Please try again.",
      );
    }
  };

  const handleSendFQ = () => {
    const activeQuoteId = sanitizeQuoteId(loadedQuoteId || quoteForm.quoteId);
    if (!activeQuoteId) {
      message.warning("Save or load a quote before sending FQ.");
      return;
    }

    const alreadySent = quoteForm.quoteSent && !/^not yet$/i.test(quoteForm.quoteSent.trim());
    if (alreadySent) {
      setShowFQResendConfirm(true);
    } else {
      executeSendFQ();
    }
  };

  const handleFirstFollowUp = async () => {
    const activeQuoteId = sanitizeQuoteId(loadedQuoteId || quoteForm.quoteId);
    if (!activeQuoteId) {
      message.warning("Save or load a quote before sending follow-up email.");
      return;
    }

    try {
      const rawEmail = String(quoteForm.contactEmail || "").trim();
      const angleMatch = rawEmail.match(/<([^>]+)>/);
      const toEmail = angleMatch?.[1]?.trim() || rawEmail;

      const draftResponse = await createOutlookDraftFromTemplate({
        templateSlug: "first-follow-up-email",
        quoteId: activeQuoteId,
        to: toEmail || undefined,
        launchMode: "desktop",
      });

      // Update the first follow-up date
      const sentAt = new Date().toISOString();
      setQuoteForm((prev) => ({
        ...prev,
        firstFollowUpDate: sentAt,
      }));

      await openOutlookDraft(draftResponse);
    } catch (error: any) {
      message.error(
        error?.response?.data?.message ||
          "Outlook draft could not be prepared. Check the Outlook desktop setup.",
      );
    }
  };

  const handleSecondFollowUp = async () => {
    const activeQuoteId = sanitizeQuoteId(loadedQuoteId || quoteForm.quoteId);
    if (!activeQuoteId) {
      message.warning("Save or load a quote before sending follow-up email.");
      return;
    }

    try {
      const rawEmail = String(quoteForm.contactEmail || "").trim();
      const angleMatch = rawEmail.match(/<([^>]+)>/);
      const toEmail = angleMatch?.[1]?.trim() || rawEmail;

      const draftResponse = await createOutlookDraftFromTemplate({
        templateSlug: "second-follow-up-email",
        quoteId: activeQuoteId,
        to: toEmail || undefined,
        launchMode: "desktop",
      });

      // Update the second follow-up date
      const sentAt = new Date().toISOString();
      setQuoteForm((prev) => ({
        ...prev,
        secondFollowUpDate: sentAt,
      }));

      await openOutlookDraft(draftResponse);
    } catch (error: any) {
      message.error(
        error?.response?.data?.message ||
          "Outlook draft could not be prepared. Check the Outlook desktop setup.",
      );
    }
  };

  const handleFinalFollowUp = async () => {
    const activeQuoteId = sanitizeQuoteId(loadedQuoteId || quoteForm.quoteId);
    if (!activeQuoteId) {
      message.warning("Save or load a quote before sending follow-up email.");
      return;
    }

    try {
      const rawEmail = String(quoteForm.contactEmail || "").trim();
      const angleMatch = rawEmail.match(/<([^>]+)>/);
      const toEmail = angleMatch?.[1]?.trim() || rawEmail;

      const draftResponse = await createOutlookDraftFromTemplate({
        templateSlug: "third-follow-up-email",
        quoteId: activeQuoteId,
        to: toEmail || undefined,
        launchMode: "desktop",
      });

      // Update the final follow-up date
      const sentAt = new Date().toISOString();
      setQuoteForm((prev) => ({
        ...prev,
        finalFollowUpDate: sentAt,
      }));

      await openOutlookDraft(draftResponse);
    } catch (error: any) {
      message.error(
        error?.response?.data?.message ||
          "Outlook draft could not be prepared. Check the Outlook desktop setup.",
      );
    }
  };

  const handleLooking = async () => {
    const activeQuoteId = sanitizeQuoteId(loadedQuoteId || quoteForm.quoteId);
    if (!activeQuoteId) {
      message.warning("Save or load a quote before sending looking email.");
      return;
    }
    try {
      const rawEmail = String(quoteForm.contactEmail || "").trim();
      const angleMatch = rawEmail.match(/<([^>]+)>/);
      const toEmail = angleMatch?.[1]?.trim() || rawEmail;
      const draftResponse = await createOutlookDraftFromTemplate({
        templateSlug: "looking-email",
        quoteId: activeQuoteId,
        to: toEmail || undefined,
        launchMode: "desktop",
      });
      await openOutlookDraft(draftResponse);
    } catch (error: any) {
      message.error(
        error?.response?.data?.message ||
          "Outlook draft could not be prepared. Check the Outlook desktop setup.",
      );
    }
  };

  const handleOutOfStock = async () => {
    const activeQuoteId = sanitizeQuoteId(loadedQuoteId || quoteForm.quoteId);
    if (!activeQuoteId) {
      message.warning("Save or load a quote before sending out of stock email.");
      return;
    }
    try {
      const rawEmail = String(quoteForm.contactEmail || "").trim();
      const angleMatch = rawEmail.match(/<([^>]+)>/);
      const toEmail = angleMatch?.[1]?.trim() || rawEmail;
      const draftResponse = await createOutlookDraftFromTemplate({
        templateSlug: "out-of-stock-email",
        quoteId: activeQuoteId,
        to: toEmail || undefined,
        launchMode: "desktop",
      });
      await openOutlookDraft(draftResponse);
      onQuoteFormChange("emailOutOfStock", dayjs().format("MM/DD/YYYY"));
    } catch (error: any) {
      message.error(
        error?.response?.data?.message ||
          "Outlook draft could not be prepared. Check the Outlook desktop setup.",
      );
    }
  };

  const parseCurrencyValue = (value: string) => {
    const parsed = Number(String(value || "").replace(/[^0-9.-]/g, ""));
    return Number.isNaN(parsed) ? 0 : parsed;
  };

  const getResolvedQuoteId = () => {
    const current = String(quoteForm.quoteId || "").trim();
    return current;
  };

  const buildQuotePayload = () => {
    const totalDollars = tableData.reduce(
      (sum, item) =>
        sum + parseCurrencyValue(item.price) * (Number(item.qty) || 0),
      0,
    );
    const notesValue = String(quoteForm.notes || "");
    const salesInfoValue =
      notesValue.length > 150 ? notesValue.slice(0, 150) : notesValue;

    return {
      quoteId: getResolvedQuoteId(),
      createdDate:
        quoteForm.createdDate || getNowDateTime(),
      ip: quoteForm.ip || "",
      quoteSource:
        quoteForm.quoteSource || sourceOptions[0]?.value || "Website",
      quoteStatus:
        quoteForm.quoteStatus || statusOptions[0]?.value || "Expecting PO",
      quoteSent: quoteForm.quoteSent || "",
      quoteSentDate: quoteForm.quoteSentDate || null,
      assignedEmail: quoteForm.assignedEmail || "",
      contactName: quoteForm.contactName || "",
      contactEmail: quoteForm.contactEmail || "",
      phone1: quoteForm.phone1 || "",
      phone2: quoteForm.phone2 || "",
      mobile: quoteForm.mobile || "",
      fax: quoteForm.fax || "",
      companyName: quoteForm.companyName || "",
      customerComments: quoteForm.customerComments || "",
      notes: notesValue,
      salesInfo: salesInfoValue,
      optionsRequested: quoteForm.optionsRequested || null,
      emailOutOfStock: quoteForm.emailOutOfStock || null,
      country: country || null,
      firstFollowUpDate: quoteForm.firstFollowUpDate || null,
      secondFollowUpDate: quoteForm.secondFollowUpDate || null,
      finalFollowUpDate: quoteForm.finalFollowUpDate || null,
      inConversation: isInConversation,
      dollars: totalDollars,
      subStatus: quoteForm.subStatus || "",
      grossMargin: parseCurrencyValue(quoteForm.grossMargin) || null,
    };
  };

  const syncQuoteSequenceRows = async (quoteId: string) => {
    if (!quoteId) return;

    // Process rows sequentially so a freshly-created sequence id is recorded
    // (in quoteSeqIdsByRowRef) BEFORE the next row/next save is processed.
    // Reading the decision from the ref — not the lagging state — is what
    // guarantees an already-saved row is UPDATED, never created twice.
    // Process rows that need CREATE before those that need UPDATE, so a newly
    // added model's POST fires ahead of the existing rows' PUT calls.
    const rowsToProcess = [...tableData].sort((a, b) => {
      const aSaved = (quoteSeqIdsByRowRef.current[a.key] ?? a.seqId) ? 1 : 0;
      const bSaved = (quoteSeqIdsByRowRef.current[b.key] ?? b.seqId) ? 1 : 0;
      return aSaved - bSaved; // 0 = needs create (first), 1 = needs update
    });

    for (const row of rowsToProcess) {
      const payload = {
        quoteId,
        createdDate: quoteForm.createdDate || new Date().toISOString(),
        eqBrand: row.manufacturer || "",
        eqModel: row.model || "",
        options: row.options || "",
        eqDescription: row.description || "",
        quantity: Number(row.qty) || 0,
        price: parseCurrencyValue(row.price),
        priceAutomatic: parseCurrencyValue(row.stdCal),
        priceString: row.price || "",
        wtbSentCalculated: row.status || "",
      };

      // Decide create vs update from the STABLE DB id, not only the positional
      // key map. The positional map lives in memory and is keyed by row index,
      // so after a remount (refresh / navigate back) or a key shift it can miss
      // and wrongly create a duplicate. `row.seqId` is the real sequence id that
      // was loaded from the server onto the row, so it survives those cases.
      const existingSeqId = quoteSeqIdsByRowRef.current[row.key] ?? row.seqId;
      if (existingSeqId) {
        await updateQuoteSequence(existingSeqId, payload);
        // Keep the map aligned in case the id came from row.seqId.
        if (quoteSeqIdsByRowRef.current[row.key] !== existingSeqId) {
          quoteSeqIdsByRowRef.current = {
            ...quoteSeqIdsByRowRef.current,
            [row.key]: existingSeqId,
          };
          setQuoteSeqIdsByRow((prev) => ({ ...prev, [row.key]: existingSeqId }));
        }
        continue;
      }

      // A previous (overlapping) save is already creating this exact row. Skip
      // it here — creating again would produce a duplicate. The in-flight save
      // records the id; a later save then UPDATES via the branch above.
      if (creatingRowsRef.current.has(row.key)) {
        continue;
      }

      creatingRowsRef.current.add(row.key);
      let created;
      try {
        created = await createQuoteSequence(payload);
      } finally {
        creatingRowsRef.current.delete(row.key);
      }
      // Record the new id immediately (ref) so any subsequent save sees it,
      // mirror it into state, and write it back onto the row so a later closure
      // / remount recognizes the row as already-saved and never re-creates it.
      quoteSeqIdsByRowRef.current = {
        ...quoteSeqIdsByRowRef.current,
        [row.key]: created.id,
      };
      setQuoteSeqIdsByRow((prev) => ({
        ...prev,
        [row.key]: created.id,
      }));
      row.seqId = created.id;
      setTableData((prev) =>
        prev.map((r) => (r.key === row.key ? { ...r, seqId: created.id } : r)),
      );
    }
  };

  const persistQuote = async () => {
    // Single-flight lock: if a save is already running, just mark that another
    // save is needed and bail. Callers that need the data actually flushed
    // (not just requeued) should await waitForPendingSave() instead of relying
    // on this call's return.
    if (isSavingRef.current) {
      pendingSaveRef.current = true;
      return;
    }
    isSavingRef.current = true;
    const runPromise = persistQuoteRun();
    savingPromiseRef.current = runPromise;
    try {
      await runPromise;
    } finally {
      if (savingPromiseRef.current === runPromise) {
        savingPromiseRef.current = null;
      }
    }
  };

  // Waits for an in-flight save (if any) to fully finish, including any
  // follow-up save it queued via pendingSaveRef. Used before navigating away
  // from the current record so a delayed autosave never lands on the record
  // we're navigating TO.
  const waitForPendingSave = async () => {
    while (savingPromiseRef.current) {
      await savingPromiseRef.current;
    }
  };

  const persistQuoteRun = async () => {
    // Consume the current dirty state up-front. Any edit made WHILE this save
    // runs will set isDirty back to true, so the debounced effect fires a fresh
    // save afterwards with the latest on-screen data — nothing is lost.
    setIsDirty(false);

    try {
      setIsAutoSaving(true);
      let resolvedQuoteId = getResolvedQuoteId();
      if (!resolvedQuoteId) {
        const nextQuoteResponse = await getNextQuoteId();
        resolvedQuoteId = String(nextQuoteResponse?.quoteId || "");
        if (resolvedQuoteId) {
          setQuoteForm((prev) => ({ ...prev, quoteId: resolvedQuoteId }));
        }
      }

      const payload = {
        ...buildQuotePayload(),
        quoteId: resolvedQuoteId,
        items: tableData.map((row) => ({ eqModel: row.model })),
      };
      const quoteId = payload.quoteId;

      // Use the ref (instant) — not quoteDbId state (lagging) — so a second save
      // can never create a duplicate quote while the first create is in flight.
      if (!quoteDbIdRef.current) {
        const created = await createQuote(payload);
        quoteDbIdRef.current = created.id; // record synchronously, before any await
        const persistedQuoteId = sanitizeQuoteId(
          created.quoteId || quoteId || "",
        );
        setQuoteDbId(created.id);
        setLoadedQuoteId(persistedQuoteId);
        if (persistedQuoteId && typeof window !== "undefined") {
          localStorage.setItem("lastOpenedQuoteId", persistedQuoteId);
        }
        if (created.quoteId && created.quoteId !== quoteForm.quoteId) {
          setQuoteForm((prev) => ({
            ...prev,
            quoteId: created.quoteId || quoteId,
          }));
        }
        await syncQuoteSequenceRows(created.quoteId || quoteId);
        await loadQuoteNavigatorAndStats();
        // message.success("Quote created and autosave enabled");
      } else {
        // Persist the line-item rows FIRST (new models get created, existing
        // ones updated) before updating the quote header, so the model create
        // call fires ahead of the quote/sequence updates.
        await syncQuoteSequenceRows(quoteId);
        await updateQuote(quoteDbIdRef.current, payload);
        const persistedQuoteId = sanitizeQuoteId(quoteId);
        if (persistedQuoteId && typeof window !== "undefined") {
          localStorage.setItem("lastOpenedQuoteId", persistedQuoteId);
        }
        // subStatus (Active/Inactive) and quoteSent both affect navigator list
        // membership (e.g. not-quoted) — refresh so a just-deactivated or
        // just-sent quote drops out immediately instead of lingering until an
        // unrelated refresh.
        if (
          payload.subStatus !== lastSavedSubStatusRef.current ||
          payload.quoteSent !== lastSavedQuoteSentRef.current
        ) {
          lastSavedSubStatusRef.current = payload.subStatus;
          lastSavedQuoteSentRef.current = payload.quoteSent;
          await loadQuoteNavigatorAndStats();
        }
      }
    } catch (error: any) {
      // Save failed — keep the data marked dirty so it retries on the next cycle.
      setIsDirty(true);
      message.error(error?.response?.data?.message || "Auto save failed");
    } finally {
      setIsAutoSaving(false);
      isSavingRef.current = false;
      // A save was requested while this one was running (concurrent attempt
      // bailed and set this flag). Run it now, still under the same tracked
      // promise chain, so waitForPendingSave() actually waits for it instead
      // of returning early while a fresh save is about to start — never
      // lost, never duplicated, and never missed by a navigation flush.
      if (pendingSaveRef.current) {
        pendingSaveRef.current = false;
        setIsDirty(true);
        isSavingRef.current = true;
        await persistQuoteRun();
      }
    }
  };

  useEffect(() => {
    if (!isDirty || isHydratingQuote || isLoadingQuoteById) return;
    // Pending quotes are reviewed, not edited. Autosaving one would persist the
    // previewed quoteId onto the record, which must only happen at approval.
    if (isViewingPending) return;

    const timer = setTimeout(() => {
      persistQuote();
    }, 800);

    return () => clearTimeout(timer);
  }, [
    quoteForm,
    country,
    isInConversation,
    tableData,
    isDirty,
    isHydratingQuote,
    isLoadingQuoteById,
    isViewingPending,
  ]);

  // Add these functions
  const handleEditStatus = (index: number) => {
    setEditingStatus({ index, value: statusOptions[index].label });
  };

  const handleSaveStatus = async () => {
    if (editingStatus.index < 0 || !editingStatus.value.trim()) return;
    const targetStatus = statusOptions[editingStatus.index];
    if (!targetStatus?.id) return;

    try {
      await updateStatus(targetStatus.id, {
        statusName: editingStatus.value.trim(),
        type: STATUS_TYPE_QUOTE,
      });
      // message.success("Status updated successfully");
      setEditingStatus({ index: -1, value: "" });
      await refreshQuoteStatuses();
    } catch (error: any) {
      message.error(
        error?.response?.data?.message || "Failed to update status",
      );
    }
  };

  const handleAddStatus = async () => {
    if (!newStatus.trim()) return;
    try {
      await createStatus({
        statusName: newStatus.trim(),
        type: STATUS_TYPE_QUOTE,
      });
      // message.success("Status added successfully");
      setNewStatus("");
      await refreshQuoteStatuses();
    } catch (error: any) {
      message.error(error?.response?.data?.message || "Failed to add status");
    }
  };

  const handleDeleteStatus = async (index: number) => {
    const targetStatus = statusOptions[index];
    if (!targetStatus?.id) return;
    try {
      await deleteStatus(targetStatus.id);
      // message.success("Status deleted successfully");
      await refreshQuoteStatuses();
    } catch (error: any) {
      message.error(
        error?.response?.data?.message || "Failed to delete status",
      );
    }
  };
  const handleCellChange = (key: string, field: keyof LineItem, value: any) => {
    setTableData((prev) =>
      prev.map((item) =>
        item.key === key ? { ...item, [field]: value } : item,
      ),
    );
    setIsDirty(true);
    if (field === "model") {
      fetchInventoryForRow(key, value);
    }
  };

  const fetchInventoryForRow = async (rowKey: string, model: string) => {
    const m = String(model || "").trim();
    if (!m) {
      setInventoryByRow((prev) => ({ ...prev, [rowKey]: [] }));
      return;
    }
    try {
      const res = await getInventories({ model: m, limit: 50 });
      const rows = Array.isArray(res?.data) ? res.data : [];
      setInventoryByRow((prev) => ({ ...prev, [rowKey]: rows }));
    } catch {
      setInventoryByRow((prev) => ({ ...prev, [rowKey]: [] }));
    }
  };

  const buildEquipmentSearchQuery = (row: LineItem) =>
    [
      String(row.manufacturer || "").trim(),
      String(row.model || "").trim(),
    ]
      .filter((value, index, arr) => value && arr.indexOf(value) === index)
      .join(" ");

  const handleAddDealerWtbForRow = async (rowKey: string) => {
    const row = tableData.find((item) => item.key === rowKey);
    if (!row) {
      message.error("Unable to find selected row");
      return;
    }

    const quoteIdValue = String(
      quoteForm.quoteId || loadedQuoteId || "",
    ).trim();
    const createdValue = (() => {
      // Always stamp WTB creation with current local datetime at click-time.
      const now = new Date();
      const y = now.getFullYear();
      const m = String(now.getMonth() + 1).padStart(2, "0");
      const d = String(now.getDate()).padStart(2, "0");
      const hh = String(now.getHours()).padStart(2, "0");
      const mm = String(now.getMinutes()).padStart(2, "0");
      const ss = String(now.getSeconds()).padStart(2, "0");
      return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
    })();

    try {
      await createQuoteWtb({
        created: createdValue,
        eqBrand: row.manufacturer || "",
        eqModel: row.model || "",
        eqOptions: row.options || "",
        status: "Active",
        type: "WTB",
        source: "",
        keepAlive: "No",
        priority: "5",
        recordId: quoteIdValue || undefined,
      });
      // message.success("Added to Quotes WTB");
    } catch (error: any) {
      message.error(
        error?.response?.data?.message || "Failed to add Quotes WTB entry",
      );
    }
  };

  const handleDuplicateCurrentQuote = async () => {
    const currentQuoteId = sanitizeQuoteId(loadedQuoteId || quoteForm.quoteId);
    if (!currentQuoteId) {
      message.warning("Load a quote before duplicating.");
      return;
    }

    try {
      const nextQuoteResponse = await getNextQuoteId();
      const nextQuoteId = normalizeQuoteId(nextQuoteResponse?.quoteId);
      if (!nextQuoteId) {
        message.warning("Unable to generate the next quote ID.");
        return;
      }

      const duplicatePayload = {
        ...buildQuotePayload(),
        quoteId: nextQuoteId,
        createdDate: getNowDateTime(),
        quoteSent: "",
        quoteSentDate: null,
        firstFollowUpDate: null,
        secondFollowUpDate: null,
        finalFollowUpDate: null,
      };

      await createQuote(duplicatePayload);

      await Promise.all(
        tableData.map((row) =>
          createQuoteSequence({
            quoteId: nextQuoteId,
            createdDate:
              duplicatePayload.createdDate || new Date().toISOString(),
            eqBrand: row.manufacturer || "",
            eqModel: row.model || "",
            options: row.options || "",
            eqDescription: row.description || "",
            quantity: Number(row.qty) || 0,
            price: parseCurrencyValue(row.price),
            priceAutomatic: parseCurrencyValue(row.stdCal),
            priceString: row.price || "",
            wtbSentCalculated: row.status || "",
          }),
        ),
      );

      await loadQuoteNavigatorAndStats();
      await loadQuoteByQuoteId(nextQuoteId);
      // message.success(`Quote duplicated to ${nextQuoteId}`);
    } catch (error: any) {
      message.error(
        error?.response?.data?.message || "Failed to duplicate quote",
      );
    }
  };

  // Calibration labs that receive the calibration request (BCC).
  const CAL_LABS_BCC = [
    "934 services <service934@outlook.com>",
    "Wally Gynn <wally.gynn@tmicalibration.com>",
    "service@custom-cal.com",
    "'Customer Service FL' <cs.fl@techmaster.us>",
    "'Steven Everitt' <steven.everitt@microprecision.com>",
    "Ryan@HayesInstruments.com",
  ].join(";");

  const handleAddCalForRow = (rowKey: string) => {
    const row = tableData.find((item) => item.key === rowKey);
    if (!row) {
      message.error("Unable to find selected row");
      return;
    }

    const quoteIdValue = String(
      quoteForm.quoteId || loadedQuoteId || "",
    ).trim();

    // Request is sent to Sales, with all calibration labs in BCC.
    const toEmail = "sanderson@alliancetesteq.com";

    const subject = `Calibration Request - #${quoteIdValue}`;
    const body = [
      "Hello,",
      "",
      "Please send quote for calibration with data and standard calibration without data. Please make sure you have all equipment needed to calibrate if a module or other before you quote it.",
      "",
      `Manu: ${row.manufacturer || ""}`,
      "",
      `Model: ${row.model || ""}`,
      "",
      `Description: ${row.description || ""}`,
      "",
      `Options: ${row.options || ""}`,
      "",
      "Sean Anderson",
      "Sales Manager",
      "",
      "Alliance Test Equipment, Inc.",
      "Webster, MA 01570 USA",
      "Tel: 508-671-9970",
      "www.alliancetesteq.com",
    ].join("\n");

    const mailtoUrl =
      `mailto:${encodeURIComponent(toEmail)}` +
      `?bcc=${encodeURIComponent(CAL_LABS_BCC)}` +
      `&subject=${encodeURIComponent(subject)}` +
      `&body=${encodeURIComponent(body)}`;

    // Trigger via a temporary anchor — more reliable than window.location.href
    // for opening the default mail client across browsers.
    const link = document.createElement("a");
    link.href = mailtoUrl;
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleOpenResponsesForRow = (rowKey: string) => {
    setOpenRow(rowKey);
    setResponsesTabKey("1");
    setResponsesLoading(true);
    setResponsesRefreshKey((k) => k + 1);
  };

  const handleAddRow = () => {
    const maxKey = tableData.reduce((max, row) => {
      const n = Number(row.key);
      return Number.isFinite(n) && n > max ? n : max;
    }, 0);
    const newKey = String(maxKey + 1);
    const newRow: LineItem = {
      key: newKey,
      manufacturer: "",
      model: "",
      options: "",
      qty: 1,
      price: "$0.00",
      stdCal: "$0.00",
      status: "New",
      description: "",
    };
    setTableData([...tableData, newRow]);
    setOpenRow(newKey); // Auto-open the new row
    setIsDirty(true);
  };

  const handleDeleteRow = async (keyToDelete: string) => {
    const existingSeqId = quoteSeqIdsByRow[keyToDelete];
    if (existingSeqId) {
      try {
        await deleteQuoteSequence(existingSeqId);
      } catch (error) {
        console.error("Failed to delete quote sequence row", error);
      }
      const nextRefMap = { ...quoteSeqIdsByRowRef.current };
      delete nextRefMap[keyToDelete];
      quoteSeqIdsByRowRef.current = nextRefMap;
      setQuoteSeqIdsByRow((prev) => {
        const next = { ...prev };
        delete next[keyToDelete];
        return next;
      });
    }

    setTableData((prev) => prev.filter((item) => item.key !== keyToDelete));
    // If we're deleting the currently open row, open another one
    if (openRow === keyToDelete) {
      const remainingItems = tableData.filter(
        (item) => item.key !== keyToDelete,
      );
      if (remainingItems.length > 0) {
        setOpenRow(remainingItems[0].key);
      } else {
        setOpenRow(null);
      }
    }
    setIsDirty(true);
  };

  const loadManufacturers = async () => {
    try {
      const data = await getManufacturers();
      setManufacturers(data);
      const options = data.map((m: Manufacturer) => ({
        value: m.name,
        label: m.name,
      }));
      setManufacturerOptions(options);
    } catch (error: any) {
      message.error(
        error?.response?.data?.message || "Failed to load manufacturers",
      );
    }
  };

  const handleAddManufacturer = async () => {
    if (!newManufacturerName.trim()) {
      message.warning("Please enter a manufacturer name");
      return;
    }

    try {
      await createManufacturer(newManufacturerName.trim());
      // message.success("Manufacturer added successfully");
      setNewManufacturerName("");
      await loadManufacturers();
    } catch (error: any) {
      message.error(
        error?.response?.data?.message || "Failed to add manufacturer",
      );
    }
  };

  const handleUpdateManufacturer = async () => {
    if (!editingManufacturer || !editingManufacturer.name.trim()) {
      message.warning("Please enter a manufacturer name");
      return;
    }

    try {
      await updateManufacturer(
        editingManufacturer.id,
        editingManufacturer.name.trim(),
      );
      // message.success("Manufacturer updated successfully");
      setEditingManufacturer(null);
      await loadManufacturers();
    } catch (error: any) {
      message.error(
        error?.response?.data?.message || "Failed to update manufacturer",
      );
    }
  };

  // Add this helper function to check if manufacturer is used in any quote
  const isManufacturerInUse = async (manufacturerName: string) => {
    // Check current table data
    if (tableData.some((row) => row.manufacturer === manufacturerName)) {
      return true;
    }

    // Optional: Check database for other quotes using this manufacturer
    // You might want to add an API endpoint for this
    return false;
  };

  // Update handleDeleteManufacturer to use this check
  const handleDeleteManufacturer = async (id: number, name: string) => {
    const inUse = await isManufacturerInUse(name);
    if (inUse) {
      message.warning(
        `Cannot delete "${name}" as it's being used in quotes. Please remove it from all rows first.`,
      );
      return;
    }

    try {
      await deleteManufacturer(id);
      // message.success("Manufacturer deleted successfully");
      await loadManufacturers();
    } catch (error: any) {
      message.error(
        error?.response?.data?.message || "Failed to delete manufacturer",
      );
    }
  };

  // Add useEffect to load manufacturers when component mounts
  useEffect(() => {
    loadManufacturers();
  }, []);

  const handleConversationChange = (value: boolean) => {
    setIsInConversation(value);
    setIsDirty(true);
  };

  // --- Send to Order Tracking modal ---
  const handleOpenOrderTracking = async () => {
    const firstItems = tableData.slice(0, 5);

    // Order Tracking has its own reps list (OTC Reps, via getOtcReps),
    // separate from the Quotes page's representativeOptions. Load it (if not
    // already cached) so we can match the quote's rep name against it and
    // pre-select the correct option in the modal's Rep dropdown.
    let repsList = otcReps;
    if (repsList.length === 0) {
      try {
        const res = await getOtcReps();
        repsList = Array.isArray(res?.data) ? res.data : [];
        setOtcReps(repsList);
      } catch (error) {
        // Non-blocking: Rep dropdown just stays empty if this fails.
      }
    }

    const quoteRepName = String(quoteForm.representativeName || "").trim();
    const matchedRep = findMatchingOtcRep(quoteRepName, repsList);

    const draft: OpenOrderData = {
      ...createBlankOpenOrderRecord(),
      quoteId: quoteForm.quoteId || "",
      customer: quoteForm.companyName || "",
      rep: matchedRep?.name || "",
      poDate: dayjs().format("MM/DD/YYYY"),
      gs: finalTotalAmount ? String(finalTotalAmount) : "",
      gm: quoteForm.grossMargin ? String(parseCurrencyValue(quoteForm.grossMargin)) : "",
    };
    firstItems.forEach((item, idx) => {
      const suffix = idx === 0 ? "" : String(idx + 1);
      (draft as any)[`manu${suffix}`] = item.manufacturer || "";
      (draft as any)[`model${suffix}`] = item.model || "";
      (draft as any)[`qty${suffix}`] = item.qty ? String(item.qty) : "";
    });
    setOtDraft(draft);
    setIsOrderTrackingModalOpen(true);

    if (otVendorOptions.length === 0) {
      try {
        const vendors = await getVendors();
        const list = Array.isArray(vendors) ? vendors : vendors?.data || [];
        setOtVendorOptions(
          list.map((v: any) => ({ value: v.name, label: v.name })),
        );
      } catch (error) {
        // Non-blocking: vendor dropdown just stays empty if this fails.
      }
    }

    if (otStatusOptions.length === 0) {
      try {
        const statusResponse = await getStatuses();
        const list = Array.isArray(statusResponse)
          ? statusResponse.filter((item: any) => item.type === "order_tracking")
          : [];
        setOtStatusOptions(
          list.map((item: any) => ({
            value: item.statusName,
            label: item.statusName,
          })),
        );
      } catch (error) {
        // Non-blocking: PO status dropdown just stays empty if this fails.
      }
    }

    if (otcPmts.length === 0) {
      await refreshOtcPmts();
    }
  };

  const refreshOtcPmts = async () => {
    try {
      const res = await getOtcPmts();
      setOtcPmts(Array.isArray(res?.data) ? res.data : []);
    } catch (error) {
      // Non-blocking: Pmt dropdown just stays empty if this fails.
    }
  };

  const handleOrderTrackingFieldChange = (field: keyof OpenOrderData, value: any) => {
    setOtDraft((prev) => (prev ? { ...prev, [field]: value } : prev));
  };

  const handleCancelOrderTracking = () => {
    setIsOrderTrackingModalOpen(false);
    setOtDraft(null);
  };

  const handleApproveOrderTracking = async () => {
    if (!otDraft) return;
    setIsSubmittingOrderTracking(true);
    try {
      await createOrderTracking(buildOrderTrackingCreatePayload(otDraft));
      message.success("Order tracking entry created");
      setIsOrderTrackingModalOpen(false);
      setOtDraft(null);

      if (quoteForm.grossMargin && String(quoteForm.grossMargin).trim() !== "") {
        setQuoteForm((prev) => ({ ...prev, grossMargin: "" }));
        setIsDirty(true);
        await persistQuote();
      }
    } catch (error: any) {
      message.error(
        error?.response?.data?.message || "Failed to create order tracking entry",
      );
    } finally {
      setIsSubmittingOrderTracking(false);
    }
  };

  const GRID_COLUMNS = 24; // Total columns

  const GRID_STYLE = {
    display: "grid",
    gridTemplateColumns: `repeat(${GRID_COLUMNS}, 1fr)`,
  };

  const subTotalAmount = tableData.reduce(
    (sum, item) =>
      sum + parseCurrencyValue(item.price) * (Number(item.qty) || 0),
    0,
  );
  const stdCalAmount = tableData.reduce(
    (sum, item) =>
      sum + parseCurrencyValue(item.stdCal) * (Number(item.qty) || 0),
    0,
  );
  const finalTotalAmount = subTotalAmount + stdCalAmount;
  const formatMoney = (value: number) =>
    value.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  // --- SPLIT SCREEN TABLE RENDER LOGIC ---
  const renderSplitRow = (record: LineItem, index: number) => (
    <div
      key={record.key}
      className={`flex flex-col gap-1 px-2 py-0.5 transition-colors`}
      style={{
        backgroundColor: index % 2 === 0 ? "#FFFFFF" : "#ffff99",
        borderBottom: "1px solid #BDBDBD",
      }}
    >
      {/* Mini column headers */}
      <div className="grid gap-1 text-[11px] font-black tracking-wide" style={{ ...GRID_STYLE, color: "#000000", fontWeight: 900, WebkitTextStroke: "0.25px #000000" }}>
        <div className="col-span-4">Manu</div>
        <div className="col-span-4">Model</div>
        <div className="col-span-7">Options</div>
        <div className="col-span-2">Qty</div>
        <div className="col-span-4">Price</div>
        <div className="col-span-2">Std Cal</div>
      </div>

      {/* ROW 1 */}
      <div className="grid gap-1 items-center text-[10px]" style={GRID_STYLE}>
        <div className="col-span-4">
          <Select
            showSearch
            value={isFindEntryMode ? (getFindDisplayValue("manufacturer") || undefined) : (record.manufacturer || undefined)}
            onChange={(value) => {
              if (value === "edit_manufacturer") {
                setIsManufacturerModalOpen(true);
                return;
              }
              if (isFindEntryMode) {
                setFindCriteria((p) => ({ ...p, manufacturer: String(value || "") }));
                return;
              }
              handleCellChange(record.key, "manufacturer", value);
            }}
            size="small"
            placeholder="Select manufacturer"
            className="w-full compact-select manu-bold-select"
            popupClassName="manufacturer-select-dropdown"
            filterOption={(input, option) => option?.value === "edit_manufacturer" || String(option?.label ?? "").toLowerCase().startsWith(input.toLowerCase())}
            options={[
              ...manufacturerOptions,
              { value: "separator", label: "──────────", disabled: true },
              {
                value: "edit_manufacturer",
                label: "✎ Edit Manufacturers...",
                disabled: false,
              },
            ]}
          />
        </div>
        <div className="col-span-4">
          <Input
            value={isFindEntryMode ? getFindDisplayValue("model") : record.model}
            onChange={(e) =>
              isFindEntryMode
                ? setFindCriteria((p) => ({ ...p, model: e.target.value }))
                : handleCellChange(record.key, "model", e.target.value)
            }
            size="small"
            className="w-full text-[14px] font-bold text-black h-6 px-1 py-0 bg-[#99ff99] model-table-input"
          />
        </div>
        <div className="col-span-7">
          <OptionsCellInput
            value={isFindEntryMode ? getFindDisplayValue("options") : record.options}
            onChange={(e) =>
              isFindEntryMode
                ? setFindCriteria((p) => ({ ...p, options: e.target.value }))
                : handleCellChange(record.key, "options", e.target.value)
            }
            className="w-full model-table-input options-cell-input"
          />
        </div>
        <div className="col-span-2">
          <Input
            value={record.qty.toString()}
            onChange={(e) =>
              handleCellChange(record.key, "qty", parseInt(e.target.value) || 0)
            }
            size="small"
            className="w-full text-center h-6 px-1 py-0 model-table-input options-cell-input"
          />
        </div>
        <div className="col-span-4">
          <Input
            value={record.price}
            onChange={(e) =>
              handleCellChange(record.key, "price", e.target.value)
            }
            onBlur={(e) => {
              const num = parseCurrencyValue(e.target.value);
              if (num || e.target.value.trim()) {
                handleCellChange(record.key, "price", num.toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2, maximumFractionDigits: 2 }));
              }
            }}
            size="small"
            className="w-full font-semibold h-6 px-1 py-0 model-table-input options-cell-input"
          />
        </div>
        <div className="col-span-2">
          <Input
            value={record.stdCal}
            onChange={(e) =>
              handleCellChange(record.key, "stdCal", e.target.value)
            }
            onBlur={(e) => {
              const num = parseCurrencyValue(e.target.value);
              if (num || e.target.value.trim()) {
                handleCellChange(record.key, "stdCal", num.toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2, maximumFractionDigits: 2 }));
              }
            }}
            size="small"
            className="w-full h-6 px-1 py-0 model-table-input options-cell-input"
          />
        </div>
      </div>

      {/* ROW 2 */}
      <div style={GRID_STYLE} className="gap-1 items-center text-xs">
        {/* Description - col-span-10 */}
        <div className="col-span-10">
          <OptionsCellInput
            value={isFindEntryMode ? getFindDisplayValue("description") : record.description}
            onChange={(e) =>
              isFindEntryMode
                ? setFindCriteria((p) => ({ ...p, description: e.target.value }))
                : handleCellChange(record.key, "description", e.target.value)
            }
            className="w-full font-bold text-black"
          />
        </div>

        {/* Button C */}
        <div className="col-span-1 flex justify-center">
          <Button
            type="primary"
            className="bg-[#C0C0C0] text-[9px] text-black font-bold h-5 flex items-center justify-center rounded border border-[#808080] shrink-0 shadow-sm transition-all"
            style={{ width: "14px", minWidth: "14px", padding: "0" }}
            onClick={() => {
              const modelToCopy = record.model || "";

              if (modelToCopy) {
                navigator.clipboard
                  .writeText(modelToCopy)
                  .catch(() => {
                    message.error("Failed to copy to clipboard");
                  });
              } else {
                message.warning("No model found for this record");
              }
            }}
          >
            C
          </Button>
        </div>

        {/* Setting Minus Icon */}
        <div className="col-span-1 flex justify-center">
          <img
            src={settingMinus}
            alt="settingMinus-icon"
            className="w-5 !h-5 cursor-pointer"
            onClick={() => handleDeleteRow(record.key)}
          />
        </div>

        {/* Google Icon */}
        <div className="col-span-1 flex justify-center">
          <GoogleOutlined
            style={{ color: "#3E6E9C", fontSize: "18px", cursor: "pointer" }}
            title="Search this equipment on Google"
            onClick={() => {
              const query = buildEquipmentSearchQuery(record);
              const url = query
                ? `https://www.google.com/search?q=${encodeURIComponent(query)}`
                : "https://www.google.com";
              window.open(url, "_blank");
            }}
          />
        </div>

        {/* eBay Icon */}
        <div className="col-span-1 flex justify-center">
          <img
            src={EBay}
            alt="ebay-icon"
            title="Search this equipment on eBay"
            className="w-12 h-4 cursor-pointer object-contain"
            onClick={() => {
              const query = buildEquipmentSearchQuery(record);
              const url = query
                ? `https://www.ebay.com/sch/i.html?_nkw=${encodeURIComponent(query)}`
                : "https://www.ebay.com";
              window.open(url, "_blank");
            }}
          />
        </div>

        {/* UL Icon */}
        <div className="col-span-1 flex justify-center">
          <img
            src={UL_icon}
            alt="UL_icon"
            title="Search this equipment on Used-Line"
            className="w-5 h-5 cursor-pointer"
            onClick={() => {
              const query = buildEquipmentSearchQuery(record);
              const url = query
                ? `https://www.used-line.com/search?term=${encodeURIComponent(query)}`
                : "https://www.used-line.com/";
              window.open(url, "_blank");
            }}
          />
        </div>

        {/* Checkbox after UL icon */}
        <div className="col-span-1 flex justify-center">
          <input
            type="checkbox"
            className="w-5 h-5 cursor-pointer accent-[#808080]"
            onChange={(e) => console.log("Checkbox checked:", e.target.checked)}
          />
        </div>

        {/* Status Input — read-only, expands on click to show full content */}
        <div className="col-span-5">
          <OptionsCellInput
            value={record.status}
            onChange={() => {}}
            readOnly
          />
        </div>

        {/* Setting Icon */}
        <div className="col-span-1 flex justify-center">
          <img
            src={settingIcon}
            alt="Setting Icon"
            title="Add For Calibration Quote"
            className="w-4 h-4 cursor-pointer"
            onClick={(e) => { e.stopPropagation(); handleAddCalForRow(record.key); }}
          />
        </div>

        {/* Mail Icon */}
        <div className="col-span-1 flex justify-center">
          <img
            src={emailIcon}
            alt="Email Icon"
            title="Add Equipment For The Next WTB"
            className="w-4 h-4 cursor-pointer"
            onClick={() => {
              handleAddDealerWtbForRow(record.key);
              const now = new Date();
              const mm = String(now.getMonth() + 1).padStart(2, "0");
              const dd = String(now.getDate()).padStart(2, "0");
              const yyyy = now.getFullYear();
              const hh = String(now.getHours()).padStart(2, "0");
              const min = String(now.getMinutes()).padStart(2, "0");
              const ss = String(now.getSeconds()).padStart(2, "0");
              handleCellChange(record.key, "status", `Yes @ ${mm}/${dd}/${yyyy} ${hh}:${min}:${ss}`);
            }}
          />
        </div>

        {/* Filter Button */}
        <div className="col-span-1 flex justify-end">
          <Button
            size="small"
            icon={<FilterOutlined />}
            className={
              openRow === record.key
                ? "bg-[#808080] text-white border-none h-5 w-5 p-0 flex items-center justify-center"
                : "bg-[#C0C0C0] text-black border border-[#808080] h-5 w-5 p-0 flex items-center justify-center"
            }
            onClick={() => handleOpenResponsesForRow(record.key)}
          />
        </div>
      </div>

    </div>
  );

  // --- Right Side Data ---
  const dealerSalesData = [
    {
      key: "1",
      date: "10 Sep 2025",
      price: "$21,925.00",
      qty: 1,
      options: "/210/211/233/235/302/310/350",
      status: "Open/WTB",
      comments: '"Make Offer"',
      company: "360Test Technology Co. Ltd.",
      subStatus: "Active",
      qrId: "879296",
    },
    {
      key: "2",
      date: "10 Sep 2025",
      price: "$21,925.00",
      qty: 1,
      options: "/210/211/233/235/3",
      status: "Open/WTB",
      comments: '"Make Offer"',
      company: "360Test Technology Co. Ltd.",
      subStatus: "Active",
      qrId: "879296",
    },
    {
      key: "3",
      date: "10 Sep 2025",
      price: "$21,925.00",
      qty: 1,
      options: "/210/211/233/235/3",
      status: "Open/WTB",
      comments: '"Make Offer"',
      company: "360Test Technology Co. Ltd.",
      subStatus: "Active",
      qrId: "879296",
    },
    {
      key: "4",
      date: "10 Sep 2025",
      price: "$21,925.00",
      qty: 1,
      options: "/210/211/233/235/3",
      status: "Open/WTB",
      comments: '"Make Offer"',
      company: "360Test Technology Co. Ltd.",
      subStatus: "Active",
      qrId: "879296",
    },
    {
      key: "5",
      date: "10 Sep 2025",
      price: "$21,925.00",
      qty: 1,
      options: "/210/211/233/235/3",
      status: "Open/WTB",
      comments: '"Make Offer"',
      company: "360Test Technology Co. Ltd.",
      subStatus: "Active",
      qrId: "879296",
    },
    {
      key: "6",
      date: "10 Sep 2025",
      price: "$21,925.00",
      qty: 1,
      options: "/210/211/233/235/3",
      status: "Open/WTB",
      comments: '"Make Offer"',
      company: "360Test Technology Co. Ltd.",
      subStatus: "Active",
      qrId: "879296",
    },
    {
      key: "7",
      date: "10 Sep 2025",
      price: "$21,925.00",
      qty: 1,
      options: "/210/211/233/235/3",
      status: "Open/WTB",
      comments: '"Make Offer"',
      company: "360Test Technology Co. Ltd.",
      subStatus: "Active",
      qrId: "879296",
    },
    {
      key: "8",
      date: "10 Sep 2025",
      price: "$21,925.00",
      qty: 1,
      options: "/210/211/233/235/3",
      status: "Open/WTB",
      comments: '"Make Offer"',
      company: "360Test Technology Co. Ltd.",
      subStatus: "Active",
      qrId: "879296",
    },
    {
      key: "9",
      date: "10 Sep 2025",
      price: "$21,925.00",
      qty: 1,
      options: "/210/211/233/235/3",
      status: "Open/WTB",
      comments: '"Make Offer"',
      company: "360Test Technology Co. Ltd.",
      subStatus: "Active",
      qrId: "879296",
    },
    {
      key: "10",
      date: "10 Sep 2025",
      price: "$21,925.00",
      qty: 1,
      options: "/210/211/233/235/3",
      status: "Open/WTB",
      comments: '"Make Offer"',
      company: "360Test Technology Co. Ltd.",
      subStatus: "Active",
      qrId: "879296",
    },
    {
      key: "11",
      date: "10 Sep 2025",
      price: "$21,925.00",
      qty: 1,
      options: "/210/211/233/235/3",
      status: "Open/WTB",
      comments: '"Make Offer"',
      company: "360Test Technology Co. Ltd.",
      subStatus: "Active",
      qrId: "879296",
    },
    {
      key: "12",
      date: "10 Sep 2025",
      price: "$21,925.00",
      qty: 1,
      options: "/210/211/233/235/3",
      status: "Open/WTB",
      comments: '"Make Offer"',
      company: "360Test Technology Co. Ltd.",
      subStatus: "Active",
      qrId: "879296",
    },
    {
      key: "13",
      date: "10 Sep 2025",
      price: "$21,925.00",
      qty: 1,
      options: "/210/211/233/235/3",
      status: "Open/WTB",
      comments: '"Make Offer"',
      company: "360Test Technology Co. Ltd.",
      subStatus: "Active",
      qrId: "879296",
    },
    {
      key: "14",
      date: "10 Sep 2025",
      price: "$21,925.00",
      qty: 1,
      options: "/210/211/233/235/3",
      status: "Open/WTB",
      comments: '"Make Offer"',
      company: "360Test Technology Co. Ltd.",
      subStatus: "Active",
      qrId: "879296",
    },
    {
      key: "15",
      date: "10 Sep 2025",
      price: "$21,925.00",
      qty: 1,
      options: "/210/211/233/235/3",
      status: "Open/WTB",
      comments: '"Make Offer"',
      company: "360Test Technology Co. Ltd.",
      subStatus: "Active",
      qrId: "879296",
    },
  ];

  // Opens the dealer mail in the user's mail app and, at the same time, adds the mail
  // text to the top of the quote's Customer Comments.
  const sendDealerMail = (record: any) => {
    const to      = record.sendMail || "";
    if (!to) {
      message.warning("No email to send to.");
      return;
    }
    const subject = `RE: ${[record.manu, record.model].filter(Boolean).join(" ")}`;
    const repName = quoteForm.representativeName || "Sean Anderson";
    const price   = String(record.price || "").replace(/[^0-9.]/g, "");
    const body = [
      "Still have this?",
      "",
      `Brand: ${record.manu || ""}`,
      `Model: ${record.model || ""}`,
      `Options: ${record.options || ""}`,
      `Price: ${price}`,
      "",
      "Best,",
      repName,
      "Sales Manager",
      "",
      "Alliance Test Equipment, Inc.",
      "Webster, MA 01570 USA",
      "Tel: 508-671-9970",
      "www.alliancetesteq.com",
    ].join("\n");
    window.location.href = `mailto:${encodeURIComponent(to)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;


    // Put the mail text at the top of Customer Comments right away.
    const d = new Date();
    const stamp = `${String(d.getMonth() + 1).padStart(2, "0")}/${String(d.getDate()).padStart(2, "0")}/${d.getFullYear()}`;
    const mailText = `[Mail sent ${stamp} to ${to}] Subject: ${subject}\n${body}`;
    const existing = String(quoteFormRef.current?.customerComments || "");
    // The same mail is never added twice (double click / clicking the same row again).
    if (existing.includes(mailText)) return;
    const merged = existing ? `${mailText}\n\n${existing}` : mailText;
    quoteFormRef.current = { ...quoteFormRef.current, customerComments: merged };
    setQuoteForm((prev: any) => ({ ...prev, customerComments: merged }));
    if (quoteDbIdRef.current) {
      updateQuote(quoteDbIdRef.current, { customerComments: merged } as any).catch(() => setIsDirty(true));
    } else {
      setIsDirty(true);
    }
  };

  const dealerSalesColumns = [
    {
      title: "",
      dataIndex: "icon",
      width: 44,
      onHeaderCell: () => ({
        style: {
          padding: "4px 2px",
          fontSize: "9px",
          fontWeight: 700,
          backgroundColor: "#DCDCDC",
          color: "#000000",
          height: "28px",
          width: 44,
        },
      }),
      render: (_: any, record: any) => {
        const handleMailTo = (e: React.MouseEvent) => {
          e.stopPropagation();
          sendDealerMail(record);
        };
        return (
          <div className="flex items-center gap-0.5">
            <FaUser style={{ fontSize: 16, color: "#3E6E9C", cursor: "pointer" }} />
            <div
              style={{ backgroundColor: "#DCDCDC", borderRadius: "3px", width: 18, height: 18, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", fontWeight: 700, fontSize: 11, color: "#000000" }}
              onClick={handleMailTo}
              title="Send email"
            >
              @
            </div>
          </div>
        );
      },
    },
    {
      title: "Date",
      dataIndex: "date",
      width: 88,
      onHeaderCell: () => ({
        style: {
          padding: "4px 2px",
          fontSize: "12px",
          fontWeight: 700,
          backgroundColor: "#DCDCDC",
          color: "#000000",
          height: "30px",
          width: 88,
        },
      }),
      render: (val: string, record: any) => {
        return (
          <span
            className="text-[10px] text-black whitespace-nowrap cursor-pointer px-1 rounded"
            style={{ display: "block", minHeight: "22px" }}
            onDoubleClick={() => openResponsesTableEdit(record.key, "price")}
          >
            {renderResponseDisplayValue(val)}
          </span>
        );
      },
    },
    {
      title: "Price",
      dataIndex: "price",
      width: 52,
      ellipsis: true,
      onHeaderCell: () => ({
        style: {
          padding: "4px 2px",
          fontSize: "12px",
          fontWeight: 700,
          backgroundColor: "#DCDCDC",
          color: "#000000",
          height: "30px",
          width: 52,
        },
      }),
      onCell: () => ({ style: { padding: "0px 0px" } }),
      render: (val: string, record: any) => {
        const isEditing = !!editingResponsesTable;
        return isEditing ? (
          <Input
            size="small"
            value={editingResponsesTable.valuesByKey[record.key]?.price ?? ""}
            onChange={(e) =>
              updateResponseDraftValue(record.key, "price", e.target.value)
            }
            onBlur={() =>
              handleSaveCell(
                record.key,
                "price",
                editingResponsesTable.valuesByKey[record.key]?.price ?? "",
                record,
              )
            }
            onPressEnter={() =>
              handleSaveCell(
                record.key,
                "price",
                editingResponsesTable.valuesByKey[record.key]?.price ?? "",
                record,
              )
            }
            autoFocus={
              editingResponsesTable.focusKey === record.key &&
              editingResponsesTable.focusField === "price"
            }
            onFocus={() => switchResponseEditFocus(record.key, "price")}
            className="w-full dealer-open-control text-[10px] bg-[#99ffff]"
          />
        ) : (
          <span
            style={{ display: "block", backgroundColor: "#99ffff", padding: "2px 3px", borderRadius: 0, fontSize: 10, fontWeight: 700, color: "#1a1a1a", whiteSpace: "nowrap", cursor: "pointer", minHeight: "22px" }}
            onDoubleClick={() => openResponsesTableEdit(record.key, "price")}
          >
            {renderResponseDisplayValue(val)}
          </span>
        );
      },
    },
    {
      title: "Qty",
      dataIndex: "qty",
      width: 28,
      align: "center" as const,
      onHeaderCell: () => ({
        style: {
          padding: "4px 2px",
          fontSize: "12px",
          fontWeight: 700,
          backgroundColor: "#DCDCDC",
          color: "#000000",
          height: "30px",
          textAlign: "center",
          width: 28,
        },
      }),
      render: (val: number | string, record: any) => {
        const isEditing = !!editingResponsesTable;
        return isEditing ? (
          <Input
            size="small"
            value={editingResponsesTable.valuesByKey[record.key]?.qty ?? ""}
            onChange={(e) =>
              updateResponseDraftValue(record.key, "qty", e.target.value)
            }
            onBlur={() =>
              handleSaveCell(
                record.key,
                "qty",
                editingResponsesTable.valuesByKey[record.key]?.qty ?? "",
                record,
              )
            }
            onPressEnter={() =>
              handleSaveCell(
                record.key,
                "qty",
                editingResponsesTable.valuesByKey[record.key]?.qty ?? "",
                record,
              )
            }
            autoFocus={
              editingResponsesTable.focusKey === record.key &&
              editingResponsesTable.focusField === "qty"
            }
            onFocus={() => switchResponseEditFocus(record.key, "qty")}
            className="w-full dealer-open-control text-[10px] text-center"
          />
        ) : (
          <span
            className="text-[10px] cursor-pointer"
            style={{ color: "#000000", whiteSpace: "nowrap", display: "block", minHeight: "22px" }}
            onDoubleClick={() => openResponsesTableEdit(record.key, "qty")}
          >
            {renderResponseDisplayValue(val)}
          </span>
        );
      },
    },
    {
      title: "Options",
      dataIndex: "options",
      width: 110,
      onHeaderCell: () => ({
        style: { padding: "4px 2px", fontSize: "12px", fontWeight: 700, backgroundColor: "#DCDCDC", color: "#000000", height: "30px", width: 110 },
      }),
      onCell: () => ({ style: { overflow: "visible", padding: "0 0" } }),
      render: (val: string, record: any) => {
        const isEditing = !!editingResponsesTable;
        const isFocused = isEditing && editingResponsesTable.focusKey === record.key && editingResponsesTable.focusField === "options";
        if (isEditing) {
          const curVal = editingResponsesTable.valuesByKey[record.key]?.options ?? "";
          if (isFocused) {
            return (
              <div style={{ position: "relative", height: 24 }}>
                <textarea
                  ref={(el) => {
                    if (!el) return;
                    el.style.height = "0px";
                    el.style.height = `${el.scrollHeight}px`;
                    if (!(el as any)._didFocus) {
                      (el as any)._didFocus = true;
                      el.focus();
                      el.setSelectionRange(el.value.length, el.value.length);
                    }
                  }}
                  value={curVal}
                  rows={1}
                  onChange={(e) => {
                    updateResponseDraftValue(record.key, "options", e.target.value);
                    e.target.style.height = "0px";
                    e.target.style.height = `${e.target.scrollHeight}px`;
                  }}
                  onBlur={() => handleSaveCell(record.key, "options", editingResponsesTable.valuesByKey[record.key]?.options ?? "", record)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                      e.preventDefault();
                      handleSaveCell(record.key, "options", editingResponsesTable.valuesByKey[record.key]?.options ?? "", record);
                    }
                  }}
                  onMouseDown={(e) => {
                    const ta = e.currentTarget;
                    if (e.nativeEvent.offsetY > 24) {
                      e.preventDefault();
                      ta.style.pointerEvents = "none";
                      const below = document.elementFromPoint(e.clientX, e.clientY) as HTMLElement | null;
                      ta.style.pointerEvents = "";
                      if (below && below !== ta) {
                        const inp = (below.matches("input,textarea,select") ? below : below.querySelector("input,textarea,select")) as HTMLElement | null;
                        (inp ?? below).focus?.();
                      }
                    }
                  }}
                  style={{ position: "absolute", top: 0, left: 0, width: "100%", overflow: "hidden", fontSize: 12, lineHeight: "1.5", padding: "3px 6px", border: "1px solid #4096ff", borderRadius: 4, backgroundColor: "#fff", zIndex: 300, boxShadow: "0 6px 16px rgba(0,0,0,0.18)", resize: "none", whiteSpace: "pre-wrap", wordBreak: "break-word", outline: "none", boxSizing: "border-box" }}
                />
              </div>
            );
          }
          return (
            <Input size="small" value={curVal}
              onChange={(e) => updateResponseDraftValue(record.key, "options", e.target.value)}
              onBlur={() => handleSaveCell(record.key, "options", editingResponsesTable.valuesByKey[record.key]?.options ?? "", record)}
              onPressEnter={() => handleSaveCell(record.key, "options", editingResponsesTable.valuesByKey[record.key]?.options ?? "", record)}
              onFocus={() => switchResponseEditFocus(record.key, "options")}
              className="w-full dealer-open-control text-[10px]"
            />
          );
        }
        return (
          <div title={val} className="text-black cursor-pointer px-1"
            style={{ fontSize: "10px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "100%", minHeight: "22px" }}
            onDoubleClick={() => openResponsesTableEdit(record.key, "options")}>
            {renderResponseDisplayValue(val)}
          </div>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      width: 36,
      ellipsis: true,
      onHeaderCell: () => ({
        style: { padding: "4px 2px", fontSize: "12px", fontWeight: 700, backgroundColor: "#DCDCDC", color: "#000000", height: "30px", width: 36 },
      }),
      render: (val: string, record: any) => {
        const isEditing = !!editingResponsesTable;
        return isEditing ? (
          <Select showSearch size="small"
            value={editingResponsesTable.valuesByKey[record.key]?.status || undefined}
            onChange={(value) => {
              const nextValue = String(value || "");
              updateResponseDraftValue(record.key, "status", nextValue);
              handleSaveCell(record.key, "status", nextValue, record);
            }}
            autoFocus={editingResponsesTable.focusKey === record.key && editingResponsesTable.focusField === "status"}
            onFocus={() => switchResponseEditFocus(record.key, "status")}
            className="w-full dealer-open-control text-[10px]"
            options={SIMPLE_STATUS_OPTIONS}
            filterOption={(input, option) => String(option?.label ?? "").toLowerCase().startsWith(input.toLowerCase())}
            placeholder="Select status"
            dropdownMatchSelectWidth={false}
          />
        ) : (
          <span className="text-[10px] cursor-pointer"
            style={{ color: "#000000", whiteSpace: "nowrap", display: "block", minHeight: "22px" }}
            onDoubleClick={() => openResponsesTableEdit(record.key, "status")}>
            {renderResponseDisplayValue(val)}
          </span>
        );
      },
    },
    {
      title: "Comments",
      dataIndex: "comments",
      width: 95,
      onHeaderCell: () => ({
        style: { padding: "4px 2px", fontSize: "12px", fontWeight: 700, backgroundColor: "#DCDCDC", color: "#000000", height: "30px", width: 95 },
      }),
      onCell: () => ({ style: { overflow: "visible", padding: "0 0" } }),
      render: (text: string, record: any) => {
        const isEditing = !!editingResponsesTable;
        const isFocused = isEditing && editingResponsesTable.focusKey === record.key && editingResponsesTable.focusField === "comments";
        if (isEditing) {
          const curVal = editingResponsesTable.valuesByKey[record.key]?.comments ?? "";
          if (isFocused) {
            return (
              <div style={{ position: "relative", height: 24 }}>
                <textarea
                  ref={(el) => {
                    if (!el) return;
                    // Fixed height: from the box's top down to the bottom of the screen.
                    el.style.height = `${Math.max(120, window.innerHeight - el.getBoundingClientRect().top - 12)}px`;
                    if (!(el as any)._didFocus) {
                      (el as any)._didFocus = true;
                      el.focus();
                      el.setSelectionRange(el.value.length, el.value.length);
                    }
                  }}
                  value={curVal}
                  rows={1}
                  onChange={(e) => {
                    updateResponseDraftValue(record.key, "comments", e.target.value);
                  }}
                  onBlur={() => handleSaveCell(record.key, "comments", editingResponsesTable.valuesByKey[record.key]?.comments ?? "", record)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                      e.preventDefault();
                      handleSaveCell(record.key, "comments", editingResponsesTable.valuesByKey[record.key]?.comments ?? "", record);
                    }
                  }}
                  style={{ position: "absolute", top: 0, left: 0, width: "100%", overflowY: "auto", fontSize: 12, lineHeight: "1.5", padding: "3px 6px", border: "1px solid #4096ff", borderRadius: 4, backgroundColor: "#fff", zIndex: 300, boxShadow: "0 6px 16px rgba(0,0,0,0.18)", resize: "none", whiteSpace: "pre-wrap", wordBreak: "break-word", outline: "none", boxSizing: "border-box" }}
                />
              </div>
            );
          }
          return (
            <Input size="small" value={curVal}
              onChange={(e) => updateResponseDraftValue(record.key, "comments", e.target.value)}
              onBlur={() => handleSaveCell(record.key, "comments", curVal, record)}
              onPressEnter={() => handleSaveCell(record.key, "comments", curVal, record)}
              onFocus={() => switchResponseEditFocus(record.key, "comments")}
              className="w-full dealer-open-control text-[10px]"
            />
          );
        }
        return (
          <span title={text} className="text-black text-[9px] cursor-pointer px-1"
            style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", display: "block", maxWidth: "100%", minHeight: "22px" }}
            onDoubleClick={() => openResponsesTableEdit(record.key, "comments")}>
            {renderResponseDisplayValue(text)}
          </span>
        );
      },
    },
    {
      title: "",
      dataIndex: "company",
      width: 140,
      ellipsis: true,
      onHeaderCell: () => ({
        style: { padding: "4px 2px", fontSize: "12px", fontWeight: 700, backgroundColor: "#DCDCDC", color: "#000000", height: "30px", width: 140 },
      }),
      render: (text: string, record: any) => {
        const isEditing = !!editingResponsesTable;
        return isEditing ? (
          <Input size="small"
            value={editingResponsesTable.valuesByKey[record.key]?.company ?? ""}
            onChange={(e) => updateResponseDraftValue(record.key, "company", e.target.value)}
            onBlur={() => handleSaveCell(record.key, "company", editingResponsesTable.valuesByKey[record.key]?.company ?? "", record)}
            onPressEnter={() => handleSaveCell(record.key, "company", editingResponsesTable.valuesByKey[record.key]?.company ?? "", record)}
            autoFocus={editingResponsesTable.focusKey === record.key && editingResponsesTable.focusField === "company"}
            onFocus={() => switchResponseEditFocus(record.key, "company")}
            className="w-full dealer-open-control text-[10px]"
          />
        ) : (
          <div title={text} className="text-black text-[10px] cursor-pointer px-1"
            style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "100%", minHeight: "22px" }}
            onDoubleClick={() => openResponsesTableEdit(record.key, "company")}>
            {renderResponseDisplayValue(text)}
          </div>
        );
      },
    },
    {
      title: "Sub Status",
      dataIndex: "subStatus",
      width: 48,
      onHeaderCell: () => ({
        style: { padding: "4px 2px", fontSize: "12px", fontWeight: 700, backgroundColor: "#DCDCDC", color: "#000000", height: "30px", width: 48 },
      }),
      render: (val: string, record: any) => {
        const isEditing = !!editingResponsesTable;
        return isEditing ? (
          <Select size="small"
            value={editingResponsesTable.valuesByKey[record.key]?.subStatus || "Active"}
            onChange={(value) => {
              updateResponseDraftValue(record.key, "subStatus", value);
              handleSaveCell(record.key, "subStatus", value, record);
            }}
            options={[{ value: "Active", label: "Active" }, { value: "Inactive", label: "Inactive" }]}
            autoFocus={editingResponsesTable.focusKey === record.key && editingResponsesTable.focusField === "subStatus"}
            onFocus={() => switchResponseEditFocus(record.key, "subStatus")}
            className="w-full dealer-open-control text-[10px]"
            dropdownMatchSelectWidth={false}
          />
        ) : (
          <span className="text-[10px] cursor-pointer"
            style={{ color: "#000000", whiteSpace: "nowrap", display: "block", minHeight: "22px" }}
            onDoubleClick={() => openResponsesTableEdit(record.key, "subStatus")}>
            {renderResponseDisplayValue(val)}
          </span>
        );
      },
    },
    {
      title: "",
      dataIndex: "listType",
      width: 36,
      onHeaderCell: () => ({
        style: { padding: "4px 2px", fontSize: "12px", fontWeight: 700, backgroundColor: "#DCDCDC", color: "#000000", height: "30px", width: 36 },
      }),
      render: (val: string, record: any) => {
        const isEditing = !!editingResponsesTable;
        return isEditing ? (
          <Input size="small"
            value={editingResponsesTable.valuesByKey[record.key]?.listType ?? ""}
            onChange={(e) => updateResponseDraftValue(record.key, "listType", e.target.value)}
            onBlur={() => handleSaveCell(record.key, "listType", editingResponsesTable.valuesByKey[record.key]?.listType ?? "", record)}
            onPressEnter={() => handleSaveCell(record.key, "listType", editingResponsesTable.valuesByKey[record.key]?.listType ?? "", record)}
            autoFocus={editingResponsesTable.focusKey === record.key && editingResponsesTable.focusField === "listType"}
            onFocus={() => switchResponseEditFocus(record.key, "listType")}
            className="w-full dealer-open-control text-[10px]"
          />
        ) : (
          <span className="text-[10px] cursor-pointer"
            style={{ color: "#000000", whiteSpace: "nowrap", display: "block", minHeight: "22px" }}
            onDoubleClick={() => openResponsesTableEdit(record.key, "listType")}>
            {renderResponseDisplayValue(val)}
          </span>
        );
      },
    },
    {
      title: "QR ID",
      dataIndex: "qrId",
      width: 46,
      ellipsis: true,
      onHeaderCell: () => ({
        style: { padding: "4px 2px", fontSize: "12px", fontWeight: 700, backgroundColor: "#DCDCDC", color: "#000000", height: "30px", width: 46 },
      }),
      render: (val: string, record: any) => {
        const isEditing = !!editingResponsesTable;
        return isEditing ? (
          <Input size="small"
            value={editingResponsesTable.valuesByKey[record.key]?.qrId ?? ""}
            onChange={(e) => updateResponseDraftValue(record.key, "qrId", e.target.value)}
            onBlur={() => handleSaveCell(record.key, "qrId", editingResponsesTable.valuesByKey[record.key]?.qrId ?? "", record)}
            onPressEnter={() => handleSaveCell(record.key, "qrId", editingResponsesTable.valuesByKey[record.key]?.qrId ?? "", record)}
            autoFocus={editingResponsesTable.focusKey === record.key && editingResponsesTable.focusField === "qrId"}
            onFocus={() => switchResponseEditFocus(record.key, "qrId")}
            className="w-full dealer-open-control text-[10px]"
          />
        ) : (
          <span className="text-[10px] cursor-pointer"
            style={{ color: "#000000", whiteSpace: "nowrap", display: "block", minHeight: "22px" }}
            onDoubleClick={() => openResponsesTableEdit(record.key, "qrId")}>
            {renderResponseDisplayValue(val)}
          </span>
        );
      },
    },
    {
      title: "",
      dataIndex: "help",
      width: 25,
      onHeaderCell: () => ({
        style: { padding: "4px 2px", fontSize: "12px", fontWeight: 700, backgroundColor: "#DCDCDC", color: "#000000", height: "30px", width: 25 },
      }),
      render: (_: any, record: any) => (
        <div className="flex gap-0.5">
          <Button type="primary" size="small"
            className="border h-2 w-2 p-0 text-[6px] flex items-center justify-center min-w-0"
            style={{ backgroundColor: "#800000", borderColor: "#600000" }}
            icon={<RightOutlined style={{ fontSize: "12px", color: "#ffffff" }} />}
            onClick={() => {
              const currentModel = tableData.find((i) => i.key === openRow)?.model?.trim() || "";
              navigate(`/quotes-responses${currentModel ? `?model=${encodeURIComponent(currentModel)}` : ""}`);
            }}
          />
        </div>
      ),
    },
  ];

  const wtbColHeader = (width?: number) => ({
    style: {
      padding: "3px 8px",
      fontSize: 12,
      fontWeight: 700,
      backgroundColor: "#fff",
      color: "#000",
      height: 26,
      borderBottom: "1px solid #bbb",
      borderRight: "1px solid #ddd",
      whiteSpace: "nowrap" as const,
      ...(width ? { width } : {}),
    },
  });

  const makeWtbEditCell = (field: string, val: string, record: any, extraCellStyle?: React.CSSProperties) => {
    const isEditing = !!editingWtbResponseTable;
    const curVal = isEditing ? (editingWtbResponseTable.valuesByKey[record.key]?.[field] ?? "") : val;
    if (isEditing) {
      return (
        <Input
          size="small"
          value={curVal}
          autoFocus={editingWtbResponseTable.focusKey === record.key && editingWtbResponseTable.focusField === field}
          onChange={(e) => updateWtbResponseDraft(record.key, field, e.target.value)}
          onBlur={() => handleSaveWtbResponseCell(record.key, field, editingWtbResponseTable.valuesByKey[record.key]?.[field] ?? "")}
          onPressEnter={() => handleSaveWtbResponseCell(record.key, field, editingWtbResponseTable.valuesByKey[record.key]?.[field] ?? "")}
          onFocus={() => setEditingWtbResponseTable((prev) => prev ? { ...prev, focusKey: record.key, focusField: field } : prev)}
          style={{ fontSize: 11, height: 22, ...extraCellStyle }}
          className="w-full"
        />
      );
    }
    return (
      <span
        style={{ fontSize: 11, color: "#000", whiteSpace: "nowrap", display: "block", minHeight: 22, padding: "1px 4px", cursor: "pointer" }}
        onDoubleClick={() => openWtbResponseEdit(record.key, field)}
      >
        {val || " "}
      </span>
    );
  };

  const wtbResponseColumns = [
    {
      title: "Created",
      dataIndex: "date",
      width: 110,
      onHeaderCell: () => wtbColHeader(110),
      onCell: () => ({ style: { padding: "0px", borderRight: "1px solid #e8e8e8", backgroundColor: "#fff" } }),
      render: (val: string, record: any) => makeWtbEditCell("date", val, record),
    },
    {
      title: "Model",
      dataIndex: "model",
      width: 110,
      onHeaderCell: () => wtbColHeader(110),
      onCell: () => ({ style: { padding: "0px", borderRight: "1px solid #e8e8e8", backgroundColor: "#fff" } }),
      render: (val: string, record: any) => makeWtbEditCell("model", val, record),
    },
    {
      title: "Manu",
      dataIndex: "manu",
      width: 120,
      onHeaderCell: () => wtbColHeader(120),
      onCell: () => ({ style: { padding: "0px", borderRight: "1px solid #e8e8e8", backgroundColor: "#fff" } }),
      render: (val: string, record: any) => makeWtbEditCell("manu", val, record),
    },
    {
      title: "Price",
      dataIndex: "price",
      width: 100,
      onHeaderCell: () => wtbColHeader(100),
      onCell: () => ({ style: { padding: "0px", borderRight: "1px solid #e8e8e8" } }),
      render: (val: string, record: any) => {
        const isEditing = !!editingWtbResponseTable;
        if (isEditing) {
          const curVal = editingWtbResponseTable.valuesByKey[record.key]?.price ?? "";
          return (
            <Input
              size="small"
              value={curVal}
              autoFocus={editingWtbResponseTable.focusKey === record.key && editingWtbResponseTable.focusField === "price"}
              onChange={(e) => updateWtbResponseDraft(record.key, "price", e.target.value)}
              onBlur={() => handleSaveWtbResponseCell(record.key, "price", editingWtbResponseTable.valuesByKey[record.key]?.price ?? "")}
              onPressEnter={() => handleSaveWtbResponseCell(record.key, "price", editingWtbResponseTable.valuesByKey[record.key]?.price ?? "")}
              onFocus={() => setEditingWtbResponseTable((prev) => prev ? { ...prev, focusKey: record.key, focusField: "price" } : prev)}
              style={{ fontSize: 11, height: 22, backgroundColor: "#ffff00" }}
              className="w-full"
            />
          );
        }
        return (
          <span
            style={{ display: "block", backgroundColor: "#ffff00", fontSize: 11, color: "#000", padding: "1px 4px", whiteSpace: "nowrap", minHeight: 22, cursor: "pointer" }}
            onDoubleClick={() => openWtbResponseEdit(record.key, "price")}
          >
            {val || " "}
          </span>
        );
      },
    },
    {
      title: "Dealer",
      dataIndex: "company",
      width: 200,
      onHeaderCell: () => wtbColHeader(200),
      onCell: () => ({ style: { padding: "0px", borderRight: "1px solid #e8e8e8", backgroundColor: "#fff" } }),
      render: (val: string, record: any) => makeWtbEditCell("company", val, record),
    },
    {
      title: "ListType",
      dataIndex: "listType",
      width: 90,
      onHeaderCell: () => wtbColHeader(90),
      onCell: () => ({ style: { padding: "0px", backgroundColor: "#fff" } }),
      render: (val: string, record: any) => makeWtbEditCell("listType", val, record),
    },
  ];

  const euColHeader = (): object => ({
    style: {
      padding: "4px 6px",
      fontSize: "12px",
      fontWeight: 700,
      backgroundColor: "#DCDCDC",
      background: "#DCDCDC",
      color: "#000000",
      height: "28px",
      borderBottom: "2px solid #b0b0b0",
    },
  });

  const euEditableCell = (rowKey: string, field: string, value: string, extraStyle?: React.CSSProperties) => {
    const isEditing = euEditingCell?.key === rowKey && euEditingCell?.field === field;
    if (isEditing) {
      return (
        <textarea
          autoFocus
          value={euEditingValue}
          rows={2}
          onChange={(e) => setEuEditingValue(e.target.value)}
          onBlur={() => saveEuCell(rowKey, field, euEditingValue)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); saveEuCell(rowKey, field, euEditingValue); }
            if (e.key === "Escape") setEuEditingCell(null);
          }}
          style={{ width: "100%", fontSize: 11, border: "1px solid #1677ff", padding: "1px 2px", outline: "none", background: "#fff", resize: "none", lineHeight: "1.4", ...extraStyle }}
        />
      );
    }
    return (
      <span
        onDoubleClick={() => { setEuEditingCell({ key: rowKey, field }); setEuEditingValue(value || ""); }}
        style={{ fontSize: 11, color: "#000", display: "block", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", cursor: "default", ...extraStyle }}
        title={value || "-"}
      >
        {value || "-"}
      </span>
    );
  };

  const euQuotesColumns = [
    {
      title: "Status",
      dataIndex: "subStatus",
      width: "14%",
      onHeaderCell: () => euColHeader(),
      onCell: (record: any) => ({ style: { padding: "3px 6px" } }),
      render: (val: string, record: any) => euEditableCell(record.key, "subStatus", val),
    },
    {
      title: "Customer",
      dataIndex: "company",
      width: "13%",
      onHeaderCell: () => euColHeader(),
      onCell: (record: any) => ({ style: { padding: "3px 6px" } }),
      render: (text: string, record: any) => euEditableCell(record.key, "company", text),
    },
    {
      title: "Created",
      dataIndex: "date",
      width: "10%",
      onHeaderCell: () => euColHeader(),
      onCell: (record: any) => ({ style: { padding: "3px 6px" } }),
      render: (text: string, record: any) => euEditableCell(record.key, "date", text),
    },
    {
      title: "Model",
      dataIndex: "model",
      width: "9%",
      align: "center" as const,
      onHeaderCell: () => euColHeader(),
      onCell: (record: any) => ({ className: "eu-model-cell", style: { padding: "3px 6px", backgroundColor: "#ffffcc", textAlign: "center" } }),
      render: (text: string, record: any) => euEditableCell(record.key, "model", text),
    },
    {
      title: "Manu",
      dataIndex: "manu",
      width: "11%",
      onHeaderCell: () => euColHeader(),
      onCell: (record: any) => ({ style: { padding: "3px 6px" } }),
      render: (text: string, record: any) => euEditableCell(record.key, "manu", text),
    },
    {
      title: "Options",
      dataIndex: "options",
      width: "11%",
      onHeaderCell: () => euColHeader(),
      onCell: (record: any) => ({ style: { padding: "3px 6px" } }),
      render: (text: string, record: any) => euEditableCell(record.key, "options", text),
    },
    {
      title: "Quote",
      dataIndex: "price",
      width: "10%",
      align: "center" as const,
      onHeaderCell: () => euColHeader(),
      onCell: () => ({ className: "eu-quote-cell", style: { padding: "3px 6px", backgroundColor: "#ffff00", textAlign: "center" } }),
      render: (text: string) => (
        <span style={{ fontSize: 11, fontWeight: 700, color: "#000", whiteSpace: "nowrap" }}>
          {text || "$0.00"}
        </span>
      ),
    },
    {
      title: "Cal",
      dataIndex: "cal",
      width: "7%",
      onHeaderCell: () => euColHeader(),
      onCell: (record: any) => ({ style: { padding: "3px 6px" } }),
      render: (text: string, record: any) => euEditableCell(record.key, "cal", text),
    },
    {
      title: "Description",
      dataIndex: "description",
      onHeaderCell: () => euColHeader(),
      onCell: (record: any) => ({ style: { padding: "3px 6px" } }),
      render: (text: string, record: any) => euEditableCell(record.key, "description", text),
    },
  ];

  const activeQuoteId = normalizeQuoteId(loadedQuoteId || quoteForm.quoteId);
  const currentRecordIndex = quoteIdList.indexOf(activeQuoteId);
  const currentRecordNo = currentRecordIndex >= 0 ? currentRecordIndex + 1 : 0;

  useEffect(() => {
    setRecordInputValue(currentRecordNo ? String(currentRecordNo) : "");
  }, [currentRecordNo]);

  const handleRecordInputCommit = (value: string) => {
    const n = Number(value);
    if (!Number.isFinite(n) || n < 1 || n > quoteIdList.length) {
      setRecordInputValue(currentRecordNo ? String(currentRecordNo) : "");
      return;
    }

    const quoteId = quoteIdList[n - 1];
    if (quoteId) {
      loadQuoteByQuoteId(quoteId);
    }
  };

  const totalRecords = recordStats.total;
  const openRecords = allQuoteIdList.length;
  const activeCount = isFindResultsActive
    ? allQuoteIdList.length
    : isNotQuotedFilterActive
    ? recordStats.notQuoted
    : isExpectingPoFilterActive
      ? recordStats.expectingPo
      : isInConversationFilterActive
        ? inConversationQuoteIdList.length
        : openRecords;
  const activeCountLabel = isFindResultsActive
    ? "Find"
    : isNotQuotedFilterActive
    ? "Not Quoted"
    : isExpectingPoFilterActive
      ? "Expecting PO"
      : isInConversationFilterActive
        ? "In Conv"
        : "Open";
  const isFilterActive =
    isFindResultsActive ||
    isNotQuotedFilterActive ||
    isExpectingPoFilterActive ||
    isInConversationFilterActive;
  const EBay = require("../../Assets/EBay_logo.png");
  const UL_icon = require("../../Assets/UL-icon.png");
  const settingMinus = require("../../Assets/setting-icon-minus.png");
  const settingPlus = require("../../Assets/setting-icon-plus.png");
  const UsedLine_logo = require("../../Assets/usedline-logo_s.jpg");
  const emailIcon = require("../../Assets/Email.png");
  const settingIcon = require("../../Assets/setting.png");
  const pageHeaderButtonColors: Record<
    string,
    { bg: string; hover: string; text: string; border?: string }
  > = {
    Inventory: {
      bg: "#c0c0c0",
      hover: "#c0c0c0",
      text: "#000000",
    },
    "Set Alerts": {
      bg: "#FF66FF",
      hover: "#FF99FF",
      text: "#000000",
    },
    Duplicate: {
      bg: "#c0c0c0",
      hover: "#c0c0c0",
      text: "#000000",
    },
    "Open Order Report": {
      bg: "#ffff66",
      hover: "#ffff99",
      text: "#000000",
    },
    "Not Quoted Yet": {
      bg: "#99FFFF",
      hover: "#CCFFFF",
      text: "#000000",
      border: "1px solid #003333",
    },
    "Find In CONV": {
      bg: "#00FF00",
      hover: "#66FF66",
      text: "#000000",
    },
    "Expecting PO": {
      bg: "#00FF00",
      hover: "#66FF66",
      text: "#000000",
    },
    "OTC Snapshot": {
      bg: "#FFFF00",
      hover: "#FFFF66",
      text: "#000000",
    },
    "Order Tracking Center": {
      bg: "#c0c0c0",
      hover: "#c0c0c0",
      text: "#000000",
    },
    // Charcoal: neutral, so it doesn't compete with the bright colours the
    // rest of the row uses. The greys already here are light silver
    // (#c0c0c0), so there's no confusing the two.
    "Customer Email": {
      bg: "#2B2B2B",
      hover: "#444444",
      text: "#FFFFFF",
    },
    "Dealer Email": {
      bg: "#2B2B2B",
      hover: "#444444",
      text: "#FFFFFF",
    },
  };

  const getPageHeaderNavigationPath = (buttonLabel: string) => {
    switch (buttonLabel) {
      case "Inventory":
        return "/inventory";
      case "Open Order Report":
        return "/open-order";
      case "OTC Snapshot":
        return "/otc";
      case "Order Tracking Center":
        return "/order-tracking";
      default:
        return null;
    }
  };

  // Both Email buttons open the same page and hand it this quote's whole
  // context — the quote number AND its models — so the side you asked for
  // opens onto its linked history and the other side is already loaded when
  // you switch tabs over there. Only `side` says which one you land on.
  const buildEmailPagePath = (targetSide: "customer" | "dealer") => {
    const quoteId = sanitizeQuoteId(loadedQuoteId || quoteForm.quoteId);
    const models = Array.from(
      new Set(
        tableData.map((item) => (item.model || "").trim()).filter(Boolean),
      ),
    );
    const params = new URLSearchParams({ side: targetSide });
    if (quoteId) params.set("quoteId", quoteId);
    if (models.length) params.set("model", models.join(","));
    return `/customer-email?${params.toString()}`;
  };

  // Sean's ask: the quote page itself shows every email about this quote (sell
  // side) and every email about the models on it (buy side), without leaving
  // for the Emails page. Same record keys the Emails page uses, so a message
  // linked there shows up here and vice versa.
  const showEmailResponseTabs = canSeeEmailLinkTabs();
  const quoteEmailRecordKey = sanitizeQuoteId(
    loadedQuoteId || quoteForm.quoteId,
  );
  // Every model on the quote, not just the row you happen to have selected —
  // "all related to the model - or models in the quote".
  const dealerEmailRecordKey = Array.from(
    new Set(tableData.map((item) => (item.model || "").trim()).filter(Boolean)),
  ).join(",");

  const handlePageHeaderButtonClick = (buttonLabel: string) => {
    const path = getPageHeaderNavigationPath(buttonLabel);

    if (buttonLabel === "Customer Email" || buttonLabel === "Dealer Email") {
      navigate(
        buildEmailPagePath(
          buttonLabel === "Dealer Email" ? "dealer" : "customer",
        ),
        // Back on the email page returns here directly, not through
        // whatever tab/filter history the email page builds up itself.
        { state: { from: `${window.location.pathname}${window.location.search}` } },
      );
      return;
    }
    if (buttonLabel === "Not Quoted Yet") {
      handleToggleNotQuotedFilter();
      return;
    }
    if (buttonLabel === "Expecting PO") {
      handleToggleExpectingPoFilter();
      return;
    }
    if (buttonLabel === "Find In CONV") {
      handleToggleInConversationFilter();
      return;
    }
    if (buttonLabel === "Duplicate") {
      handleDuplicateCurrentQuote();
      return;
    }
    if (buttonLabel === "Email") {
      handleOpenEmailScreen();
      return;
    }
    if (path) {
      navigate(withQuoteId(path));
    }
  };

  const renderPageHeaderButton = (
    buttonLabel: string,
    extraStyle: React.CSSProperties = {},
  ) => {
    const colors = pageHeaderButtonColors[buttonLabel] || { bg: "#FFFFFF", hover: "#F0F0F0", text: "#000000" };

    return (
      <Button
        key={buttonLabel}
        size="small"
        style={{
          backgroundColor: colors.bg,
          color: colors.text,
          fontSize: "12px",
          height: "18px",
          padding: "0 12px",
          border: colors.border || "1px solid #111111",
          fontWeight: 700,
          borderRadius: 0,
          lineHeight: "16px",
          boxShadow: "none",
          ...extraStyle,
        }}
        onMouseEnter={(e) =>
          (e.currentTarget.style.backgroundColor = colors.hover)
        }
        onMouseLeave={(e) =>
          (e.currentTarget.style.backgroundColor = colors.bg)
        }
        onClick={() => handlePageHeaderButtonClick(buttonLabel)}
      >
        {buttonLabel === "Email" ? (
          <Space size={4}>
            <MailOutlined />
            Email
          </Space>
        ) : (
          buttonLabel
        )}
      </Button>
    );
  };

  return (
    <>
      <ConfigProvider theme={{ token: { colorPrimary: "#808080" } }}>
        <div className="px-2 h-screen flex flex-col" style={{ backgroundColor: "#FFFFFF" }}>
          <CommonHeader
            className="mb-0"
            currentRecord={isViewingPending ? (pendingViewIndex ?? 0) + 1 : recordInputValue}
            disableNext={isViewingPending ? (pendingViewIndex ?? 0) >= pendingQuotes.length - 1 : isLastRecord}
            disablePrevious={isViewingPending ? (pendingViewIndex ?? 0) <= 0 : isFirstRecord}
            isFindMode={isFindMode}
            onCancelFind={cancelFind}
            onDeleteRecord={handleSoftDeleteCurrentQuote}
            onFind={enterFindMode}
            onNewRecord={handleNewQuoteRecord}
            onNextRecord={
              isViewingPending
                ? () => goToPending((pendingViewIndex ?? 0) + 1)
                : () => handleQuoteArrowNavigation("next")
            }
            onPerformFind={performFind}
            onPreviousRecord={
              isViewingPending
                ? () => goToPending((pendingViewIndex ?? 0) - 1)
                : () => handleQuoteArrowNavigation("prev")
            }
            onRecordChange={setRecordInputValue}
            onRecordCommit={handleRecordInputCommit}
            onRecordSliderCommit={(index) => {
              if (isViewingPending) {
                goToPending(index);
                return;
              }
              const targetId = quoteIdList[index];
              if (targetId) loadQuoteByQuoteId(targetId);
            }}
            onShowAll={handleShowAll}
            recordCount={isViewingPending ? pendingQuotes.length : quoteIdList.length}
            recordIndex={isViewingPending ? (pendingViewIndex ?? 0) : currentNavIdx}
            rightContent={
              <div className="flex items-center gap-2">
                {isViewingPending ? (
                  <>
                    <Dropdown
                      trigger={["click"]}
                      disabled={pendingActionLoading}
                      menu={{
                        items: [
                          { key: "openWtb", label: "Open / WTB" },
                          { type: "divider" },
                          { key: "delete", label: "Delete", danger: true },
                        ],
                        onClick: ({ key }) => {
                          if (key === "openWtb") {
                            handleApproveCurrentPending("Open/WTB");
                          } else if (key === "delete") {
                            confirmDeleteCurrentPending();
                          }
                        },
                      }}
                    >
                      <Button
                        size="small"
                        loading={pendingActionLoading}
                        className="text-xs font-semibold"
                        style={{
                          // The page ConfigProvider sets colorPrimary to grey,
                          // which washes out on the grey header bar — force the
                          // solid blue so the action is clearly visible.
                          background: "#004aad",
                          borderColor: "#003a87",
                          color: "#ffffff",
                        }}
                      >
                        <Space size={4}>
                          Action
                          <DownOutlined style={{ fontSize: 10 }} />
                        </Space>
                      </Button>
                    </Dropdown>
                    <Button
                      size="small"
                      onClick={exitPendingMode}
                      className="text-xs font-semibold"
                      style={{
                        background: "#ffffff",
                        borderColor: "#5a5a5a",
                        color: "#111111",
                      }}
                    >
                      Exit
                    </Button>
                  </>
                ) : (
                  <Button
                    size="small"
                    type="primary"
                    className="bg-[#004aad] text-xs font-semibold"
                    style={{ display: "none" }}
                    loading={pendingActionLoading}
                    onClick={enterPendingMode}
                  >
                    Pending Quotes
                  </Button>
                )}
                <PageLogoutButton />
              </div>
            }
            title="Sales View"
            totalActiveCount={isViewingPending ? pendingQuotes.length : activeCount}
            totalLabel={isViewingPending ? "Pending" : (isFilterActive ? `${activeCountLabel} (Filtered)` : (sortRules.length > 0 ? "Total (Sorted)" : "Total (Unsorted)"))}
            totalRecordCount={isViewingPending ? pendingQuotes.length : totalRecords}
            totalValue={isViewingPending ? pendingQuotes.length : (isFilterActive ? `${activeCount} / ${totalRecords}` : totalRecords)}
            withQuoteId={withQuoteId}
            sortColumns={QUOTE_HEADER_EXPORT_COLUMNS}
            sortTitle="Sort Quotes Records"
            sortRules={sortRules}
            onApplySort={handleApplySortRules}
            exportColumns={QUOTES_ADD_EXPORT_COLUMNS}
            getData={() => {
              // Merge quote header fields with each line item row so both tables are exported
              const header: Record<string, any> = {
                quoteId: quoteForm.quoteId,
                createdDate: quoteForm.createdDate,
                companyName: quoteForm.companyName,
                contactName: quoteForm.contactName,
                contactEmail: quoteForm.contactEmail,
                phone1: quoteForm.phone1,
                phone2: quoteForm.phone2,
                mobile: quoteForm.mobile,
                quoteStatus: quoteForm.quoteStatus,
                subStatus: quoteForm.subStatus,
                quoteSource: quoteForm.quoteSource,
                assignedEmail: quoteForm.assignedEmail,
                quoteSent: quoteForm.quoteSent,
                quoteSentDate: quoteForm.quoteSentDate,
                firstFollowUpDate: quoteForm.firstFollowUpDate,
                secondFollowUpDate: quoteForm.secondFollowUpDate,
                finalFollowUpDate: quoteForm.finalFollowUpDate,
                country: (quoteForm as any).country,
                customerComments: quoteForm.customerComments,
                notes: quoteForm.notes,
                optionsRequested: quoteForm.optionsRequested,
              };
              if (tableData.length === 0) return [header];
              return tableData.map((item) => ({
                ...header,
                manufacturer: item.manufacturer,
                model: item.model,
                options: item.options,
                qty: item.qty,
                price: item.price,
                priceString: (item as any).priceString,
                stdCal: item.stdCal,
                status: item.status,
                description: item.description,
                wtbSentCalculated: (item as any).wtbSentCalculated,
              }));
            }}
            onImport={async (rows) => {
              // 1. Save quote headers → quotes_fm (deduplicated by quoteId on backend)
              await bulkImportQuotes(rows);
              // 2. Save line items → quoteseq_fm (all rows linked by quoteId)
              await bulkImportQuoteSeq(rows);
            }}
            exportFilename="quotes"
          />

          {/* --- 1. Custom Toolbar Header Section (Part of the page, not sticky) --- */}
          <div className="mb-1 flex min-h-[98px] items-center gap-8 py-4 pl-6 pr-3" style={{ backgroundColor: "#3E6E9C", width: "100%" }}>
            <h1 className="shrink-0 text-[36px] font-bold text-white leading-none">
              Sales View
            </h1>
            <div className="flex items-center gap-5">
              <div className="flex flex-col items-center gap-[1px]">
                {renderPageHeaderButton("Inventory", { minWidth: 80 })}
                {renderPageHeaderButton("Set Alerts", { minWidth: 104 })}
                {renderPageHeaderButton("Duplicate", { minWidth: 72 })}
              </div>
              {renderPageHeaderButton("Open Order Report", { minWidth: 118 })}
              {renderPageHeaderButton("Not Quoted Yet", {
                height: 48,
                minWidth: 130,
                fontSize: "13px",
              })}
              <div className="flex flex-col gap-[3px]">
                {renderPageHeaderButton("Find In CONV", { minWidth: 100 })}
                {renderPageHeaderButton("Expecting PO", { minWidth: 100 })}
              </div>
              {renderPageHeaderButton("OTC Snapshot", { minWidth: 120 })}
              {renderPageHeaderButton("Order Tracking Center", { minWidth: 136 })}
              {canSendToOrderTracking && (
                <Button
                  size="small"
                  style={{
                    backgroundColor: "#CCFFCC",
                    color: "#000000",
                    fontSize: "12px",
                    height: "48px",
                    padding: "0 12px",
                    minWidth: 140,
                    border: "1px solid #111111",
                    fontWeight: 700,
                    borderRadius: 0,
                    lineHeight: "16px",
                    boxShadow: "none",
                    whiteSpace: "normal",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor = "#B8F0B8")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor = "#CCFFCC")
                  }
                  onClick={handleOpenOrderTracking}
                >
                  Send to Order Tracking
                </Button>
              )}
            </div>
          </div>

          {/* 2. Main Info Card Container (Total width 1419px) */}
          {/* Style Block - Handles the Tab Border Logic */}
          <style>{`
          /* --- LEFT SIDE TABS --- */
          .custom-tabs .ant-tabs-nav {
            margin-bottom: -1px !important;
          }

          .custom-tabs .ant-tabs-tab {
            border-bottom: 1px solid #b0b0b0 !important;
            z-index: 1;
            background-color: #DCDCDC !important;
            border-color: #b0b0b0 !important;
            border-radius: 3px 3px 0 0 !important;
          }

          .custom-tabs .ant-tabs-tab .ant-tabs-tab-btn {
            color: #333333 !important;
            font-size: 11px !important;
            font-weight: 500 !important;
          }

          .custom-tabs .ant-tabs-tab-active {
            position: relative !important;
            z-index: 10 !important;
            border-bottom-color: #FFFFFF !important;
            background-color: #FFFFFF !important;
          }

          .custom-tabs .ant-tabs-tab-active .ant-tabs-tab-btn {
            color: #000000 !important;
            font-weight: 700 !important;
            font-size: 12px !important;
          }

          /* --- RIGHT SIDE TABS (DEALER SALES) --- */
          /* Use flex throughout — never height:100% which fails when the parent
             has no explicit pixel height (flex-1 parent on short/zoomed screens) */
          .custom-dealer-tabs {
            display: flex !important;
            flex-direction: column !important;
            flex: 1 !important;
            min-height: 0 !important;
          }

          .custom-dealer-tabs .ant-tabs-content-holder {
            display: flex !important;
            flex-direction: column !important;
            flex: 1 !important;
            min-height: 0 !important;
            overflow: hidden !important;
            border-left: 1px solid #808080 !important;
            border-right: 1px solid #808080 !important;
            border-bottom: 1px solid #808080 !important;
          }

          .custom-dealer-tabs .ant-tabs-content {
            display: flex !important;
            flex-direction: column !important;
            flex: 1 !important;
            min-height: 0 !important;
          }

          .custom-dealer-tabs .ant-tabs-tabpane {
            display: flex !important;
            flex-direction: column !important;
            flex: 1 !important;
            min-height: 0 !important;
            overflow: hidden !important;
          }

          .custom-dealer-tabs .ant-tabs-tabpane-hidden {
            display: none !important;
          }

          .custom-dealer-tabs .ant-tabs-nav {
            margin-bottom: 0 !important;
            background: transparent !important;
            border: none !important;
            box-shadow: none !important;
          }

          .custom-dealer-tabs .ant-tabs-nav::before {
            border-bottom: 1px solid #808080 !important;
          }

          .custom-dealer-tabs .ant-tabs-ink-bar,
          .custom-dealer-tabs .ant-tabs-ink-bar-animated {
            display: none !important;
            height: 0 !important;
            background: transparent !important;
          }

          .custom-dealer-tabs .ant-tabs-nav-wrap,
          .custom-dealer-tabs .ant-tabs-nav-list {
            background: transparent !important;
          }

          .custom-dealer-tabs .ant-tabs-tab {
            margin-right: 2px !important;
            background-color: #DCDCDC !important;
            border: 1px solid #808080 !important;
            border-bottom: 1px solid #808080 !important;
            border-radius: 4px 4px 0 0 !important;
            padding: 3px 10px !important;
            box-shadow: none !important;
          }

          .custom-dealer-tabs .ant-tabs-tab .ant-tabs-tab-btn {
            color: #000000 !important;
            font-size: 12px !important;
          }

          .custom-dealer-tabs .ant-tabs-tab-active {
            background-color: #DCDCDC !important;
            border: 1px solid #808080 !important;
            border-bottom-color: transparent !important;
            z-index: 10 !important;
            position: relative !important;
            margin-bottom: -1px !important;
          }

          .custom-dealer-tabs .ant-tabs-tab-active .ant-tabs-tab-btn {
            color: #000000 !important;
            font-weight: 400 !important;
          }

          .custom-dealer-tabs .ant-tabs-tab:hover:not(.ant-tabs-tab-active) {
            background-color: #D0D0D0 !important;
          }

          /* EU Quotes table header container (when scroll prop is used, Ant Design creates a separate header div) */
          .custom-eu-table .ant-table-header,
          .custom-dealer-table .ant-table-header {
            background-color: #DCDCDC !important;
            background: #DCDCDC !important;
          }

          /* EU Quotes table row borders - bottom only to avoid double borders */
          .custom-eu-table .ant-table-tbody > tr > td {
            border-bottom: 1px solid #b0b0b0 !important;
            border-top: none !important;
          }
          .custom-eu-table .ant-table-tbody > tr:last-child > td {
            border-bottom: none !important;
          }
          .custom-eu-table table {
            border-collapse: collapse !important;
            width: 100% !important;
            table-layout: fixed !important;
          }
          .custom-eu-table .ant-table-container {
            overflow: hidden !important;
          }
          .custom-eu-table .ant-table-body {
            overflow-x: hidden !important;
          }

          /* EU Quotes table header cells */
          .custom-eu-table .ant-table-thead > tr > th,
          .custom-eu-table .ant-table-thead > tr > th.ant-table-cell,
          .custom-eu-table table > thead > tr > th {
            background-color: #DCDCDC !important;
            background: #DCDCDC !important;
            color: #000000 !important;
            font-weight: 700 !important;
            font-size: 12px !important;
            border-bottom: 2px solid #b0b0b0 !important;
            padding: 4px 6px !important;
            opacity: 1 !important;
            visibility: visible !important;
          }

          /* Dealer Sales table header cells */
          .custom-dealer-table .ant-table-thead > tr > th,
          .custom-dealer-table .ant-table-thead > tr > th.ant-table-cell,
          .custom-dealer-table table > thead > tr > th {
            background-color: #DCDCDC !important;
            background: #DCDCDC !important;
            color: #000000 !important;
            font-weight: 700 !important;
            font-size: 12px !important;
            border-bottom: 2px solid #b0b0b0 !important;
            padding: 4px 6px !important;
            opacity: 1 !important;
            visibility: visible !important;
          }

          /* WTB Response table — white background, auto width, clean borders */
          .wtb-response-table {
            width: auto !important;
          }
          .wtb-response-table table {
            width: auto !important;
            border-collapse: collapse !important;
            background-color: #fff !important;
          }
          .wtb-response-table .ant-table {
            background: transparent !important;
          }
          .wtb-response-table .ant-table-placeholder {
            display: none !important;
          }
          .wtb-response-table .ant-table-thead > tr > th {
            background-color: #fff !important;
            background: #fff !important;
            color: #000 !important;
            font-weight: 700 !important;
            font-size: 12px !important;
            border-bottom: 1px solid #bbb !important;
            white-space: nowrap !important;
          }
          .wtb-response-table .ant-table-tbody > tr > td {
            background-color: #fff !important;
            border-bottom: 1px solid #e8e8e8 !important;
            border-top: none !important;
          }
          .wtb-response-table .ant-table-tbody > tr:hover > td {
            background-color: #f5f5f5 !important;
          }
          .wtb-response-table .ant-table-tbody > tr:hover > td span[style*="ffff00"] {
            background-color: #ffff00 !important;
          }
        `}</style>

          {/* Added 'relative' to the outer container as requested */}
          <div className="overflow-hidden flex flex-col w-full mb-2 relative" style={{ backgroundColor: "#EDEDED", border: "1px solid #b0b0b0", borderTop: "none", borderRadius: "4px", boxShadow: "0 2px 4px rgba(0,0,0,0.15)" }}>
            {/* --- ROW 1: THE COMMON HEADING DIV --- */}
            <div className="flex w-full items-end z-0" style={{ backgroundColor: "#FFFFFF", borderBottom: "1px solid #b0b0b0" }}>
              {/* Heading Part 1: Tabs & Country */}
              <div className="w-[50%] !h-[2.2rem] flex items-end ml-1">
                <Tabs
                  tabBarStyle={{
                    marginBottom: 0,
                    borderBottom: "none",
                    backgroundColor: "transparent",
                    borderTop: "none",
                  }}
                  tabBarGutter={0}
                  type="card"
                  size="small"
                  activeKey={activeTopTab}
                  onChange={setActiveTopTab}
                  className="w-full mb-[-1px] custom-tabs" // CSS class applied here
                  style={{
                    borderBottom: "none",
                  }}
                  tabBarExtraContent={{
                    right: (
                      <div className="flex items-center gap-1.5 mr-2 lg:mr-4 h-full mb-1">
                        <span className="text-[10px] text-black font-bold uppercase tracking-wide">
                          Country:
                        </span>
                        <Input
                          value={isFindEntryMode ? getFindDisplayValue("country") : country}
                          onChange={(e) => {
                            if (isFindEntryMode) {
                              setFindCriteria((p) => ({ ...p, country: e.target.value }));
                              return;
                            }
                            setCountry(e.target.value);
                            setIsDirty(true);
                          }}
                          size="small"
                          className="w-30 h-5 text-[10px] font-bold text-black px-1.5 py-0.5 border border-gray-400 text-center"
                          style={{
                            backgroundColor: "#66ff66",
                            borderColor: "#CCCC00",
                            borderRadius: "2px",
                          }}
                        />
                      </div>
                    ),
                  }}
                  items={[
                    { key: "General", label: "General" },
                    { key: "Contact", label: "Contact" },
                    { key: "Office", label: "Office" },
                    { key: "Company", label: "Company" },
                    { key: "Document", label: "Doc" },
                    { key: "Web", label: "Web" },
                    { key: "Edit", label: "Edit" },
                  ].map((item) => ({
                    ...item,
                    label: (
                      <span className="text-[11px] font-medium px-2">
                        {item.label}
                      </span>
                    ),
                  }))}
                />
              </div>

              {/* Heading Part 2: Customer Comments */}
              <div className="w-[28%] flex items-center justify-between gap-1 overflow-hidden !h-[2.2rem] px-1">
                <span className="hidden xl:block text-black text-[11px] font-bold tracking-tight shrink-0 mr-1">
                  Customer Comments:
                </span>

                <div className="flex items-center gap-1.5 flex-1 min-w-0 justify-end pr-2">
                  <div className="flex items-center gap-1 min-w-0 shrink">
                    <label className="text-[11px] whitespace-nowrap text-black font-bold">
                      GLC Tag
                    </label>
                    <Input
                      size="small"
                      className="h-6 w-14 lg:w-16 text-[11px] rounded border-gray-300 px-1"
                      value={isFindEntryMode ? getFindDisplayValue("optionsRequested") : (quoteForm.optionsRequested || "")}
                      onChange={(e) => isFindEntryMode ? setFindCriteria((p) => ({ ...p, optionsRequested: e.target.value })) : onQuoteFormChange("optionsRequested", e.target.value)}
                      suffix={isFindEntryMode ? <SearchOutlined style={{ fontSize: 10, color: "#808080" }} /> : undefined}
                      style={isFindEntryMode ? { background: "#fffde7" } : undefined}
                    />
                  </div>

                  <div className="flex items-center gap-1 min-w-0 shrink-0">
                    <label className="text-[11px] whitespace-nowrap text-black font-bold">
                      ID
                    </label>
                    <Input
                      value={isFindEntryMode ? getFindDisplayValue("quoteId") : quoteForm.quoteId}
                      onChange={(e) => isFindEntryMode ? setFindCriteria((p) => ({ ...p, quoteId: e.target.value })) : handleQuoteIdChange(e.target.value)}
                      onPressEnter={(e) => { e.preventDefault(); if (isFindEntryMode) { performFind(); } else { maybeLoadQuoteById(); } }}
                      onBlur={isFindEntryMode ? undefined : maybeLoadQuoteById}
                      className="h-6 w-24 lg:w-28 text-[11px] rounded border-gray-300 px-1 font-semibold text-gray-700"
                      suffix={isFindEntryMode ? <SearchOutlined style={{ fontSize: 10, color: "#808080" }} /> : undefined}
                      style={isFindEntryMode ? { background: "#fffde7" } : undefined}
                    />
                  </div>

                  <Button
                    type="primary"
                    className="bg-[#C0C0C0] text-[10px] text-black font-bold w-5 h-5 flex items-center justify-center rounded border border-[#808080] shrink-0 shadow-sm transition-all"
                    onClick={() => {
                      const quoteIdToCopy = quoteForm.quoteId?.trim();
                      if (quoteIdToCopy) {
                        navigator.clipboard
                          .writeText(quoteIdToCopy)
                          .then(() => {
                            // message.success(
                            //   `Quote ID "${quoteIdToCopy}" copied to clipboard`,
                            // );
                          })
                          .catch(() => {
                            message.error("Failed to copy to clipboard");
                          });
                      } else {
                        message.warning("No Quote ID found");
                      }
                    }}
                  >
                    C
                  </Button>
                </div>
              </div>

              {/* Heading Part 3: Sourcing Notes Label */}
              <div className="w-[19%] flex items-center justify-between pl-2 pr-2 !h-[2.2rem]">
                <span className="text-black text-[11px] font-bold tracking-wider truncate">
                  Sourcing Notes:
                </span>
              </div>
            </div>

            {/* --- ROW 2: THE CONTENT AREA --- */}
            <div className="flex w-full h-[215px]">
              {/* Content Part 1 (58%) */}
              <div className="w-[50%] px-2 pt-1 border-r-2 border-gray-300" style={{ backgroundColor: "#FFFFFF" }}>
                {activeTopTab === "General" && (
                  <GeneralTab
                    setIsInConversation={handleConversationChange}
                    isInConversation={isInConversation}
                    settingPlus={settingPlus}
                    onAddRow={handleAddRow}
                    onSendFQ={handleSendFQ}
                    onFirstFollowUp={handleFirstFollowUp}
                    onSecondFollowUp={handleSecondFollowUp}
                    onFinalFollowUp={handleFinalFollowUp}
                    onLooking={handleLooking}
                    onOutOfStock={handleOutOfStock}
                    statusOptions={statusOptions}
                    sourceOptions={sourceOptions}
                    setIsStatusModalOpen={setIsStatusModalOpen}
                    quoteForm={quoteForm}
                    onQuoteFormChange={onQuoteFormChange}
                    isFindMode={isFindMode}
                    isFindResultsActive={isFindResultsActive}
                    findCriteria={findCriteria}
                    appliedFindCriteria={appliedFindCriteria}
                    setFindCriteria={setFindCriteria}
                  />
                )}
                {activeTopTab === "Contact" && (
                  <ContactTab
                    quoteForm={quoteForm}
                    onQuoteFormChange={onQuoteFormChange}
                  />
                )}
                {activeTopTab === "Office" && (
                  <OfficeTab quoteForm={quoteForm} />
                )}
                {activeTopTab === "Company" && <CompanyTab />}
                {activeTopTab === "Document" && <DocumentTab />}
                {activeTopTab === "Web" && (
                  <WebTab
                    quoteForm={quoteForm}
                    onQuoteFormChange={onQuoteFormChange}
                  />
                )}
                {activeTopTab === "Edit" && (
                  <EditTab
                    quoteForm={quoteForm}
                    onQuoteFormChange={onQuoteFormChange}
                    representativeOptions={representativeOptions}
                  />
                )}
              </div>

              {/* Content Part 2 (28%) */}
              <div className="w-[28%] border-r-2 border-gray-400 bg-white overflow-hidden">
                <textarea
                  placeholder="Type customer comments here..."
                  value={isFindEntryMode ? getFindDisplayValue("customerComments") : quoteForm.customerComments}
                  onChange={(e) => isFindEntryMode ? setFindCriteria((p) => ({ ...p, customerComments: e.target.value })) : onQuoteFormChange("customerComments", e.target.value)}
                  className="w-full h-full text-[12px] text-black leading-normal p-2 border-none outline-none resize-none bg-transparent"
                  style={{ overflowY: "scroll" }}
                />
              </div>

              {/* Content Part 3 (14%) - Sourcing Notes */}
              <div className="w-[22%] overflow-hidden" style={{ backgroundColor: "#A9C7E8" }}>
                <textarea
                  placeholder="Sourcing notes..."
                  value={isFindEntryMode ? getFindDisplayValue("notes") : quoteForm.notes}
                  onChange={(e) => isFindEntryMode ? setFindCriteria((p) => ({ ...p, notes: e.target.value })) : onQuoteFormChange("notes", e.target.value)}
                  className="w-full h-full text-[12px] text-black leading-normal p-2 border-none outline-none resize-none"
                  style={{ overflowY: "scroll", backgroundColor: "transparent" }}
                />
              </div>
            </div>
          </div>

          {/* Status Edit Modal with Blur Background */}
          {isStatusModalOpen && (
            <>
              {/* Blur overlay */}
              <div
                className="fixed inset-0 z-40 backdrop-blur-sm bg-white/30"
                onClick={() => setIsStatusModalOpen(false)}
              />

              {/* Modal */}
              <div className="fixed inset-0 z-50 flex items-start justify-center pt-20">
                <div className="relative bg-white rounded-lg shadow-xl border border-gray-300 w-80 max-h-96 overflow-hidden">
                  <div className="p-3 border-b border-gray-200 flex justify-between items-center">
                    <h3 className="text-[12px] font-semibold text-gray-700">
                      Edit Status Options
                    </h3>
                    <Button
                      type="text"
                      size="small"
                      className="h-5 w-5 p-0 text-gray-400 hover:text-gray-600"
                      onClick={() => setIsStatusModalOpen(false)}
                    >
                      ✕
                    </Button>
                  </div>

                  <div className="p-3 max-h-64 overflow-y-auto">
                    {/* Status List */}
                    <div className="space-y-2 mb-3">
                      {statusOptions.map((option, index) => (
                        <div
                          key={index}
                          className="flex items-center gap-1 group"
                        >
                          {editingStatus.index === index ? (
                            <>
                              <Input
                                value={editingStatus.value}
                                onChange={(e) =>
                                  setEditingStatus({
                                    ...editingStatus,
                                    value: e.target.value,
                                  })
                                }
                                size="small"
                                className="h-6 text-[10px] flex-1"
                                autoFocus
                                onPressEnter={handleSaveStatus}
                              />
                              <Button
                                type="primary"
                                size="small"
                                className="h-5 w-5 p-0 flex items-center justify-center bg-green-600 hover:bg-green-700"
                                onClick={handleSaveStatus}
                              >
                                <span className="text-[10px]">✓</span>
                              </Button>
                              <Button
                                type="text"
                                size="small"
                                className="h-5 w-5 p-0 flex items-center justify-center text-gray-500"
                                onClick={() =>
                                  setEditingStatus({ index: -1, value: "" })
                                }
                              >
                                <span className="text-[10px]">✕</span>
                              </Button>
                            </>
                          ) : (
                            <>
                              <span className="text-[10px] flex-1">
                                {option.label}
                              </span>
                              <div className="flex gap-1">
                                <Button
                                  type="text"
                                  size="small"
                                  className="h-4 w-4 p-0 flex items-center justify-center text-gray-400 hover:text-blue-600"
                                  onClick={() => handleEditStatus(index)}
                                >
                                  <EditOutlined className="text-[12px]" />
                                </Button>
                                <Button
                                  type="text"
                                  size="small"
                                  className="h-4 w-4 p-0 flex items-center justify-center text-gray-400 hover:text-red-600"
                                  onClick={() => handleDeleteStatus(index)}
                                >
                                  <RiDeleteBinLine className="text-[12px]" />
                                </Button>
                              </div>
                            </>
                          )}
                        </div>
                      ))}
                    </div>

                    {/* Add New Status */}
                    <div className="border-t border-gray-200 pt-2">
                      <div className="text-[10px] font-medium text-gray-500 mb-1">
                        Add New Status
                      </div>
                      <div className="flex items-center gap-1">
                        <Input
                          placeholder="Enter new status"
                          value={newStatus}
                          onChange={(e) => setNewStatus(e.target.value)}
                          size="small"
                          className="h-6 text-[10px] flex-1"
                          onPressEnter={handleAddStatus}
                        />
                        <Button
                          type="primary"
                          size="small"
                          className="h-6 px-2 text-[9px] bg-[#C0C0C0] text-black border border-[#808080]"
                          onClick={handleAddStatus}
                        >
                          Add
                        </Button>
                      </div>
                    </div>
                  </div>

                  <div className="p-2 border-t border-gray-200 flex justify-end">
                    <Button
                      size="small"
                      className="h-6 px-3 text-[9px]"
                      onClick={() => setIsStatusModalOpen(false)}
                    >
                      Close
                    </Button>
                  </div>
                </div>
              </div>
            </>
          )}

          <div className="bg-white overflow-hidden flex flex-1 min-h-0" style={{ boxShadow: "0 4px 12px rgba(0,0,0,0.2)", border: "none" }}>
            {/* LEFT: Fixed 50% Scrollable Table */}
            <div className="w-[41%] border-r border-gray-400 flex flex-col overflow-hidden">
              {/* Inventory rows — all models in the quote, always min 3 rows */}
              {(() => {
                const allInvRows = tableData.flatMap((row) => inventoryByRow[row.key] || []);
                const formatPrice = (v: any) =>
                  v != null && v !== ""
                    ? Number(v).toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2 })
                    : "";
                const COLS = "90px 90px 1fr 80px 90px 22px";
                const ROW_H = 25;
                const minRows = 3;
                const totalRows = Math.max(allInvRows.length, minRows);
                const scrollable = allInvRows.length > minRows;
                return (
                  <div style={{
                    flexShrink: 0,
                    border: "1px solid #000",
                    maxHeight: ROW_H * minRows,
                    overflowY: scrollable ? "auto" : "hidden",
                  }}>
                    {Array.from({ length: totalRows }).map((_, i) => {
                      const inv = allInvRows[i];
                      const isLast = i === totalRows - 1;
                      return (
                        <div
                          key={inv?.invid ?? `blank-${i}`}
                          style={{
                            height: ROW_H,
                            backgroundColor: "#ffffcc",
                            borderBottom: isLast ? "none" : "1px solid #000",
                            display: "grid",
                            gridTemplateColumns: COLS,
                            alignItems: "center",
                            padding: "0 6px",
                            gap: 6,
                            fontSize: 11,
                            color: "#333",
                            flexShrink: 0,
                          }}
                        >
                          {inv ? (
                            <>
                              <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={inv.manu || ""}>{inv.manu || ""}</span>
                              <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={inv.model || ""}>{inv.model || ""}</span>
                              <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={inv.opt || ""}>{inv.opt || ""}</span>
                              <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={inv.status || ""}>{inv.status || ""}</span>
                              <span style={{ fontWeight: 600, whiteSpace: "nowrap" }}>{formatPrice(inv.sellDealer)}</span>
                              <span
                                onClick={() => navigate(`/inventory?invid=${inv.invid}`)}
                                style={{ cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", width: 18, height: 18, backgroundColor: "#8B0000", borderRadius: 2, flexShrink: 0 }}
                                title="Open inventory record"
                              >
                                <RightOutlined style={{ color: "#fff", fontSize: 9 }} />
                              </span>
                            </>
                          ) : null}
                        </div>
                      );
                    })}
                  </div>
                );
              })()}


              <div className="flex-1 overflow-y-auto flex flex-col">
                <div>
                  {tableData.map(renderSplitRow)}
                </div>
                <div
                  className="flex-1"
                  style={{
                    backgroundImage: tableData.length % 2 === 0
                      ? "repeating-linear-gradient(to bottom, #FFFFFF 0px, #FFFFFF 51px, #BDBDBD 51px, #BDBDBD 52px, #ffff99 52px, #ffff99 103px, #BDBDBD 103px, #BDBDBD 104px)"
                      : "repeating-linear-gradient(to bottom, #ffff99 0px, #ffff99 51px, #BDBDBD 51px, #BDBDBD 52px, #FFFFFF 52px, #FFFFFF 103px, #BDBDBD 103px, #BDBDBD 104px)",
                    backgroundSize: "100% 104px",
                    minHeight: 0,
                  }}
                />
              </div>

              <div className="sticky bottom-0 border-t p-1 space-y-1" style={{ backgroundColor: "#ffff99" }}>
                <div className="flex items-center gap-1 justify-end text-xs">
                  <span className="text-black font-bold">Sub Total:</span>{" "}
                  <Input
                    value={formatMoney(subTotalAmount)}
                    readOnly
                    size="small"
                    className="w-24 text-center font-bold text-xs py-1 border-gray-400"
                    style={{ backgroundColor: "#ffff99", borderRadius: "2px" }}
                  />
                </div>
                <div className="flex items-center gap-2 justify-end text-xs">
                  <span className="text-black font-bold">Final Total:</span>{" "}
                  <Input
                    value={formatMoney(finalTotalAmount)}
                    readOnly
                    size="small"
                    className="w-24 text-center font-bold text-xs py-1 border-gray-400"
                    style={{ backgroundColor: "#ffff99", borderRadius: "2px" }}
                  />
                </div>
                <div className="flex items-center gap-1 justify-end text-xs">
                  <span className="text-black font-bold">Gross Margin:</span>{" "}
                  <Input
                    value={
                      isFindEntryMode
                        ? getFindDisplayValue("grossMargin")
                        : isGrossMarginFocused
                          ? quoteForm.grossMargin
                          : quoteForm.grossMargin
                            ? formatMoney(parseCurrencyValue(quoteForm.grossMargin))
                            : ""
                    }
                    onFocus={() => setIsGrossMarginFocused(true)}
                    onBlur={() => setIsGrossMarginFocused(false)}
                    onChange={(e) =>
                      isFindEntryMode
                        ? setFindCriteria((p) => ({ ...p, grossMargin: e.target.value }))
                        : onQuoteFormChange("grossMargin", e.target.value)
                    }
                    placeholder="$0.00"
                    size="small"
                    className="w-24 text-center font-bold text-xs py-1 border-gray-400"
                    style={{ backgroundColor: "#ffff99", borderRadius: "2px" }}
                  />
                </div>
              </div>
            </div>

            <div className="w-[59%] flex flex-col overflow-hidden min-h-0" style={{ backgroundColor: "#DCDCDC" }}>
              <Tabs
                type="line"
                tabBarGutter={2} // Added spacing for right tabs
                activeKey={responsesTabKey}
                onChange={setResponsesTabKey}
                className="px-2 pt-1 custom-right-tabs !mb-0 flex-1 min-h-0 custom-dealer-tabs"
                items={[
                  {
                    key: "1",
                    label: (
                      <span className="text-[12px] px-1 py-0.5">
                        Dealer Sales
                      </span>
                    ),
                    children: (
                      <div className="flex flex-col flex-1 min-h-0">
                        {/* ── Dealer info bar ── */}
                        <div className="flex-shrink-0" style={{ backgroundColor: "#DCDCDC", borderBottom: "1px solid #b0b0b0", padding: "3px 4px" }}>
                          <div style={{ display: "flex", gap: 4, alignItems: "flex-end" }}>
                            {/* Send Mail */}
                            <div style={{ display: "flex", flexDirection: "column", flex: "0 0 180px" }}>
                              <span style={{ fontSize: 10, fontWeight: 700, color: "#333", marginBottom: 1 }}>Send Mail</span>
                              <div style={{ display: "flex", alignItems: "center", gap: 2 }}>
                                <div
                                  style={{ backgroundColor: "#b0b0b0", borderRadius: 2, width: 16, height: 16, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, fontWeight: 700, color: "#000", flexShrink: 0, cursor: "pointer" }}
                                  title="Send email"
                                  onClick={() => {
                                    const record = quotesResponsesData.find((r) => String(r.key) === selectedResponseInfo.key);
                                    if (!record) {
                                      message.warning("Select a dealer row first.");
                                      return;
                                    }
                                    sendDealerMail(record);
                                  }}
                                >
                                  @
                                </div>
                                <input
                                  readOnly
                                  value={selectedResponseInfo.sendMail}
                                  style={{ flex: 1, fontSize: 10, height: 18, border: "1px solid #999", borderRadius: 2, padding: "0 3px", backgroundColor: "#fff", minWidth: 0 }}
                                />
                              </div>
                            </div>
                            {/* Dealer Selling */}
                            <div style={{ display: "flex", flexDirection: "column", flex: "0 0 140px" }}>
                              <span style={{ fontSize: 10, fontWeight: 700, color: "#333", marginBottom: 1 }}>Dealer Selling</span>
                              <input
                                readOnly
                                value={selectedResponseInfo.dealerSelling}
                                style={{ fontSize: 10, height: 18, border: "1px solid #999", borderRadius: 2, padding: "0 3px", backgroundColor: "#fff", width: "100%" }}
                              />
                            </div>
                            {/* Tel */}
                            <div style={{ display: "flex", flexDirection: "column", flex: "0 0 110px" }}>
                              <span style={{ fontSize: 10, fontWeight: 700, color: "#333", marginBottom: 1 }}>Tel:</span>
                              <input
                                readOnly
                                value={selectedResponseInfo.tel}
                                style={{ fontSize: 10, height: 18, border: "1px solid #999", borderRadius: 2, padding: "0 3px", backgroundColor: "#fff", width: "100%" }}
                              />
                            </div>
                            {/* Alt Tel */}
                            <div style={{ display: "flex", flexDirection: "column", flex: "0 0 110px" }}>
                              <span style={{ fontSize: 10, fontWeight: 700, color: "#333", marginBottom: 1 }}>Alt Tel</span>
                              <input
                                readOnly
                                value={selectedResponseInfo.altTel}
                                style={{ fontSize: 10, height: 18, border: "1px solid #999", borderRadius: 2, padding: "0 3px", backgroundColor: "#fff", width: "100%" }}
                              />
                            </div>
                          </div>
                        </div>

                        {selectedModelForResponses && (
                          <div className="flex-shrink-0 px-2 py-1" style={{ backgroundColor: "#DCDCDC" }}>
                            <div className="text-[12px] font-bold px-3 py-0" style={{ backgroundColor: "#ffff66", color: "#000000", border: "1px solid #cccc00", width: "fit-content", lineHeight: "18px" }}>
                              Currently Viewing: {selectedModelForResponses}
                            </div>
                          </div>
                        )}
                        <div
                          ref={dealerSalesTableWrapperRef}
                          className="flex-1 min-h-0"
                          style={{ overflowY: "auto", overflowX: "hidden" }}
                        >
                          <Table
                            size="small"
                            className="custom-dealer-table"
                            columns={dealerSalesColumns}
                            dataSource={quotesResponsesData}
                            loading={responsesLoading}
                            pagination={false}
                            onRow={(record) => ({
                              onClick: () => setSelectedResponseInfo({
                                key: String(record.key),
                                sendMail: record.sendMail || "",
                                dealerSelling: record.dealerSelling || "",
                                tel: record.tel || "",
                                altTel: record.altTel || "",
                              }),
                              style: { cursor: "pointer" },
                            })}
                          />
                          {responsesLoadingMore ? (
                            <div className="px-2 py-1 text-[11px] text-gray-500">
                              Loading more...
                            </div>
                          ) : null}
                        </div>
                      </div>
                    ),
                  },
                  {
                    key: "6",
                    label: (
                      <span className="text-[12px] px-1 py-0.5">Cust Email</span>
                    ),
                    children: (
                      <div className="flex flex-col flex-1 min-h-0">
                        <div className="flex-shrink-0 flex items-center gap-2 px-2 py-1" style={{ backgroundColor: "#DCDCDC" }}>
                          <Input
                            size="small"
                            allowClear
                            value={custEmailSearch}
                            onChange={(event) => setCustEmailSearch(event.target.value)}
                            placeholder="Search sender or subject"
                            prefix={<SearchOutlined style={{ fontSize: 11, color: "#9ca3af" }} />}
                            style={{ width: 200, fontSize: 11 }}
                          />
                          <div className="text-[12px] font-bold px-3 py-0" style={{ backgroundColor: "#ffff66", color: "#000000", border: "1px solid #cccc00", width: "fit-content", lineHeight: "18px" }}>
                            {quoteEmailRecordKey
                              ? `Quote: ${quoteEmailRecordKey}`
                              : "Save or open a quote to see its email history"}
                          </div>
                          <button
                            type="button"
                            className="text-[11px] font-semibold leading-[18px] px-3 border border-black rounded-none bg-[#CCFFFF] text-black hover:bg-[#b3f0f0] active:bg-[#99e0e0]"
                            onClick={() => navigate(buildEmailPagePath("customer"))}
                          >
                            Full email history
                          </button>
                        </div>
                        <div className="flex-1 min-h-0 overflow-auto p-2" style={{ backgroundColor: "#fff" }}>
                          <EmailThreadPanel
                            linkType="quote"
                            recordKey={quoteEmailRecordKey}
                            keyLabel="Quote"
                            refreshToken={responsesRefreshKey}
                            search={custEmailSearch}
                            compact
                          />
                        </div>
                      </div>
                    ),
                  },
                  {
                    key: "2",
                    label: (
                      <span className="text-[12px] px-1 py-0.5">eBay</span>
                    ),
                    children: (
                      <div className="flex flex-col flex-1 min-h-0">
                        <div className="flex-shrink-0 px-2 py-1 flex flex-wrap items-center gap-2" style={{ backgroundColor: "#DCDCDC" }}>
                          {selectedModelForResponses && (
                            <div className="text-[12px] font-bold px-3 py-0" style={{ backgroundColor: "#ffff66", color: "#000000", border: "1px solid #cccc00", width: "fit-content", lineHeight: "18px" }}>
                              Currently Viewing: {selectedModelForResponses}
                            </div>
                          )}
                          <div className="flex items-center gap-1 ml-auto">
                            <span className="text-[12px] text-gray-700">Ship to:</span>
                            <Select
                              size="small"
                              value={ebayCountry}
                              onChange={(value) => setEbayCountry(value)}
                              options={EBAY_SHIP_COUNTRIES}
                              showSearch
                              optionFilterProp="label"
                              style={{ width: 150, fontSize: 12 }}
                            />
                          </div>
                        </div>
                        <div className="flex-1 min-h-0 overflow-y-auto p-3" style={{ backgroundColor: "#fff" }}>
                          {ebayLoading ? (
                            <div className="text-[12px] text-gray-500 text-center py-6">
                              Searching eBay...
                            </div>
                          ) : ebayError ? (
                            <div className="text-[12px] text-red-600 text-center py-6">
                              {ebayError}
                            </div>
                          ) : ebayItems.length === 0 ? (
                            <div className="flex flex-col items-center py-6 gap-2">
                              <img src={EBay} alt="eBay" className="w-40" />
                              <span className="text-[12px] text-gray-500">
                                {selectedModelForResponses
                                  ? "No eBay results found for this equipment."
                                  : "Select a row to search eBay."}
                              </span>
                            </div>
                          ) : (
                            <div className="flex flex-col gap-2">
                              {!ebayExactMatch && (
                                <div className="text-[11px] text-gray-600 italic">
                                  No exact match — showing related results for "{ebayMatchedQuery}"
                                </div>
                              )}
                              <div className="grid grid-cols-2 gap-3">
                              {ebayItems.map((item) => (
                                <a
                                  key={item.itemId}
                                  href={item.itemWebUrl}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="flex gap-2 border border-gray-300 rounded p-2 hover:bg-gray-50"
                                >
                                  {item.imageUrl ? (
                                    <img
                                      src={item.imageUrl}
                                      alt={item.title}
                                      className="w-16 h-16 object-contain flex-shrink-0"
                                    />
                                  ) : null}
                                  <div className="flex flex-col min-w-0">
                                    <span className="text-[11px] font-semibold text-gray-800 truncate">
                                      {item.title}
                                    </span>
                                    <span className="text-[11px] text-green-700 font-bold">
                                      {item.price || "-"}
                                    </span>
                                    <span className="text-[10px] text-gray-500 truncate">
                                      {item.condition || ""}
                                    </span>
                                  </div>
                                </a>
                              ))}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    ),
                  },
                  {
                    key: "7",
                    label: (
                      <span className="text-[12px] px-1 py-0.5">
                        Dealer Emails
                      </span>
                    ),
                    children: (
                      <div className="flex flex-col flex-1 min-h-0">
                        <div className="flex-shrink-0 flex items-center gap-2 px-2 py-1" style={{ backgroundColor: "#DCDCDC" }}>
                          <Input
                            size="small"
                            allowClear
                            value={dealerEmailSearch}
                            onChange={(event) => setDealerEmailSearch(event.target.value)}
                            placeholder="Search sender or subject"
                            prefix={<SearchOutlined style={{ fontSize: 11, color: "#9ca3af" }} />}
                            style={{ width: 200, height: 24, fontSize: 11 }}
                          />
                          {/* The picker only commits a typed date on Enter or a
                              calendar click, so the list kept showing mail
                              outside the range while a date sat typed in the
                              box. Apply each end as soon as it is a full
                              MM/DD/YY date, or cleared. */}
                          <span
                            className="flex flex-shrink-0"
                            onInput={(event) => {
                              const target = event.target as HTMLInputElement;
                              const inputs = Array.from(
                                event.currentTarget.querySelectorAll("input"),
                              );
                              const index = inputs.indexOf(target);
                              if (index !== 0 && index !== 1) return;
                              const text = target.value.trim();
                              let next: dayjs.Dayjs | null;
                              if (!text) {
                                next = null;
                              } else {
                                const match = /^(\d{2})\/(\d{2})\/(\d{2})$/.exec(text);
                                if (!match) return;
                                const [, mm, dd, yy] = match;
                                next = dayjs(new Date(2000 + Number(yy), Number(mm) - 1, Number(dd)));
                                // Rejects rollovers such as 02/31/26.
                                if (next.format("MM/DD/YY") !== text) return;
                              }
                              setDealerEmailDateRange((current) => {
                                const range: [dayjs.Dayjs | null, dayjs.Dayjs | null] = [
                                  current?.[0] ?? null,
                                  current?.[1] ?? null,
                                ];
                                range[index] = next;
                                return range;
                              });
                            }}
                          >
                          <DatePicker.RangePicker
                            size="small"
                            allowClear
                            allowEmpty={[true, true]}
                            value={dealerEmailDateRange}
                            onChange={(range) => setDealerEmailDateRange(range)}
                            // Apply each end as soon as it is picked, so a
                            // From-only or To-only range filters too.
                            onCalendarChange={(range) => setDealerEmailDateRange(range)}
                            // A typed date only commits on Enter or a calendar
                            // click by default; also commit it on blur/Tab.
                            changeOnBlur
                            format="MM/DD/YY"
                            placeholder={["From", "To"]}
                            separator={<span style={{ fontSize: 10, color: "#9ca3af" }}>–</span>}
                            suffixIcon={null}
                            style={{ width: 150, height: 24, fontSize: 11, flexShrink: 0, padding: "0 6px" }}
                          />
                          </span>
                          <div className="text-[12px] font-bold px-3 py-0" style={{ backgroundColor: "#ffff66", color: "#000000", border: "1px solid #cccc00", maxWidth: "70%", lineHeight: "18px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                            {dealerEmailRecordKey
                              ? `Models: ${dealerEmailRecordKey.split(",").join(", ")}`
                              : "Add a model to the quote to see dealer email history"}
                          </div>
                          <button
                            type="button"
                            className="text-[11px] font-semibold leading-[18px] px-3 border border-black rounded-none bg-[#CCFFFF] text-black hover:bg-[#b3f0f0] active:bg-[#99e0e0]"
                            onClick={() => navigate(buildEmailPagePath("dealer"))}
                          >
                            Full email history
                          </button>
                        </div>
                        <div className="flex-1 min-h-0 overflow-auto p-2" style={{ backgroundColor: "#fff" }}>
                          <EmailThreadPanel
                            linkType="dealer"
                            recordKey={dealerEmailRecordKey}
                            keyLabel="Model"
                            refreshToken={responsesRefreshKey}
                            search={dealerEmailSearch}
                            dateFrom={dealerEmailDateRange?.[0]?.toDate() ?? null}
                            dateTo={dealerEmailDateRange?.[1]?.toDate() ?? null}
                            compact
                          />
                        </div>
                      </div>
                    ),
                  },
                  {
                    key: "3",
                    label: (
                      <span className="text-[12px] px-1 py-0.5">EU Quotes</span>
                    ),
                    children: (
                      <div className="flex flex-col flex-1 min-h-0">
                        {selectedModelForResponses && (
                          <div className="flex-shrink-0 px-2 py-1" style={{ backgroundColor: "#DCDCDC" }}>
                            <div className="text-[12px] font-bold px-3 py-0" style={{ backgroundColor: "#ffff66", color: "#000000", border: "1px solid #cccc00", width: "fit-content", lineHeight: "18px" }}>
                              Currently Viewing: {selectedModelForResponses}
                            </div>
                          </div>
                        )}
                        <div
                          ref={euQuotesTableWrapperRef}
                          className="flex-1 min-h-0"
                          style={{ overflowY: "auto", overflowX: "hidden" }}
                        >
                          <Table
                            size="small"
                            className="custom-eu-table"
                            columns={euQuotesColumns}
                            dataSource={euQuotesData}
                            loading={euQuotesLoading}
                            pagination={false}
                            tableLayout="fixed"
                            style={{ width: "100%" }}
                          />
                          {responsesLoadingMore ? (
                            <div className="px-2 py-1 text-[11px] text-gray-500">
                              Loading more...
                            </div>
                          ) : null}
                        </div>
                      </div>
                    ),
                  },
                  {
                    key: "4",
                    label: (
                      <span className="text-[12px] px-1 py-0.5">
                        Dealer WTB
                      </span>
                    ),
                    children: (
                      <div className="flex flex-col h-full">
                        {selectedModelForResponses && (
                          <div className="flex-shrink-0 px-2 py-1" style={{ backgroundColor: "#DCDCDC" }}>
                            <div className="text-[12px] font-bold px-3 py-0" style={{ backgroundColor: "#ffff66", color: "#000000", border: "1px solid #cccc00", width: "fit-content", lineHeight: "18px" }}>
                              Currently Viewing: {selectedModelForResponses}
                            </div>
                          </div>
                        )}
                        <div ref={wtbTableWrapperRef} className="flex-1 overflow-auto min-h-0" style={{ backgroundColor: "#DCDCDC", padding: "8px" }}>
                          <div style={{ display: "flex", justifyContent: "center" }}>
                            <Table
                              size="small"
                              className="wtb-response-table"
                              columns={wtbResponseColumns}
                              dataSource={quotesWtbData}
                              loading={wtbLoading}
                              pagination={false}
                              tableLayout="auto"
                              style={{ width: "auto", border: "1px solid #bbb" }}
                            />
                          </div>
                        </div>
                      </div>
                    ),
                  },
                  {
                    key: "5",
                    label: (
                      <span className="text-[12px] px-1 py-0.5">USEDLINE</span>
                    ),
                    children: (
                      <div className="p-10 flex flex-col items-center justify-center">
                        <img
                          src={UsedLine_logo}
                          alt="Usedline"
                          className="w-90 h-70"
                        />
                      </div>
                    ),
                  },
                ]
                  .filter((tab) => !HIDDEN_RESPONSE_TAB_KEYS.has(tab.key))
                  // The two email tabs follow the same allow-list as the
                  // Customer/Dealer Email buttons in the header.
                  .filter(
                    (tab) =>
                      showEmailResponseTabs ||
                      !EMAIL_RESPONSE_TAB_KEYS.has(tab.key),
                  )}
              />
            </div>
          </div>
        </div>
      </ConfigProvider>
      {showFQResendConfirm && (
        <>
          <div className="fixed inset-0 z-40 backdrop-blur-sm bg-black/30" />
          <div className="fixed inset-0 z-50 flex items-center justify-center">
            <div className="bg-white rounded-lg shadow-xl border border-gray-300 w-80 p-6">
              <div className="text-sm font-semibold text-gray-800 mb-2">FQ Already Sent</div>
              <div className="text-xs text-gray-600 mb-5">
                This quote was previously sent ({quoteForm.quoteSent}). Do you want to send it again?
              </div>
              <div className="flex justify-end gap-2">
                <button
                  className="px-4 py-1.5 text-xs border border-gray-400 rounded hover:bg-gray-100"
                  onClick={() => setShowFQResendConfirm(false)}
                >
                  No
                </button>
                <button
                  className="px-4 py-1.5 text-xs bg-yellow-400 border border-gray-800 rounded font-bold hover:bg-yellow-500"
                  onClick={() => { setShowFQResendConfirm(false); executeSendFQ(); }}
                >
                  Yes, Send Again
                </button>
              </div>
            </div>
          </div>
        </>
      )}

      {isManufacturerModalOpen && (
        <>
          {/* Blur overlay */}
          <div
            className="fixed inset-0 z-40 backdrop-blur-sm bg-white/30"
            onClick={() => {
              setIsManufacturerModalOpen(false);
              setEditingManufacturer(null);
              setNewManufacturerName("");
            }}
          />

          {/* Modal */}
          <div className="fixed inset-0 z-50 flex items-start justify-center pt-20">
            <div className="relative bg-white rounded-lg shadow-xl border border-gray-300 w-96 max-h-[500px] overflow-hidden">
              <div className="p-3 border-b border-gray-200 flex justify-between items-center bg-gray-50">
                <h3 className="text-[14px] font-semibold text-gray-700">
                  Manage Manufacturers
                </h3>
                <Button
                  type="text"
                  size="small"
                  className="h-6 w-6 p-0 text-gray-400 hover:text-gray-600"
                  onClick={() => {
                    setIsManufacturerModalOpen(false);
                    setEditingManufacturer(null);
                    setNewManufacturerName("");
                  }}
                >
                  ✕
                </Button>
              </div>

              <div className="p-3 max-h-[300px] overflow-y-auto">
                {/* Manufacturer List */}
                <div className="space-y-2">
                  <div className="text-[11px] font-medium text-gray-500 mb-2">
                    Existing Manufacturers ({manufacturers.length})
                  </div>
                  {manufacturers.map((manufacturer) => (
                    <div
                      key={manufacturer.id}
                      className="flex items-center gap-1 group bg-gray-50 rounded p-1.5"
                    >
                      {editingManufacturer?.id === manufacturer.id ? (
                        <>
                          <Input
                            value={editingManufacturer.name}
                            onChange={(e) =>
                              setEditingManufacturer({
                                ...editingManufacturer,
                                name: e.target.value,
                              })
                            }
                            size="small"
                            className="h-7 text-[11px] flex-1"
                            autoFocus
                            onPressEnter={handleUpdateManufacturer}
                          />
                          <Button
                            type="primary"
                            size="small"
                            className="h-6 w-6 p-0 flex items-center justify-center bg-green-600 hover:bg-green-700"
                            onClick={handleUpdateManufacturer}
                          >
                            <span className="text-[11px]">✓</span>
                          </Button>
                          <Button
                            type="text"
                            size="small"
                            className="h-6 w-6 p-0 flex items-center justify-center text-gray-500"
                            onClick={() => setEditingManufacturer(null)}
                          >
                            <span className="text-[11px]">✕</span>
                          </Button>
                        </>
                      ) : (
                        <>
                          <span className="text-[11px] flex-1">
                            {manufacturer.name}
                          </span>
                          <div className="flex gap-1">
                            <Button
                              type="text"
                              size="small"
                              className="h-5 w-5 p-0 flex items-center justify-center text-gray-400 hover:text-blue-600"
                              onClick={() =>
                                setEditingManufacturer({
                                  id: manufacturer.id,
                                  name: manufacturer.name,
                                })
                              }
                            >
                              <EditOutlined className="text-[12px]" />
                            </Button>
                            <Button
                              type="text"
                              size="small"
                              className="h-5 w-5 p-0 flex items-center justify-center text-gray-400 hover:text-red-600"
                              onClick={() =>
                                handleDeleteManufacturer(
                                  manufacturer.id,
                                  manufacturer.name,
                                )
                              }
                            >
                              <RiDeleteBinLine className="text-[12px]" />
                            </Button>
                          </div>
                        </>
                      )}
                    </div>
                  ))}

                  {manufacturers.length === 0 && (
                    <div className="text-center text-gray-400 text-[11px] py-4">
                      No manufacturers added yet
                    </div>
                  )}
                </div>
              </div>

              {/* Add New Manufacturer — frozen below the list */}
              <div className="px-3 py-2 border-t border-gray-200 bg-white">
                <div className="text-[11px] font-medium text-gray-500 mb-2">
                  Add New Manufacturer
                </div>
                <div className="flex items-center gap-2">
                  <Input
                    placeholder="Enter manufacturer name"
                    value={newManufacturerName}
                    onChange={(e) => setNewManufacturerName(e.target.value)}
                    size="small"
                    className="h-7 text-[11px] flex-1"
                    onPressEnter={handleAddManufacturer}
                  />
                  <Button
                    type="default"
                    size="small"
                    className="h-7 px-3 text-[11px] bg-[#C0C0C0] hover:!bg-[#b0b0b0] text-black hover:!text-black border border-[#808080] hover:!border-[#808080]"
                    onClick={handleAddManufacturer}
                  >
                    Add
                  </Button>
                </div>
              </div>

              <div className="p-2 border-t border-gray-200 flex justify-end bg-gray-50">
                <Button
                  size="small"
                  className="h-7 px-3 text-[11px]"
                  onClick={() => {
                    setIsManufacturerModalOpen(false);
                    setEditingManufacturer(null);
                    setNewManufacturerName("");
                  }}
                >
                  Close
                </Button>
              </div>
            </div>
          </div>
        </>
      )}

      {isOrderTrackingModalOpen && otDraft && (
        <>
          <div
            className="fixed inset-0 z-40 backdrop-blur-sm bg-white/30"
            onClick={handleCancelOrderTracking}
          />
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div
              className="relative rounded-lg shadow-xl border border-gray-400 w-full max-w-[1620px] max-h-[92vh] overflow-y-auto"
              style={{ backgroundColor: "#CCFFCC" }}
            >
              {/* Title bar styled like the Order Tracking Center */}
              <div
                className="flex items-center justify-between px-4 py-2 border-b border-gray-400"
                style={{ backgroundColor: "#3399FF" }}
              >
                <h3 className="text-black font-bold text-[18px] m-0">
                  Order Tracking Center
                </h3>
                <Button
                  type="text"
                  size="small"
                  className="h-6 w-6 p-0 flex items-center justify-center text-black hover:!bg-white/30"
                  onClick={handleCancelOrderTracking}
                >
                  ✕
                </Button>
              </div>

              <OrderTrackingModalBody
                otDraft={otDraft}
                onFieldChange={handleOrderTrackingFieldChange}
                otStatusOptions={otStatusOptions}
                otVendorOptions={otVendorOptions}
                manufacturerOptions={manufacturerOptions}
                sourceOptions={sourceOptions}
                otcReps={otcReps}
                otcPmts={otcPmts}
                onOpenPmtModal={() => setIsPmtModalOpen(true)}
              />

              {/* Footer: Approve / Cancel */}
              <div className="p-3 border-t border-gray-400 flex justify-end gap-2 bg-white/40">
                <Button
                  size="small"
                  className="h-8 px-4 text-[12px]"
                  onClick={handleCancelOrderTracking}
                  disabled={isSubmittingOrderTracking}
                >
                  Cancel
                </Button>
                <Button
                  type="primary"
                  size="small"
                  className="h-8 px-4 text-[12px] bg-green-600 hover:!bg-green-700"
                  onClick={handleApproveOrderTracking}
                  loading={isSubmittingOrderTracking}
                >
                  Approve
                </Button>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Pmt Modal (Edit Pmt Options) */}
      {isPmtModalOpen && (
        <>
          <div
            className="fixed inset-0 z-[60] backdrop-blur-sm bg-white/30"
            onClick={() => {
              setIsPmtModalOpen(false);
              setEditingPmt(null);
              setNewPmtName("");
            }}
          />
          <div className="fixed inset-0 z-[70] flex items-start justify-center pt-20">
            <div className="relative bg-white rounded-lg shadow-xl border border-gray-300 w-80 max-h-96 overflow-hidden">
              <div className="p-3 border-b border-gray-200 flex justify-between items-center">
                <h3 className="text-[12px] font-semibold text-gray-700">
                  Edit Pmt Options
                </h3>
                <Button
                  type="text"
                  size="small"
                  className="h-5 w-5 p-0"
                  onClick={() => {
                    setIsPmtModalOpen(false);
                    setEditingPmt(null);
                    setNewPmtName("");
                  }}
                >
                  x
                </Button>
              </div>
              <div className="p-3 max-h-64 overflow-y-auto">
                <div className="space-y-2 mb-3">
                  {otcPmts.map((pmt) => (
                    <div key={pmt.id} className="flex items-center gap-1 group">
                      {editingPmt?.id === pmt.id ? (
                        <>
                          <Input
                            value={editingPmt.name}
                            onChange={(e) =>
                              setEditingPmt({ ...editingPmt, name: e.target.value })
                            }
                            size="small"
                            className="h-6 text-[10px] flex-1"
                            autoFocus
                            onPressEnter={async () => {
                              if (!editingPmt.name.trim()) return;
                              await updateOtcPmt(editingPmt.id, editingPmt.name.trim());
                              setEditingPmt(null);
                              refreshOtcPmts();
                            }}
                          />
                          <Button
                            type="primary"
                            size="small"
                            className="h-5 w-5 p-0 flex items-center justify-center bg-green-600"
                            onClick={async () => {
                              if (!editingPmt.name.trim()) return;
                              await updateOtcPmt(editingPmt.id, editingPmt.name.trim());
                              setEditingPmt(null);
                              refreshOtcPmts();
                            }}
                          >
                            <span className="text-[10px]">✓</span>
                          </Button>
                          <Button
                            type="text"
                            size="small"
                            className="h-5 w-5 p-0"
                            onClick={() => setEditingPmt(null)}
                          >
                            <span className="text-[10px]">x</span>
                          </Button>
                        </>
                      ) : (
                        <>
                          <span className="text-[10px] flex-1">{pmt.name}</span>
                          <Button
                            type="text"
                            size="small"
                            className="h-4 w-4 p-0 text-gray-400 hover:text-blue-600"
                            onClick={() => setEditingPmt({ id: pmt.id, name: pmt.name })}
                          >
                            <EditOutlined className="text-[12px]" />
                          </Button>
                          <Button
                            type="text"
                            size="small"
                            className="h-4 w-4 p-0 text-gray-400 hover:text-red-600"
                            onClick={async () => {
                              await deleteOtcPmt(pmt.id);
                              refreshOtcPmts();
                            }}
                          >
                            <DeleteOutlined className="text-[12px]" />
                          </Button>
                        </>
                      )}
                    </div>
                  ))}
                </div>
                <div className="border-t border-gray-200 pt-2">
                  <div className="text-[10px] font-medium text-gray-500 mb-1">
                    Add New Pmt
                  </div>
                  <div className="flex items-center gap-1">
                    <Input
                      placeholder="Enter pmt name"
                      value={newPmtName}
                      onChange={(e) => setNewPmtName(e.target.value)}
                      size="small"
                      className="h-6 text-[10px] flex-1"
                      onPressEnter={async () => {
                        if (!newPmtName.trim()) return;
                        await createOtcPmt(newPmtName.trim());
                        setNewPmtName("");
                        refreshOtcPmts();
                      }}
                    />
                    <Button
                      type="primary"
                      size="small"
                      className="h-6 px-2 text-[9px] bg-[#004aad]"
                      onClick={async () => {
                        if (!newPmtName.trim()) return;
                        await createOtcPmt(newPmtName.trim());
                        setNewPmtName("");
                        refreshOtcPmts();
                      }}
                    >
                      Add
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

// Mirrors the field layout of the real Order Tracking Center record
// (src/Pages/order-tracking/order-tracking.tsx RecordDetail) so the modal
// looks identical to that page's "new record" form.
const otModalInputStyle: React.CSSProperties = {
  height: 28,
  fontSize: 12,
  borderRadius: 2,
  border: "1px solid #292929",
};
const otModalLabelCls = "text-[11px] font-bold text-black mb-1 block";

const OrderTrackingModalBody = ({
  otDraft,
  onFieldChange,
  otStatusOptions,
  otVendorOptions,
  manufacturerOptions,
  sourceOptions,
  otcReps,
  otcPmts,
  onOpenPmtModal,
}: {
  otDraft: OpenOrderData;
  onFieldChange: (field: keyof OpenOrderData, value: any) => void;
  otStatusOptions: Array<{ value: string; label: string }>;
  otVendorOptions: Array<{ value: string; label: string }>;
  manufacturerOptions: Array<{ value: string; label: string }>;
  sourceOptions: Array<{ value: string; label: string }>;
  otcReps: Array<{ id: number; name: string }>;
  otcPmts: Array<{ id: number; name: string }>;
  onOpenPmtModal: () => void;
}) => {
  const [focusedMoneyField, setFocusedMoneyField] = useState<string | null>(null);
  const parseOtMoneyValue = (value: any) => {
    const parsed = Number(String(value || "").replace(/[^0-9.-]/g, ""));
    return Number.isFinite(parsed) ? parsed : 0;
  };
  const formatOtMoneyValue = (value: any) => {
    const numericValue = parseOtMoneyValue(value);
    return numericValue
      ? numericValue.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : "";
  };

  const lineItemRows = [
    {
      n: 1,
      manu: "manu" as const,
      model: "model" as const,
      qty: "qty" as const,
      vendor: "vendor" as const,
      sn: "sn" as const,
      rentalPeriod: "rentalPeriod" as const,
      showSn: true,
    },
    {
      n: 2,
      manu: "manu2" as const,
      model: "model2" as const,
      qty: "qty2" as const,
      vendor: "vendor2" as const,
      sn: "sn2" as const,
      rentalPeriod: "rentalPeriod2" as const,
      showSn: true,
    },
    {
      n: 3,
      manu: "manu3" as const,
      model: "model3" as const,
      qty: "qty3" as const,
      vendor: "vendor3" as const,
      sn: null,
      rentalPeriod: null,
      showSn: false,
    },
    {
      n: 4,
      manu: "manu4" as const,
      model: "model4" as const,
      qty: "qty4" as const,
      vendor: "vendor4" as const,
      sn: null,
      rentalPeriod: null,
      showSn: false,
    },
    {
      n: 5,
      manu: "manu5" as const,
      model: "model5" as const,
      qty: "qty5" as const,
      vendor: "vendor5" as const,
      sn: null,
      rentalPeriod: null,
      showSn: false,
    },
  ];

  return (
    <div className="p-3">
      {/* Top row: Rep / PO Date / Cust PO# / Customer / Gross Sale / Gross Margin / Pmt / PO Status */}
      <div
        className="grid gap-x-2"
        style={{ gridTemplateColumns: "90px 110px 110px 200px 110px 110px 90px 140px 1fr" }}
      >
        <div>
          <span className={otModalLabelCls}>Rep</span>
          <Select
            showSearch
            allowClear
            className="w-full"
            style={{ height: 28 }}
            placeholder="Select Rep"
            value={otDraft.rep || undefined}
            options={otcReps.map((rep) => ({
              value: rep.name,
              label: rep.name,
            }))}
            filterOption={(input, option) =>
              String(option?.label || "")
                .toLowerCase()
                .startsWith(input.toLowerCase())
            }
            onChange={(value) => onFieldChange("rep", value || "")}
          />
        </div>
        <div>
          <span className={otModalLabelCls}>PO Date</span>
          <DatePicker
            className="w-full"
            format="MM/DD/YYYY"
            style={{ height: 28, fontSize: 12 }}
            value={toDayjsValue(otDraft.poDate)}
            onChange={(_, dateString) =>
              onFieldChange("poDate", (dateString as string) || "")
            }
          />
        </div>
        <div>
          <span className={otModalLabelCls}>Cust PO #</span>
          <Input
            style={{ ...otModalInputStyle, color: "blue" }}
            placeholder="Enter Cust PO #"
            value={otDraft.custPo}
            onChange={(e) => onFieldChange("custPo", e.target.value)}
          />
        </div>
        <div>
          <span className={otModalLabelCls}>Customer</span>
          <Input
            style={{
              ...otModalInputStyle,
              backgroundColor: "#c0c0c0",
              fontWeight: "bold",
              color: "blue",
            }}
            placeholder="Enter Customer"
            value={otDraft.customer}
            onChange={(e) => onFieldChange("customer", e.target.value)}
          />
        </div>
        <div>
          <span className={otModalLabelCls}>Gross Sale</span>
          <Input
            style={otModalInputStyle}
            placeholder="$0.00"
            value={
              focusedMoneyField === "gs"
                ? String(otDraft.gs ?? "")
                : formatOtMoneyValue(otDraft.gs)
            }
            onFocus={() => setFocusedMoneyField("gs")}
            onBlur={() => setFocusedMoneyField(null)}
            onChange={(e) => onFieldChange("gs", e.target.value)}
          />
        </div>
        <div>
          <span className={otModalLabelCls}>Gross Margin</span>
          <Input
            style={{ ...otModalInputStyle, backgroundColor: "#c0c0c0" }}
            placeholder="$0.00"
            value={
              focusedMoneyField === "gm"
                ? String(otDraft.gm ?? "")
                : formatOtMoneyValue(otDraft.gm)
            }
            onFocus={() => setFocusedMoneyField("gm")}
            onBlur={() => setFocusedMoneyField(null)}
            onChange={(e) => onFieldChange("gm", e.target.value)}
          />
        </div>
        <div>
          <span className={otModalLabelCls}>Pmt</span>
          <Select
            className="w-full"
            size="small"
            style={{ height: 28 }}
            placeholder="Select Pmt"
            showSearch
            allowClear
            value={otDraft.pmt || undefined}
            options={[
              ...otcPmts.map((p) => ({ value: p.name, label: p.name })),
              { value: "___EDIT_PMTS___", label: "✎ Edit Pmts..." },
            ]}
            onChange={(value) => {
              if (value === "___EDIT_PMTS___") {
                onOpenPmtModal();
                return;
              }
              onFieldChange("pmt", value || "");
            }}
          />
        </div>
        <div>
          <span className={otModalLabelCls}>PO Status</span>
          <Select
            className="w-full"
            size="small"
            style={{ height: 28 }}
            placeholder="Select Status"
            value={otDraft.poStatus || undefined}
            options={otStatusOptions}
            onChange={(value) => onFieldChange("poStatus", value)}
          />
        </div>
      </div>

      {/* Rental? / Vendor RMA row */}
      <div className="flex items-center gap-6 mt-2">
        <div className="flex items-center gap-2">
          <span className="text-[11px] font-bold text-black whitespace-nowrap">
            Rental?
          </span>
          <Input
            style={{ ...otModalInputStyle, width: 140 }}
            value={otDraft.rental}
            onChange={(e) => onFieldChange("rental", e.target.value)}
          />
        </div>
        <div className="flex items-center gap-2">
          <span className="text-[11px] font-bold text-black whitespace-nowrap">
            Vendor RMA
          </span>
          <Input
            style={{ ...otModalInputStyle, width: 160 }}
            placeholder="Enter Vendor RMA"
            value={otDraft.vendorRma}
            onChange={(e) => onFieldChange("vendorRma", e.target.value)}
          />
        </div>
      </div>

      {/* Body: line items (left) / comments + tracking/rma (middle) / invoice+payment (right) */}
      <div className="grid gap-4 mt-3" style={{ gridTemplateColumns: "minmax(0,1fr) 220px 300px" }}>
        {/* Line items */}
        <div className="flex flex-col gap-3">
          {lineItemRows.map((row) => (
            <div key={row.n}>
              <div
                className="grid gap-x-2"
                style={{ gridTemplateColumns: "1fr 1fr 70px 1fr 150px" }}
              >
                <div>
                  <span className={otModalLabelCls}>Manu</span>
                  <Select
                    showSearch
                    className="w-full"
                    style={{ height: 28, fontSize: 12 }}
                    value={(otDraft as any)[row.manu] || undefined}
                    options={manufacturerOptions}
                    placeholder="Select..."
                    onChange={(value) => onFieldChange(row.manu, value || "")}
                    filterOption={(input, option) =>
                      String(option?.label || "")
                        .toLowerCase()
                        .startsWith(input.toLowerCase())
                    }
                  />
                </div>
                <div>
                  <span className={otModalLabelCls}>Model</span>
                  <Input
                    style={otModalInputStyle}
                    placeholder="Enter Model"
                    value={(otDraft as any)[row.model] || ""}
                    onChange={(e) => onFieldChange(row.model, e.target.value)}
                  />
                </div>
                <div>
                  <span className={otModalLabelCls}>Qty</span>
                  <Input
                    style={otModalInputStyle}
                    placeholder="En..."
                    value={(otDraft as any)[row.qty] || ""}
                    onChange={(e) => onFieldChange(row.qty, e.target.value)}
                  />
                </div>
                <div>
                  <span className={otModalLabelCls}>Vendor</span>
                  <Select
                    showSearch
                    className="w-full"
                    style={{ height: 28, fontSize: 12 }}
                    value={(otDraft as any)[row.vendor] || undefined}
                    options={otVendorOptions}
                    placeholder="Select Vendor..."
                    onChange={(value) => onFieldChange(row.vendor, value || "")}
                    filterOption={(input, option) =>
                      String(option?.label || "")
                        .toLowerCase()
                        .startsWith(input.toLowerCase())
                    }
                  />
                </div>
                {row.n <= 2 && (
                  <div>
                    <span className={otModalLabelCls}>Ship to Cust..</span>
                    <DatePicker
                      className="w-full"
                      style={{ height: 28, fontSize: 12 }}
                      value={toDayjsValue((otDraft as any)[`dateShipped${row.n === 1 ? "" : row.n}`])}
                      onChange={(_, dateString) =>
                        onFieldChange(
                          `dateShipped${row.n === 1 ? "" : row.n}` as keyof OpenOrderData,
                          (dateString as string) || "",
                        )
                      }
                    />
                  </div>
                )}
              </div>

              {row.showSn && (
                <div className="grid gap-x-2 items-center mt-1" style={{ gridTemplateColumns: "1fr 1fr 70px 1fr 150px" }}>
                  <div className="flex items-center gap-2">
                    <span className="text-[11px] font-bold text-black">SN</span>
                    <Input
                      style={{ ...otModalInputStyle, flex: 1 }}
                      placeholder="Enter SN"
                      value={row.sn ? (otDraft as any)[row.sn] || "" : ""}
                      onChange={(e) =>
                        row.sn && onFieldChange(row.sn, e.target.value)
                      }
                    />
                  </div>
                  <div />
                  <div />
                  <div className="flex items-center gap-2">
                    <span className="text-[11px] font-bold text-black whitespace-nowrap">
                      Rental Period
                    </span>
                  </div>
                  <div>
                    <Input
                      style={otModalInputStyle}
                      placeholder="Enter Rental Period"
                      value={row.rentalPeriod ? (otDraft as any)[row.rentalPeriod] || "" : ""}
                      onChange={(e) =>
                        row.rentalPeriod && onFieldChange(row.rentalPeriod, e.target.value)
                      }
                    />
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Middle: Comments + Tracking#s + RMA */}
        <div className="flex flex-col gap-3">
          <div>
            <span className={otModalLabelCls}>Comments</span>
            <Input.TextArea
              style={{ fontSize: 12, borderRadius: 2, resize: "none" }}
              rows={4}
              placeholder="Enter Comments"
              value={otDraft.comments}
              onChange={(e) => onFieldChange("comments", e.target.value)}
            />
          </div>
          <div>
            <span className={otModalLabelCls}>Tracking #s</span>
            <Input.TextArea
              style={{ fontSize: 12, borderRadius: 2, border: "1px solid #292929", resize: "none", height: 100 }}
              placeholder="Enter Tracking Info"
              value={otDraft.trackingNo}
              onChange={(e) => onFieldChange("trackingNo", e.target.value)}
            />
          </div>
          <div>
            <span className={otModalLabelCls}>RMA</span>
            <Input
              style={otModalInputStyle}
              placeholder="Enter RMA"
              value={otDraft.rma}
              onChange={(e) => onFieldChange("rma", e.target.value)}
            />
          </div>
          <div>
            <span className={otModalLabelCls}>RMA Comment</span>
            <Input.TextArea
              style={{ fontSize: 12, borderRadius: 2, border: "1px solid #292929", resize: "none" }}
              rows={2}
              placeholder="Enter RMA Comment"
              value={otDraft.rmaComment}
              onChange={(e) => onFieldChange("rmaComment", e.target.value)}
            />
          </div>
        </div>

        {/* Right: Invoice/Payment/Actions */}
        <div className="grid grid-cols-3 gap-2">
          <div>
            <span className={otModalLabelCls}>Invoice Date</span>
            <DatePicker
              className="w-full"
              style={{ height: 28, fontSize: 12 }}
              value={toDayjsValue(otDraft.invoiceDate)}
              onChange={(_, dateString) =>
                onFieldChange("invoiceDate", (dateString as string) || "")
              }
            />
          </div>
          <div>
            <span className={otModalLabelCls}>Invoice Number</span>
            <Input
              style={otModalInputStyle}
              value={otDraft.ateInvoiceNo}
              onChange={(e) => onFieldChange("ateInvoiceNo", e.target.value)}
            />
          </div>
          <div>
            <span className={otModalLabelCls}>Invoice Due Date</span>
            <DatePicker
              className="w-full"
              style={{ height: 28, fontSize: 12 }}
              value={toDayjsValue(otDraft.invoiceDueDate)}
              onChange={(_, dateString) =>
                onFieldChange("invoiceDueDate", (dateString as string) || "")
              }
            />
          </div>
          <div>
            <span className={otModalLabelCls}>Invoice Total</span>
            <Input
              style={{ ...otModalInputStyle, color: "red", fontWeight: "bold" }}
              prefix={<span style={{ color: "red", fontWeight: "bold" }}>$</span>}
              value={otDraft.invoiceTotal}
              onChange={(e) => onFieldChange("invoiceTotal", e.target.value)}
            />
          </div>
          <div>
            <span className={otModalLabelCls}>Paid?</span>
            <Input
              style={{ ...otModalInputStyle, color: "#dc2626", fontWeight: "bold" }}
              placeholder="Yes/No"
              value={otDraft.paid}
              onChange={(e) => onFieldChange("paid", e.target.value)}
            />
          </div>
          <div>
            <span className={otModalLabelCls}>Vendor Paid?</span>
            <DatePicker
              className="w-full"
              style={{ height: 28, fontSize: 12 }}
              value={toDayjsValue(otDraft.vendorPaid)}
              onChange={(_, dateString) =>
                onFieldChange("vendorPaid", (dateString as string) || "")
              }
            />
          </div>

          <div className="col-span-3">
            <span className={otModalLabelCls}>Actions</span>
            <Input
              style={{ ...otModalInputStyle, color: "#dc2626", fontWeight: 600 }}
              placeholder="Select or type Action"
              value={otDraft.actions}
              onChange={(e) => onFieldChange("actions", e.target.value)}
            />
          </div>
          <div className="col-span-2">
            <span className={otModalLabelCls}>Order Complete</span>
            <Select
              className="w-full"
              size="small"
              style={{ height: 28 }}
              placeholder="Select Status"
              value={otDraft.orderComplete || undefined}
              options={[
                { value: "Active order", label: "Active order" },
                { value: "Closed", label: "Closed" },
              ]}
              onChange={(value) => onFieldChange("orderComplete", value)}
            />
          </div>
          <div className="col-span-1" />

          <div className="col-span-3">
            <span className={otModalLabelCls}>Lead From</span>
            <Select
              className="w-full"
              size="small"
              style={{ height: 28 }}
              placeholder="Select Source"
              value={otDraft.leadFrom || undefined}
              options={sourceOptions}
              onChange={(value) => onFieldChange("leadFrom", value)}
            />
          </div>
        </div>
      </div>

      {/* Bottom: Quote ID / Sales Order # */}
      <div className="flex items-center gap-4 mt-3 pt-2 border-t-2 border-black">
        <div className="flex items-center gap-2">
          <span className="text-[11px] font-bold text-black">Quote ID</span>
          <Input
            style={{ ...otModalInputStyle, width: 140 }}
            value={otDraft.quoteId}
            onChange={(e) => onFieldChange("quoteId", e.target.value)}
          />
        </div>
        <div className="flex items-center gap-2">
          <span className="text-[11px] font-bold text-black whitespace-nowrap">
            Sales Order #
          </span>
          <Input
            style={{ ...otModalInputStyle, width: 140 }}
            placeholder="Enter Sales Order #"
            value={otDraft.salesOrder}
            onChange={(e) => onFieldChange("salesOrder", e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

// ... rest of the file (SmallInput, FieldRow, Sub-Components) remains identical ...
const SmallInput = (props: any) => (
  <Input
    {...props}
    size="small"
    className={`h-5 text-[11px] rounded-none ${props.className || ""}`}
    style={{ borderRadius: "2px", ...props.style }}
  />
);

const SmallSelect = (props: any) => (
  <Select
    {...props}
    size="small"
    className={`w-full text-[11px] ${props.className || ""}`}
    style={{ borderRadius: "2px", ...props.style }}
  />
);

const FieldRow = ({
  label,
  children,
  labelW = "w-20",
  labelStyle,
}: {
  label: string;
  children: React.ReactNode;
  labelW?: string;
  labelStyle?: React.CSSProperties;
}) => (
  <div className="flex items-center gap-2 mb-1">
    <label
      className={`text-[11px] font-semibold ${labelW} shrink-0`}
      style={{ color: "#800080", ...labelStyle }}
    >
      {label}
    </label>
    <div className="flex-1 min-w-0">{children}</div>
  </div>
);

const GeneralTab = ({
  setIsInConversation,
  isInConversation,
  settingPlus,
  onAddRow,
  onSendFQ,
  onFirstFollowUp,
  onSecondFollowUp,
  onFinalFollowUp,
  onLooking,
  onOutOfStock,
  statusOptions,
  sourceOptions,
  setIsStatusModalOpen,
  quoteForm,
  onQuoteFormChange,
  isFindMode,
  isFindResultsActive,
  findCriteria,
  appliedFindCriteria,
  setFindCriteria,
}: GeneralTabProps) => {
  const navigate = useNavigate();
  const getFindDisplayValue = (field: string) =>
    findCriteria[field] !== undefined
      ? String(findCriteria[field] || "")
      : String(appliedFindCriteria[field] || "");
  const isFindEntryMode = isFindMode && !isFindResultsActive;
  return (
    <>
      <div className="grid grid-cols-3 gap-x-2">
        {/* Column 1 */}
        <div className="col-span-1 flex flex-col">
          <div className="mb-1">
            <FieldRow label="Date" labelW="w-16">
              <DatePicker
                className="h-5 w-full text-[10px] rounded-none bg-[#ffcccc] bold-date-picker"
                style={{ borderRadius: "2px" }}
                size="small"
                value={
                  isFindEntryMode
                    ? toDayjsValue(getFindDisplayValue("createdDate"))
                    : toDayjsValue(quoteForm.createdDate)
                }
                format="MM/DD/YYYY"
                onChange={(_, dateString) =>
                  isFindEntryMode
                    ? setFindCriteria((p) => ({ ...p, createdDate: dateString || "" }))
                    : onQuoteFormChange(
                        "createdDate",
                        mergeDateWithExistingTime(dateString, quoteForm.createdDate) ||
                          quoteForm.createdDate,
                      )
                }
              />
            </FieldRow>
            <FieldRow label="Sources" labelW="w-16">
              <SmallSelect
                value={isFindEntryMode ? (getFindDisplayValue("quoteSource") || undefined) : (quoteForm.quoteSource || undefined)}
                popupClassName="sources-select-dropdown"
                className="compact-select grey-bg-select"
                options={sourceOptions}
                onChange={(value) =>
                  isFindEntryMode
                    ? setFindCriteria((p) => ({ ...p, quoteSource: value || "" }))
                    : onQuoteFormChange("quoteSource", value)
                }
              />
            </FieldRow>

            <FieldRow label="Status" labelW="w-16">
              <SmallSelect
                value={isFindEntryMode ? (getFindDisplayValue("quoteStatus") || undefined) : (quoteForm.quoteStatus || undefined)}
                popupClassName="status-select-dropdown"
                className="compact-select w-full grey-bg-select"
                options={[
                  ...statusOptions,
                  { value: "separator", label: "──────────", disabled: true },
                  {
                    value: "edit_status",
                    label: "✎ Edit Status...",
                    disabled: false,
                  },
                ]}
                onChange={(value) => {
                  if (value === "edit_status") {
                    setIsStatusModalOpen(true);
                    return;
                  }
                  if (isFindEntryMode) {
                    setFindCriteria((p) => ({ ...p, quoteStatus: String(value || "") }));
                    return;
                  }
                  onQuoteFormChange("quoteStatus", value);
                }}
              />
            </FieldRow>

            <FieldRow label="Sub Status" labelW="w-16" labelStyle={{ color: "#800080" }}>
              <div className="flex items-center gap-3 px-2" style={{ background: "#EDEDED", border: "1px solid #d0d0d0", borderRadius: "2px", height: "22px" }}>
                {(["Active", "InActive"] as const).map((val) => {
                  const currentSubStatus = isFindEntryMode ? getFindDisplayValue("subStatus") : (quoteForm.subStatus || "");
                  const checked = currentSubStatus === val;
                  return (
                    <span
                      key={val}
                      onClick={() =>
                        isFindEntryMode
                          ? setFindCriteria((p) => ({ ...p, subStatus: checked ? "" : val }))
                          : onQuoteFormChange("subStatus", checked ? "" : val)
                      }
                      className="flex items-center gap-1 cursor-pointer select-none"
                      style={{ fontSize: "11px", color: "#000000" }}
                    >
                      <span style={{
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "13px",
                        height: "13px",
                        borderRadius: "50%",
                        border: "1px solid #666",
                        background: "#fff",
                        flexShrink: 0,
                      }}>
                        {checked && (
                          <span style={{
                            width: "7px",
                            height: "7px",
                            borderRadius: "50%",
                            background: "#808080",
                            display: "block",
                          }} />
                        )}
                      </span>
                      {val}
                    </span>
                  );
                })}
              </div>
            </FieldRow>

            <FieldRow label="Reps" labelW="w-16">
              <SmallInput
                value={isFindEntryMode ? getFindDisplayValue("representativeName") : quoteForm.representativeName}
                placeholder={isFindEntryMode ? "Search rep..." : ""}
                readOnly={!isFindEntryMode}
                onChange={(e) => isFindEntryMode ? setFindCriteria((p) => ({ ...p, representativeName: e.target.value })) : undefined}
                suffix={isFindEntryMode ? <SearchOutlined style={{ fontSize: 10, color: "#808080" }} /> : undefined}
                className={isFindEntryMode ? "" : "bg-gray-100"}
                style={{ borderRadius: "2px", background: isFindEntryMode ? "#fffde7" : undefined }}
              />
            </FieldRow>
          </div>

          {/* Rest of the component remains the same */}
          <div className="flex items-center gap-1 mt-0">
            <span className="text-[10px] font-bold whitespace-nowrap" style={{ color: "#000000" }}>
              In Conversation?
            </span>
            <span
              onClick={() => setIsInConversation(!isInConversation)}
              className="px-2 text-[10px] font-bold h-5 flex items-center cursor-pointer select-none"
              style={{
                backgroundColor: "#FFFF00",
                color: "#000000",
                border: "1px solid #808080",
                borderRadius: "2px",
                boxShadow: "1px 1px 2px rgba(0,0,0,0.2)",
              }}
            >
              {isInConversation ? "Yes" : "No"}
            </span>
          </div>

          <div className="flex gap-1 mt-auto pt-1 items-center">
            <Button
              type="primary"
              className="h-6 w-24 text-[9px] px-1 font-bold"
              style={{
                backgroundColor: "#DCDCDC",
                color: "#000000",
                border: "1px solid #808080",
                borderRadius: "2px",
                boxShadow: "1px 1px 2px rgba(0,0,0,0.25)",
              }}
              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#D0D0D0"; }}
              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "#C0C0C0"; }}
              onClick={onLooking}
            >
              @Looking
            </Button>
            <Input
              size="small"
              className="h-6 border-gray-300 flex-1 text-[10px]"
              style={{ borderRadius: "2px" }}
            />
          </div>
        </div>

        {/* Column 2/3 - remains the same */}
        <div className="col-span-2 grid grid-cols-12 gap-x-2">
          <div className="col-span-8 space-y-1">
            <FieldRow label="Contact" labelW="w-20">
              <SmallInput
                placeholder={isFindEntryMode ? "Search contact..." : ""}
                value={isFindEntryMode ? getFindDisplayValue("contactName") : quoteForm.contactName}
                onChange={(e) => isFindEntryMode ? setFindCriteria((p) => ({ ...p, contactName: e.target.value })) : onQuoteFormChange("contactName", e.target.value)}
                suffix={isFindEntryMode ? <SearchOutlined style={{ fontSize: 10, color: "#808080" }} /> : undefined}
                style={{ borderRadius: "2px", background: isFindEntryMode ? "#fffde7" : undefined }}
              />
            </FieldRow>
            <FieldRow label="Email" labelW="w-20">
              <div className="flex items-center gap-1 w-full">
                <SmallInput
                  className="flex-1 min-w-0"
                  placeholder={isFindEntryMode ? "Search email..." : ""}
                  value={isFindEntryMode ? getFindDisplayValue("contactEmail") : quoteForm.contactEmail}
                  onChange={(e) => isFindEntryMode ? setFindCriteria((p) => ({ ...p, contactEmail: e.target.value })) : onQuoteFormChange("contactEmail", e.target.value)}
                  suffix={isFindEntryMode ? <SearchOutlined style={{ fontSize: 10, color: "#808080" }} /> : undefined}
                  style={{ borderRadius: "2px", background: isFindEntryMode ? "#fffde7" : undefined }}
                />
                <Button
                  type="primary"
                  size="small"
                  icon={<MailOutlined style={{ fontSize: 11 }} />}
                  className="flex-shrink-0"
                  style={{
                    borderRadius: 2,
                    height: 20,
                    fontSize: 10,
                    paddingInline: 8,
                    display: "inline-flex",
                    alignItems: "center",
                    background: "#16a34a",
                    borderColor: "#16a34a",
                  }}
                  onClick={() => {
                    // Open the OS default mail app addressed to the contact email.
                    const raw = String(quoteForm.contactEmail || "").trim();
                    const angleMatch = raw.match(/<([^>]+)>/);
                    const to = (angleMatch?.[1]?.trim() || raw).trim();
                    if (!to) {
                      message.warning("No contact email to send to.");
                      return;
                    }
                    window.location.href = `mailto:${encodeURIComponent(to)}`;
                  }}
                >
                  Email
                </Button>
              </div>
            </FieldRow>
            <FieldRow label="Company" labelW="w-20">
              <SmallInput
                placeholder={isFindEntryMode ? "Search company..." : ""}
                value={isFindEntryMode ? getFindDisplayValue("companyName") : quoteForm.companyName}
                onChange={(e) => isFindEntryMode ? setFindCriteria((p) => ({ ...p, companyName: e.target.value })) : onQuoteFormChange("companyName", e.target.value)}
                suffix={isFindEntryMode ? <SearchOutlined style={{ fontSize: 10, color: "#808080" }} /> : undefined}
                style={{ borderRadius: "2px", background: isFindEntryMode ? "#fffde7" : undefined }}
              />
            </FieldRow>
            <FieldRow label="FQ Status" labelW="w-20">
              <SmallInput
                value={isFindEntryMode ? getFindDisplayValue("quoteSent") : quoteForm.quoteSent}
                onChange={(e) => isFindEntryMode ? setFindCriteria((p) => ({ ...p, quoteSent: e.target.value })) : onQuoteFormChange("quoteSent", e.target.value)}
                placeholder={isFindEntryMode ? "Search FQ status..." : ""}
                className="text-[9px] text-gray-500 bg-white h-5"
                suffix={isFindEntryMode ? <SearchOutlined style={{ fontSize: 10, color: "#808080" }} /> : undefined}
                style={{ borderRadius: "2px", background: isFindEntryMode ? "#fffde7" : undefined }}
              />
            </FieldRow>
          </div>

          <div className="col-span-4 pt-2">
            <Button
              type="primary"
              className="font-bold text-[14px] mt-4"
              style={{
                backgroundColor: "#ffcc00",
                color: "#5a3e00",
                border: "1px solid #000000",
                borderRadius: "0px",
                boxShadow: "inset -2px -2px 5px rgba(0,0,0,0.25), inset 1px 1px 3px rgba(255,255,255,0.4)",
                letterSpacing: "0px",
                color: "#000000",
                height: "34px",
                width: "100px",
                display: "block",
                margin: "16px auto 0",
              }}
              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#e6b800"; }}
              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "#ffcc00"; }}
              onClick={onSendFQ}
            >
              Send FQ
            </Button>
          </div>

          <div className="col-span-12 flex items-start gap-8">
            <div className="pt-2 ml-8">
              <img
                src={settingPlus}
                alt="tools"
                className="w-7 h-7 opacity-80 cursor-pointer hover:scale-105 transition-transform"
                onClick={onAddRow}
              />
            </div>
            <div className="flex-1 space-y-1">
              {[
                { n: 1, label: "First Follow up", handler: onFirstFollowUp },
                { n: 2, label: "Second Follow up", handler: onSecondFollowUp },
                { n: 3, label: "Final Follow up", handler: onFinalFollowUp },
              ].map((item) => (
                <div key={item.n} className="flex items-center gap-1">
                  <div
                    className="text-black text-[10px] w-8 h-5 flex items-center justify-center font-bold cursor-pointer transition-colors"
                    style={{ backgroundColor: "#DCDCDC", border: "1px solid #808080", borderRadius: "2px", boxShadow: "1px 1px 2px rgba(0,0,0,0.25)" }}
                    onClick={item.handler}
                    onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.backgroundColor = "#D0D0D0"; }}
                    onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.backgroundColor = "#C0C0C0"; }}
                    title={`Send ${item.label} email`}
                  >
                    @ {item.n}
                  </div>
                  <DatePicker
                    size="small"
                    className="!text-[7px] h-5 rounded-none border-gray-300"
                    style={{ borderRadius: "2px", width: "160px" }}
                    format="MM/DD/YYYY hh:mm:ss A"
                    showTime
                    placeholder="Select date"
                    value={
                      item.n === 1
                        ? quoteForm.firstFollowUpDate
                          ? dayjs(quoteForm.firstFollowUpDate)
                          : null
                        : item.n === 2
                          ? quoteForm.secondFollowUpDate
                            ? dayjs(quoteForm.secondFollowUpDate)
                            : null
                          : quoteForm.finalFollowUpDate
                            ? dayjs(quoteForm.finalFollowUpDate)
                            : null
                    }
                    onChange={(_, dateString) =>
                      onQuoteFormChange(
                        item.n === 1
                          ? "firstFollowUpDate"
                          : item.n === 2
                            ? "secondFollowUpDate"
                            : "finalFollowUpDate",
                        dateString,
                      )
                    }
                  />
                  <span className="text-[10px] whitespace-nowrap">
                    {item.label}
                  </span>
                </div>
              ))}
            </div>
          </div>

          <div className="col-span-12 flex items-center gap-1 mt-1 flex-wrap">
            <Button
              type="primary"
              className="h-6 w-24 text-[9px] font-bold px-1 flex-shrink-0"
              style={{
                backgroundColor: "#DCDCDC",
                color: "#000000",
                border: "1px solid #808080",
                borderRadius: "2px",
                boxShadow: "1px 1px 2px rgba(0,0,0,0.25)",
              }}
              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#D0D0D0"; }}
              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "#C0C0C0"; }}
              onClick={onOutOfStock}
            >
              @Out of Stock
            </Button>
            <DatePicker
              size="small"
              className="h-6 border-gray-500 !text-[10px] flex-shrink-0"
              style={{ width: "140px", borderRadius: "2px" }}
              placeholder="Select date"
              value={
                quoteForm.emailOutOfStock
                  ? dayjs(quoteForm.emailOutOfStock)
                  : null
              }
              format="MM/DD/YYYY"
              onChange={(_, dateString) =>
                onQuoteFormChange("emailOutOfStock", dateString)
              }
            />
            <span className="text-[10px] whitespace-nowrap">
              Send out if No Product
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

const ContactTab = ({
  quoteForm,
  onQuoteFormChange,
}: {
  quoteForm: any;
  onQuoteFormChange: (field: string, value: any) => void;
}) => {
  return (
    <div className="grid grid-cols-12 gap-x-6">
      <div className="col-span-6">
        <FieldRow label="Name:">
          <SmallInput
            value={quoteForm.contactName}
            onChange={(e) => onQuoteFormChange("contactName", e.target.value)}
          />
        </FieldRow>
        <FieldRow label="Email:">
          <SmallInput
            value={quoteForm.contactEmail}
            onChange={(e) => onQuoteFormChange("contactEmail", e.target.value)}
          />
        </FieldRow>
        <FieldRow label="Phone 1:">
          <SmallInput
            value={quoteForm.phone1}
            onChange={(e) => onQuoteFormChange("phone1", e.target.value)}
          />
        </FieldRow>
        <FieldRow label="Phone 2:">
          <SmallInput
            value={quoteForm.phone2}
            onChange={(e) => onQuoteFormChange("phone2", e.target.value)}
          />
        </FieldRow>
        <FieldRow label="Mobile:">
          <SmallInput
            value={quoteForm.mobile}
            onChange={(e) => onQuoteFormChange("mobile", e.target.value)}
          />
        </FieldRow>
        <FieldRow label="Fax:">
          <SmallInput
            value={quoteForm.fax}
            onChange={(e) => onQuoteFormChange("fax", e.target.value)}
          />
        </FieldRow>
      </div>

      <div className="col-span-6">
        <div className="flex items-start gap-4">
          <div className="flex-1">
            <FieldRow label="Notes:" labelW="w-[70px]">
              <Input.TextArea
                rows={4}
                className="text-xs"
                style={{ resize: "none" }}
              />
            </FieldRow>
          </div>
          <div className="w-[90px]">
            <SmallInput />
          </div>
        </div>

        <div className="mt-3">
          <FieldRow label="OfficeID" labelW="w-[70px]">
            <SmallInput className="bg-yellow-100" />
          </FieldRow>
        </div>
      </div>
    </div>
  );
};

const OfficeTab = ({ quoteForm }: { quoteForm: any }) => {
  return (
    <div className="grid grid-cols-12 gap-x-8">
      <div className="col-span-5">
        <FieldRow label="Name:">
          <SmallInput />
        </FieldRow>
        <FieldRow label="Email:">
          <SmallInput />
        </FieldRow>
        <FieldRow label="Phone 1:">
          <SmallInput />
        </FieldRow>
        <FieldRow label="Phone 2:">
          <SmallInput />
        </FieldRow>
        <FieldRow label="Fax 1:">
          <SmallInput />
        </FieldRow>
        <FieldRow label="Fax 2:">
          <SmallInput />
        </FieldRow>
      </div>

      <div className="col-span-7">
        <div className="grid grid-cols-12 gap-x-4">
          <div className="col-span-9">
            <FieldRow label="Company:" labelW="w-[90px]">
              <SmallInput value={quoteForm.companyName} readOnly />
            </FieldRow>
          </div>
          <div className="col-span-3 flex justify-end">
            <SmallInput className="w-full" />
          </div>

          <div className="col-span-6">
            <FieldRow label="Country:" labelW="w-[90px]">
              <SmallInput />
            </FieldRow>
          </div>
          <div className="col-span-6">
            <FieldRow label="State:" labelW="w-[70px]">
              <SmallInput />
            </FieldRow>
          </div>

          <div className="col-span-6">
            <FieldRow label="PO:" labelW="w-[90px]">
              <SmallInput />
            </FieldRow>
          </div>
          <div className="col-span-6">
            <FieldRow label="Zip:" labelW="w-[70px]">
              <SmallInput />
            </FieldRow>
          </div>

          <div className="col-span-12">
            <FieldRow label="Address 1:" labelW="w-[90px]">
              <SmallInput />
            </FieldRow>
          </div>
          <div className="col-span-12">
            <FieldRow label="Address 2:" labelW="w-[90px]">
              <SmallInput />
            </FieldRow>
          </div>
          <div className="col-span-12">
            <FieldRow label="Shipping:" labelW="w-[90px]">
              <SmallInput />
            </FieldRow>
          </div>
        </div>
      </div>
    </div>
  );
};

const CompanyTab = () => {
  return (
    <div className="grid grid-cols-12">
      <div className="col-span-5">
        <FieldRow label="Name:">
          <SmallInput />
        </FieldRow>
        <FieldRow label="URL:">
          <SmallInput />
        </FieldRow>
        <FieldRow label="Type:">
          <SmallInput />
        </FieldRow>
      </div>
    </div>
  );
};

const DocumentTab = () => {
  return (
    <div className="grid grid-cols-12 gap-x-8">
      <div className="col-span-4">
        <div className="text-[13px] font-semibold mb-2">
          <div className="flex items-center gap-2">
            <input type="radio" name="doc" /> CC Authorization Form
          </div>
          <div className="flex items-center gap-2">
            <input type="radio" name="doc" /> Credit Application
          </div>
          <div className="flex items-center gap-2">
            <input type="radio" name="doc" /> Wire Transfer Info
          </div>
        </div>
      </div>
      <div className="col-span-8 flex items-start gap-6">
        <Button
          type="primary"
          size="small"
          className="border bg-[#C0C0C0] text-black border-[#808080] px-6"
        >
          Send
        </Button>
        <Button
          type="primary"
          size="small"
          className="border bg-[#C0C0C0] text-black border-[#808080] px-6"
        >
          Send Form
        </Button>
        <Button
          type="primary"
          size="small"
          className="border bg-[#C0C0C0] text-black border-[#808080] px-6"
        >
          Manage
        </Button>
      </div>
    </div>
  );
};

const WebTab = ({
  quoteForm,
  onQuoteFormChange,
}: {
  quoteForm: any;
  onQuoteFormChange: (field: string, value: any) => void;
}) => {
  return (
    <div className="grid grid-cols-12 gap-x-6">
      <div className="col-span-8 space-y-2">
        <div className="flex items-center gap-2">
          <span className="text-[13px] font-semibold">OpenTracker (OT):</span>
          <SmallInput className="w-[240px]" />
          <SmallInput className="w-[70px]" defaultValue="OT" />
          <SmallInput className="w-[120px]" defaultValue="OT ID:" />
          <SmallInput className="w-[90px]" defaultValue="Stream" />
          <SmallInput
            className="w-[120px] bg-red-100"
            defaultValue="1/21/2026"
          />
        </div>

        <div className="grid grid-cols-12 gap-x-4">
          <div className="col-span-6">
            <FieldRow label="IP:" labelW="w-[60px]">
              <SmallInput
                value={quoteForm.ip || ""}
                placeholder="Enter IP"
                onChange={(e) => onQuoteFormChange("ip", e.target.value)}
              />
            </FieldRow>
            <FieldRow label="Visitor:" labelW="w-[60px]">
              <div className="flex items-center gap-3 text-xs">
                <label className="flex items-center gap-1">
                  <input type="radio" name="visitor" /> Organic
                </label>
                <label className="flex items-center gap-1">
                  <input type="radio" name="visitor" /> Bookmark
                </label>
              </div>
            </FieldRow>
            <FieldRow label="Type:" labelW="w-[60px]">
              <div className="flex items-center gap-3 text-xs">
                <label className="flex items-center gap-1 mr-4">
                  <input type="radio" name="type" /> PPC
                </label>
                <label className="flex items-center gap-1 ml-1">
                  <input type="radio" name="type" /> Unknown
                </label>
              </div>
            </FieldRow>
            <FieldRow label="Keyword:" labelW="w-[60px]">
              <SmallInput />
            </FieldRow>
            <FieldRow label="Referrer:" labelW="w-[60px]">
              <SmallInput />
            </FieldRow>
          </div>

          <div className="col-span-6">
            <FieldRow label="PPC:" labelW="w-[60px]">
              <div className="flex items-center gap-3 text-xs">
                <label className="flex items-center gap-1">
                  <input type="radio" name="src" /> Google
                </label>
                <label className="flex items-center gap-1">
                  <input type="radio" name="src" /> Yahoo
                </label>
                <label className="flex items-center gap-1">
                  <input type="radio" name="src" /> MSN
                </label>
              </div>
            </FieldRow>
            <FieldRow label="Campaign:" labelW="w-[80px]">
              <SmallInput />
            </FieldRow>
            <FieldRow label="AdGroup:" labelW="w-[80px]">
              <SmallInput />
            </FieldRow>
            <FieldRow label="Keyword:" labelW="w-[80px]">
              <SmallInput />
            </FieldRow>
          </div>
        </div>
      </div>

      <div className="col-span-4">
        <div className="flex justify-end mb-2">
          <Button size="small" className="border border-gray-400 font-semibold">
            Google Ads Diagnostic Tool
          </Button>
        </div>
        <FieldRow label="Website:" labelW="w-[80px]">
          <SmallInput />
        </FieldRow>
        <FieldRow label="Comment:" labelW="w-[80px]">
          <Input.TextArea
            rows={5}
            className="text-xs"
            style={{ resize: "none" }}
          />
        </FieldRow>
      </div>
    </div>
  );
};

const EditTab = ({
  quoteForm,
  onQuoteFormChange,
  representativeOptions,
}: {
  quoteForm: any;
  onQuoteFormChange: (field: string, value: any) => void;
  representativeOptions: RepresentativeMasterItem[];
}) => {
  const [createdPickerOpen, setCreatedPickerOpen] = React.useState(false);

  return (
    <div className="grid grid-cols-12 gap-x-6">
      <div className="col-span-6">
        <FieldRow label="Created:" labelW="w-[90px]">
          <DatePicker
            className="h-5 w-full text-[10px] rounded-md bg-[#f4dbbc]"
            size="small"
            showTime={{ format: "hh:mm A" }}
            open={createdPickerOpen}
            onOpenChange={(open) => setCreatedPickerOpen(open)}
            popupClassName="created-datepicker-popup"
            value={
              toDayjsValue(quoteForm.createdDate) || toDayjsValue(getNowDateTime())
            }
            format="MM/DD/YYYY hh:mm A"
            onSelect={(date) => {
              if (date) {
                onQuoteFormChange("createdDate", date.format(DATE_TIME_FORMAT));
              }
            }}
            onChange={(date, dateString) => {
              onQuoteFormChange(
                "createdDate",
                formatDateTimeValue(dateString, getNowDateTime()),
              );
              setCreatedPickerOpen(false);
            }}
            onBlur={(e) => {
              const typed = (e.target as HTMLInputElement).value;
              if (!typed) return;
              const formatted = formatDateTimeValue(typed, "");
              if (formatted) {
                onQuoteFormChange("createdDate", formatted);
                setCreatedPickerOpen(false);
              }
            }}
          />
        </FieldRow>

        <FieldRow label="Assigned Rep:" labelW="w-[120px]">
          <Select
            size="small"
            className="w-full"
            value={quoteForm.assignedEmail || undefined}
            placeholder="Select representative"
            showSearch
            allowClear
            filterOption={(input, option) => String(option?.label ?? "").toLowerCase().startsWith(input.toLowerCase())}
            optionLabelProp="value"
            options={[...representativeOptions]
              .sort((a, b) => (a.name || "").localeCompare(b.name || ""))
              .map((rep) => ({
                value: rep.email || rep.name,
                label: rep.name,
              }))}
            onChange={(value) => {
              if (!value) {
                onQuoteFormChange("assignedEmail", "");
                onQuoteFormChange("representativeName", "");
                return;
              }
              const rep = representativeOptions.find(
                (r) => r.email === value || r.name === value
              );
              onQuoteFormChange("assignedEmail", rep?.email || "");
              onQuoteFormChange("representativeName", rep?.name || "");
            }}
          />
        </FieldRow>

        <FieldRow label="Discount Name:" labelW="w-[120px]">
          <SmallInput
            defaultValue="Trade-in Discount"
            className="bg-yellow-100"
          />
        </FieldRow>
      </div>

      <div className="col-span-6">
        <FieldRow label="Sub Email:" labelW="w-[90px]">
          <Select
            size="small"
            className="w-full"
            options={[{ value: "sub@email.com" }]}
          />
        </FieldRow>
      </div>
    </div>
  );
};

export default CreateQuote;
